(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94f8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94f8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l8zW7", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $f636388f675f9f7d$export$6503ec6e8aabbaf; }, function (v) { return $f636388f675f9f7d$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $f636388f675f9f7d$export$f7ad0328861e2f03; }, function (v) { return $f636388f675f9f7d$export$f7ad0328861e2f03 = v; });
var $f636388f675f9f7d$export$6503ec6e8aabbaf;
var $f636388f675f9f7d$export$f7ad0328861e2f03;
"use strict";
var $f636388f675f9f7d$var$mapping = new Map();
function $f636388f675f9f7d$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f636388f675f9f7d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f636388f675f9f7d$var$resolve(id) {
    var resolved = $f636388f675f9f7d$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f636388f675f9f7d$export$6503ec6e8aabbaf = $f636388f675f9f7d$var$register;
$f636388f675f9f7d$export$f7ad0328861e2f03 = $f636388f675f9f7d$var$resolve;

});

parcelRegister("40s4O", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $2eacf0f5d766e5da$export$bdfd709ae4826697; }, function (v) { return $2eacf0f5d766e5da$export$bdfd709ae4826697 = v; });
var $2eacf0f5d766e5da$export$bdfd709ae4826697;
var $2eacf0f5d766e5da$export$c9e73fbda7da57b6;
var $2eacf0f5d766e5da$export$5a759dc7a1cfb72a;
"use strict";
var $2eacf0f5d766e5da$var$bundleURL = {};
function $2eacf0f5d766e5da$var$getBundleURLCached(id) {
    var value = $2eacf0f5d766e5da$var$bundleURL[id];
    if (!value) {
        value = $2eacf0f5d766e5da$var$getBundleURL();
        $2eacf0f5d766e5da$var$bundleURL[id] = value;
    }
    return value;
}
function $2eacf0f5d766e5da$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $2eacf0f5d766e5da$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $2eacf0f5d766e5da$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $2eacf0f5d766e5da$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$2eacf0f5d766e5da$export$bdfd709ae4826697 = $2eacf0f5d766e5da$var$getBundleURLCached;
$2eacf0f5d766e5da$export$c9e73fbda7da57b6 = $2eacf0f5d766e5da$var$getBaseURL;
$2eacf0f5d766e5da$export$5a759dc7a1cfb72a = $2eacf0f5d766e5da$var$getOrigin;

});

parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $e8dfc29dafb3bbd7$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function() {};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRegister("bmgOM", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $4FDWC = parcelRequire("4FDWC");

var $a8i8g = parcelRequire("a8i8g");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $4FDWC.isBrowserBundle)() && Object.prototype.toString.call(typeof $a8i8g !== "undefined" ? $a8i8g : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("4FDWC", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $3669f9e19c015e84$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $3669f9e19c015e84$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $3669f9e19c015e84$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $3669f9e19c015e84$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("a8i8g", function(module, exports) {
// shim for using process in browser
var $7608b7726638efe3$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7608b7726638efe3$var$cachedSetTimeout;
var $7608b7726638efe3$var$cachedClearTimeout;
function $7608b7726638efe3$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $7608b7726638efe3$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        else $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    } catch (e) {
        $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        else $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    } catch (e) {
        $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    }
})();
function $7608b7726638efe3$var$runTimeout(fun) {
    if ($7608b7726638efe3$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedSetTimeout === $7608b7726638efe3$var$defaultSetTimout || !$7608b7726638efe3$var$cachedSetTimeout) && setTimeout) {
        $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7608b7726638efe3$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7608b7726638efe3$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7608b7726638efe3$var$runClearTimeout(marker) {
    if ($7608b7726638efe3$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedClearTimeout === $7608b7726638efe3$var$defaultClearTimeout || !$7608b7726638efe3$var$cachedClearTimeout) && clearTimeout) {
        $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7608b7726638efe3$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7608b7726638efe3$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7608b7726638efe3$var$queue = [];
var $7608b7726638efe3$var$draining = false;
var $7608b7726638efe3$var$currentQueue;
var $7608b7726638efe3$var$queueIndex = -1;
function $7608b7726638efe3$var$cleanUpNextTick() {
    if (!$7608b7726638efe3$var$draining || !$7608b7726638efe3$var$currentQueue) return;
    $7608b7726638efe3$var$draining = false;
    if ($7608b7726638efe3$var$currentQueue.length) $7608b7726638efe3$var$queue = $7608b7726638efe3$var$currentQueue.concat($7608b7726638efe3$var$queue);
    else $7608b7726638efe3$var$queueIndex = -1;
    if ($7608b7726638efe3$var$queue.length) $7608b7726638efe3$var$drainQueue();
}
function $7608b7726638efe3$var$drainQueue() {
    if ($7608b7726638efe3$var$draining) return;
    var timeout = $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$cleanUpNextTick);
    $7608b7726638efe3$var$draining = true;
    var len = $7608b7726638efe3$var$queue.length;
    while(len){
        $7608b7726638efe3$var$currentQueue = $7608b7726638efe3$var$queue;
        $7608b7726638efe3$var$queue = [];
        while(++$7608b7726638efe3$var$queueIndex < len)if ($7608b7726638efe3$var$currentQueue) $7608b7726638efe3$var$currentQueue[$7608b7726638efe3$var$queueIndex].run();
        $7608b7726638efe3$var$queueIndex = -1;
        len = $7608b7726638efe3$var$queue.length;
    }
    $7608b7726638efe3$var$currentQueue = null;
    $7608b7726638efe3$var$draining = false;
    $7608b7726638efe3$var$runClearTimeout(timeout);
}
$7608b7726638efe3$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7608b7726638efe3$var$queue.push(new $7608b7726638efe3$var$Item(fun, args));
    if ($7608b7726638efe3$var$queue.length === 1 && !$7608b7726638efe3$var$draining) $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$drainQueue);
};
// v8 likes predictible objects
function $7608b7726638efe3$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7608b7726638efe3$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7608b7726638efe3$var$process.title = "browser";
$7608b7726638efe3$var$process.browser = true;
$7608b7726638efe3$var$process.env = {};
$7608b7726638efe3$var$process.argv = [];
$7608b7726638efe3$var$process.version = ""; // empty string to avoid regexp issues
$7608b7726638efe3$var$process.versions = {};
function $7608b7726638efe3$var$noop() {}
$7608b7726638efe3$var$process.on = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.addListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.once = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.off = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeAllListeners = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.emit = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependOnceListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.listeners = function(name) {
    return [];
};
$7608b7726638efe3$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$7608b7726638efe3$var$process.cwd = function() {
    return "/";
};
$7608b7726638efe3$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$7608b7726638efe3$var$process.umask = function() {
    return 0;
};

});


parcelRegister("hFtc0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cdcce91081d78ae7$export$2b8d127b894957b9; }, function (v) { return $cdcce91081d78ae7$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cdcce91081d78ae7$export$cea3a54a6425200c; }, function (v) { return $cdcce91081d78ae7$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cdcce91081d78ae7$export$a7c73072b1a182ae; }, function (v) { return $cdcce91081d78ae7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cdcce91081d78ae7$export$9f27bc3417b4524d; }, function (v) { return $cdcce91081d78ae7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cdcce91081d78ae7$export$db77ccec0bb4ccac; }, function (v) { return $cdcce91081d78ae7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35; }, function (v) { return $cdcce91081d78ae7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cdcce91081d78ae7$export$ffb0004e005737fa; }, function (v) { return $cdcce91081d78ae7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cdcce91081d78ae7$export$b624eff549462981; }, function (v) { return $cdcce91081d78ae7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cdcce91081d78ae7$export$7897aa7841a5380c; }, function (v) { return $cdcce91081d78ae7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cdcce91081d78ae7$export$602eac185826482c; }, function (v) { return $cdcce91081d78ae7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cdcce91081d78ae7$export$e2c29f18771995cb; }, function (v) { return $cdcce91081d78ae7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cdcce91081d78ae7$export$5f8d39834fd61797; }, function (v) { return $cdcce91081d78ae7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cdcce91081d78ae7$export$74bf444e3cd11ea5; }, function (v) { return $cdcce91081d78ae7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cdcce91081d78ae7$export$92387174baf9b227; }, function (v) { return $cdcce91081d78ae7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cdcce91081d78ae7$export$ec112efeb987d9c6; }, function (v) { return $cdcce91081d78ae7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cdcce91081d78ae7$export$b706b080d889d2c9; }, function (v) { return $cdcce91081d78ae7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cdcce91081d78ae7$export$5be5a87408f70ddc; }, function (v) { return $cdcce91081d78ae7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d; }, function (v) { return $cdcce91081d78ae7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cdcce91081d78ae7$export$455c2e768291efa6; }, function (v) { return $cdcce91081d78ae7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cdcce91081d78ae7$export$9522e17588c12572; }, function (v) { return $cdcce91081d78ae7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cdcce91081d78ae7$export$2110ac352bb060b9; }, function (v) { return $cdcce91081d78ae7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cdcce91081d78ae7$export$56885ab8b9c456ab; }, function (v) { return $cdcce91081d78ae7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cdcce91081d78ae7$export$d927fcb6adf8f9de; }, function (v) { return $cdcce91081d78ae7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cdcce91081d78ae7$export$b82d16f27459e05a; }, function (v) { return $cdcce91081d78ae7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cdcce91081d78ae7$export$522c17b4f5e123e8; }, function (v) { return $cdcce91081d78ae7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6; }, function (v) { return $cdcce91081d78ae7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cdcce91081d78ae7$export$9b621391a187a31a; }, function (v) { return $cdcce91081d78ae7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cdcce91081d78ae7$export$f5bbd400c2f4426f; }, function (v) { return $cdcce91081d78ae7$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cdcce91081d78ae7$export$2b8d127b894957b9;
var $cdcce91081d78ae7$export$cea3a54a6425200c;
var $cdcce91081d78ae7$export$a7c73072b1a182ae;
var $cdcce91081d78ae7$export$9f27bc3417b4524d;
var $cdcce91081d78ae7$export$db77ccec0bb4ccac;
var $cdcce91081d78ae7$export$8392c0c9d3dcbd35;
var $cdcce91081d78ae7$export$ffb0004e005737fa;
var $cdcce91081d78ae7$export$b624eff549462981;
var $cdcce91081d78ae7$export$7897aa7841a5380c;
var $cdcce91081d78ae7$export$602eac185826482c;
var $cdcce91081d78ae7$export$e2c29f18771995cb;
var $cdcce91081d78ae7$export$5f8d39834fd61797;
var $cdcce91081d78ae7$export$74bf444e3cd11ea5;
var $cdcce91081d78ae7$export$92387174baf9b227;
var $cdcce91081d78ae7$export$ec112efeb987d9c6;
var $cdcce91081d78ae7$export$b706b080d889d2c9;
var $cdcce91081d78ae7$export$5be5a87408f70ddc;
var $cdcce91081d78ae7$export$45a5e7f76e0caa8d;
var $cdcce91081d78ae7$export$455c2e768291efa6;
var $cdcce91081d78ae7$export$9522e17588c12572;
var $cdcce91081d78ae7$export$2110ac352bb060b9;
var $cdcce91081d78ae7$export$56885ab8b9c456ab;
var $cdcce91081d78ae7$export$d927fcb6adf8f9de;
var $cdcce91081d78ae7$export$b82d16f27459e05a;
var $cdcce91081d78ae7$export$522c17b4f5e123e8;
var $cdcce91081d78ae7$export$1aabd8a0274ecfd6;
var $cdcce91081d78ae7$export$9b621391a187a31a;
var $cdcce91081d78ae7$export$f5bbd400c2f4426f;
"use strict";
var $cdcce91081d78ae7$var$b = "function" === typeof Symbol && Symbol.for, $cdcce91081d78ae7$var$c = $cdcce91081d78ae7$var$b ? Symbol.for("react.element") : 60103, $cdcce91081d78ae7$var$d = $cdcce91081d78ae7$var$b ? Symbol.for("react.portal") : 60106, $cdcce91081d78ae7$var$e = $cdcce91081d78ae7$var$b ? Symbol.for("react.fragment") : 60107, $cdcce91081d78ae7$var$f = $cdcce91081d78ae7$var$b ? Symbol.for("react.strict_mode") : 60108, $cdcce91081d78ae7$var$g = $cdcce91081d78ae7$var$b ? Symbol.for("react.profiler") : 60114, $cdcce91081d78ae7$var$h = $cdcce91081d78ae7$var$b ? Symbol.for("react.provider") : 60109, $cdcce91081d78ae7$var$k = $cdcce91081d78ae7$var$b ? Symbol.for("react.context") : 60110, $cdcce91081d78ae7$var$l = $cdcce91081d78ae7$var$b ? Symbol.for("react.async_mode") : 60111, $cdcce91081d78ae7$var$m = $cdcce91081d78ae7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cdcce91081d78ae7$var$n = $cdcce91081d78ae7$var$b ? Symbol.for("react.forward_ref") : 60112, $cdcce91081d78ae7$var$p = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense") : 60113, $cdcce91081d78ae7$var$q = $cdcce91081d78ae7$var$b ? Symbol.for("react.suspense_list") : 60120, $cdcce91081d78ae7$var$r = $cdcce91081d78ae7$var$b ? Symbol.for("react.memo") : 60115, $cdcce91081d78ae7$var$t = $cdcce91081d78ae7$var$b ? Symbol.for("react.lazy") : 60116, $cdcce91081d78ae7$var$v = $cdcce91081d78ae7$var$b ? Symbol.for("react.block") : 60121, $cdcce91081d78ae7$var$w = $cdcce91081d78ae7$var$b ? Symbol.for("react.fundamental") : 60117, $cdcce91081d78ae7$var$x = $cdcce91081d78ae7$var$b ? Symbol.for("react.responder") : 60118, $cdcce91081d78ae7$var$y = $cdcce91081d78ae7$var$b ? Symbol.for("react.scope") : 60119;
function $cdcce91081d78ae7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cdcce91081d78ae7$var$c:
                switch(a = a.type, a){
                    case $cdcce91081d78ae7$var$l:
                    case $cdcce91081d78ae7$var$m:
                    case $cdcce91081d78ae7$var$e:
                    case $cdcce91081d78ae7$var$g:
                    case $cdcce91081d78ae7$var$f:
                    case $cdcce91081d78ae7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cdcce91081d78ae7$var$k:
                            case $cdcce91081d78ae7$var$n:
                            case $cdcce91081d78ae7$var$t:
                            case $cdcce91081d78ae7$var$r:
                            case $cdcce91081d78ae7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cdcce91081d78ae7$var$d:
                return u;
        }
    }
}
function $cdcce91081d78ae7$var$A(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$m;
}
$cdcce91081d78ae7$export$2b8d127b894957b9 = $cdcce91081d78ae7$var$l;
$cdcce91081d78ae7$export$cea3a54a6425200c = $cdcce91081d78ae7$var$m;
$cdcce91081d78ae7$export$a7c73072b1a182ae = $cdcce91081d78ae7$var$k;
$cdcce91081d78ae7$export$9f27bc3417b4524d = $cdcce91081d78ae7$var$h;
$cdcce91081d78ae7$export$db77ccec0bb4ccac = $cdcce91081d78ae7$var$c;
$cdcce91081d78ae7$export$8392c0c9d3dcbd35 = $cdcce91081d78ae7$var$n;
$cdcce91081d78ae7$export$ffb0004e005737fa = $cdcce91081d78ae7$var$e;
$cdcce91081d78ae7$export$b624eff549462981 = $cdcce91081d78ae7$var$t;
$cdcce91081d78ae7$export$7897aa7841a5380c = $cdcce91081d78ae7$var$r;
$cdcce91081d78ae7$export$602eac185826482c = $cdcce91081d78ae7$var$d;
$cdcce91081d78ae7$export$e2c29f18771995cb = $cdcce91081d78ae7$var$g;
$cdcce91081d78ae7$export$5f8d39834fd61797 = $cdcce91081d78ae7$var$f;
$cdcce91081d78ae7$export$74bf444e3cd11ea5 = $cdcce91081d78ae7$var$p;
$cdcce91081d78ae7$export$92387174baf9b227 = function(a) {
    return $cdcce91081d78ae7$var$A(a) || $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$l;
};
$cdcce91081d78ae7$export$ec112efeb987d9c6 = $cdcce91081d78ae7$var$A;
$cdcce91081d78ae7$export$b706b080d889d2c9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$k;
};
$cdcce91081d78ae7$export$5be5a87408f70ddc = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$h;
};
$cdcce91081d78ae7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cdcce91081d78ae7$var$c;
};
$cdcce91081d78ae7$export$455c2e768291efa6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$n;
};
$cdcce91081d78ae7$export$9522e17588c12572 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$e;
};
$cdcce91081d78ae7$export$2110ac352bb060b9 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$t;
};
$cdcce91081d78ae7$export$56885ab8b9c456ab = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$r;
};
$cdcce91081d78ae7$export$d927fcb6adf8f9de = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$d;
};
$cdcce91081d78ae7$export$b82d16f27459e05a = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$g;
};
$cdcce91081d78ae7$export$522c17b4f5e123e8 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$f;
};
$cdcce91081d78ae7$export$1aabd8a0274ecfd6 = function(a) {
    return $cdcce91081d78ae7$var$z(a) === $cdcce91081d78ae7$var$p;
};
$cdcce91081d78ae7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cdcce91081d78ae7$var$e || a === $cdcce91081d78ae7$var$m || a === $cdcce91081d78ae7$var$g || a === $cdcce91081d78ae7$var$f || a === $cdcce91081d78ae7$var$p || a === $cdcce91081d78ae7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cdcce91081d78ae7$var$t || a.$$typeof === $cdcce91081d78ae7$var$r || a.$$typeof === $cdcce91081d78ae7$var$h || a.$$typeof === $cdcce91081d78ae7$var$k || a.$$typeof === $cdcce91081d78ae7$var$n || a.$$typeof === $cdcce91081d78ae7$var$w || a.$$typeof === $cdcce91081d78ae7$var$x || a.$$typeof === $cdcce91081d78ae7$var$y || a.$$typeof === $cdcce91081d78ae7$var$v);
};
$cdcce91081d78ae7$export$f5bbd400c2f4426f = $cdcce91081d78ae7$var$z;

});

parcelRegister("eDGma", function(module, exports) {


module.exports = (parcelRequire("8xQ7e"))((parcelRequire("l8zW7")).resolve("1ABzL")).then(()=>parcelRequire("cNIke"));

});
parcelRegister("8xQ7e", function(module, exports) {
"use strict";

var $erm87 = parcelRequire("erm87");
module.exports = $erm87(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("erm87", function(module, exports) {
"use strict";
var $a834c0da6d99fec1$var$cachedBundles = {};
var $a834c0da6d99fec1$var$cachedPreloads = {};
var $a834c0da6d99fec1$var$cachedPrefetches = {};
function $a834c0da6d99fec1$var$getCache(type) {
    switch(type){
        case "preload":
            return $a834c0da6d99fec1$var$cachedPreloads;
        case "prefetch":
            return $a834c0da6d99fec1$var$cachedPrefetches;
        default:
            return $a834c0da6d99fec1$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a834c0da6d99fec1$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $074f00b804988991$exports = {};


(parcelRequire("l8zW7")).register((parcelRequire("40s4O")).getBundleURL("7eYhn"), JSON.parse('["7eYhn","index.js","1ABzL","web-vitals.4684528c.js","9uLDr","index.css"]'));

var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));



var $6cds3 = parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";
var $6d4849ee44552f5f$exports = {};
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;





var $6cds3 = parcelRequire("6cds3");


var $6cds3 = parcelRequire("6cds3");
"use strict";
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $4457f145f4fd6a49$var$toString } = Object.prototype;
const { getPrototypeOf: $4457f145f4fd6a49$var$getPrototypeOf } = Object;
const $4457f145f4fd6a49$var$kindOf = ((cache)=>(thing)=>{
        const str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4457f145f4fd6a49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4457f145f4fd6a49$var$kindOf(thing) === type;
};
const $4457f145f4fd6a49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4457f145f4fd6a49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4457f145f4fd6a49$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4457f145f4fd6a49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4457f145f4fd6a49$var$isPlainObject = (val)=>{
    if ($4457f145f4fd6a49$var$kindOf(val) !== "object") return false;
    const prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4457f145f4fd6a49$var$isStream = (val)=>$4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4457f145f4fd6a49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4457f145f4fd6a49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4457f145f4fd6a49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $4457f145f4fd6a49$var$isContextDefined = (context)=>!$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    const { caseless: caseless } = $4457f145f4fd6a49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4457f145f4fd6a49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4457f145f4fd6a49$var$forEach(b, (val, key)=>{
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4457f145f4fd6a49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4457f145f4fd6a49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4457f145f4fd6a49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4457f145f4fd6a49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4457f145f4fd6a49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4457f145f4fd6a49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest("HTMLFormElement");
const $4457f145f4fd6a49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4457f145f4fd6a49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest("RegExp");
const $4457f145f4fd6a49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4457f145f4fd6a49$var$freezeMethods = (obj)=>{
    $4457f145f4fd6a49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $4457f145f4fd6a49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4457f145f4fd6a49$var$noop = ()=>{};
const $4457f145f4fd6a49$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $4457f145f4fd6a49$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $4457f145f4fd6a49$var$DIGIT = "0123456789";
const $4457f145f4fd6a49$var$ALPHABET = {
    DIGIT: $4457f145f4fd6a49$var$DIGIT,
    ALPHA: $4457f145f4fd6a49$var$ALPHA,
    ALPHA_DIGIT: $4457f145f4fd6a49$var$ALPHA + $4457f145f4fd6a49$var$ALPHA.toUpperCase() + $4457f145f4fd6a49$var$DIGIT
};
const $4457f145f4fd6a49$var$generateString = (size = 16, alphabet = $4457f145f4fd6a49$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $4457f145f4fd6a49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest("AsyncFunction");
const $4457f145f4fd6a49$var$isThenable = (thing)=>thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
var $4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    ALPHABET: $4457f145f4fd6a49$var$ALPHABET,
    generateString: $4457f145f4fd6a49$var$generateString,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
const $ed5f7e2522a0b703$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;


// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
const $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    let buf = $c114c26e12685207$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    const buf = $c114c26e12685207$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        const len = $c114c26e12685207$var$checked(obj.length) | 0;
        const buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) buf = $c114c26e12685207$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf);
    else return $5a7d4ee62d502cb1$export$6100ba28696e12de(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$c114c26e12685207$var$Buffer.prototype.readBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$c114c26e12685207$var$Buffer.prototype.readBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $c114c26e12685207$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $c114c26e12685207$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $c114c26e12685207$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigUInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeBigInt64LE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$c114c26e12685207$var$Buffer.prototype.writeBigInt64BE = $c114c26e12685207$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $c114c26e12685207$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $47bf1c92b6d3ec4f$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $c114c26e12685207$var$errors = {};
function $c114c26e12685207$var$E(sym, getMessage, Base) {
    $c114c26e12685207$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$c114c26e12685207$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$c114c26e12685207$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$c114c26e12685207$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $c114c26e12685207$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $c114c26e12685207$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $c114c26e12685207$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $c114c26e12685207$var$checkBounds(buf, offset, byteLength) {
    $c114c26e12685207$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $c114c26e12685207$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $c114c26e12685207$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $c114c26e12685207$var$checkBounds(buf, offset, byteLength);
}
function $c114c26e12685207$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $c114c26e12685207$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $c114c26e12685207$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $c114c26e12685207$var$validateNumber(value, type);
        throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $c114c26e12685207$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $c114c26e12685207$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $5a7d4ee62d502cb1$export$d622b2ad8d90c771($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $c114c26e12685207$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $c114c26e12685207$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $c114c26e12685207$var$BufferBigIntNotDefined : fn;
}
function $c114c26e12685207$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $5dbdf283f7ef4044$require$Buffer = $c114c26e12685207$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
const $5dbdf283f7ef4044$var$predicates = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject((0, $4457f145f4fd6a49$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1b5ae82d1edb0249$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(value) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(params, this, options);
}
const $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $ca291930ae00924d$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;





"use strict";
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $23a6a9f2f50fe381$export$2e2bcd8739ae039);


"use strict";
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a084e346ccf1414e$export$2e2bcd8739ae039,
        FormData: $4d02f3c5e9d23987$export$2e2bcd8739ae039,
        Blob: $7320e56e0494b653$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $e7f6cfbce8ef57c2$exports = {};

$parcel$export($e7f6cfbce8ef57c2$exports, "hasBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c0bcc9250309d66; });
$parcel$export($e7f6cfbce8ef57c2$exports, "hasStandardBrowserWebWorkerEnv", function () { return $e7f6cfbce8ef57c2$export$c81692cf5af97dac; });
const $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e7f6cfbce8ef57c2$export$c0bcc9250309d66 = ((product)=>{
    return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e7f6cfbce8ef57c2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $7bb33b7264aaaf86$export$2e2bcd8739ae039 = {
    ...$e7f6cfbce8ef57c2$exports,
    ...(0, $933095d2c2007f0e$export$2e2bcd8739ae039)
};


"use strict";
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(data, new (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).isNode && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(formData) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f671d6c34fc96548$var$defaults = {
    transitional: (0, $796c18463ea25502$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $a91febb88049dece$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBuffer(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isStream(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFile(data) || (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $c6537084d1761b1c$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).from(e, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $97723c9940354b38$var$$internals = Symbol("internals");
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $97723c9940354b38$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    const accessorName = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $97723c9940354b38$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $993ca9e2d6767cd4$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $97723c9940354b38$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $97723c9940354b38$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $97723c9940354b38$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $97723c9940354b38$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$97723c9940354b38$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;


"use strict";
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $f671d6c34fc96548$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).inherits($844e24f044f60b67$var$CanceledError, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;







"use strict";
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $de0137e96012432b$export$2e2bcd8739ae039)(requestedURL)) return (0, $4226547004fa4063$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;


"use strict";
function $089238041fc30567$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $3fe2722b85f27cc8$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $b1fb368c37c1823a$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Request aborted", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Network Error", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $796c18463ea25502$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $2d50534f56617a3d$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $8292dca2fe19e2c0$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $089238041fc30567$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $9a3acc13c385c3d9$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $7bb33b7264aaaf86$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $1b5ae82d1edb0249$export$2e2bcd8739ae039),
    xhr: (0, $089238041fc30567$export$2e2bcd8739ae039)
};
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach($f311d0388b14bc21$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f311d0388b14bc21$var$renderReason = (reason)=>`- ${reason}`;
const $f311d0388b14bc21$var$isResolvedHandle = (adapter)=>(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f311d0388b14bc21$var$renderReason).join("\n") : " " + $f311d0388b14bc21$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $f671d6c34fc96548$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f032fd5b915e863$export$2e2bcd8739ae039)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $2b2db412c73efddc$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $142febf2fa493ec7$var$headersToObject = (thing)=>thing instanceof (0, $97723c9940354b38$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(target) && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), true)
    };
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $0c953052fb93d857$export$a4ad2735b021c132 = "1.6.2";



"use strict";
const $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $0c953052fb93d857$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("options must be an object", (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};



"use strict";
const $d31ac3bc8d454bec$var$validators = (0, $153d7c57f809624c$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $d31ac3bc8d454bec$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)(),
            response: new (0, $ca291930ae00924d$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $153d7c57f809624c$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $d31ac3bc8d454bec$var$validators.function,
                serialize: $d31ac3bc8d454bec$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $97723c9940354b38$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1ba4fe270146b4e2$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $142febf2fa493ec7$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $55a6f18683d9f888$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $12c2c95c1ed3c980$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $4457f145f4fd6a49$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c9dbae5aa50ec7c7$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $844e24f044f60b67$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;






"use strict";
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(([key, value])=>{
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    const context = new (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $b4293b0eb4c07151$export$2e2bcd8739ae039)((0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $4457f145f4fd6a49$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $142febf2fa493ec7$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $f671d6c34fc96548$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $d31ac3bc8d454bec$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $844e24f044f60b67$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $c9dbae5aa50ec7c7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $5f032fd5b915e863$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $0c953052fb93d857$export$a4ad2735b021c132);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $5dbdf283f7ef4044$export$2e2bcd8739ae039);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $ed5f7e2522a0b703$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $cbed9dfdab194748$export$2e2bcd8739ae039);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $48132dea419dd2c0$export$2e2bcd8739ae039);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $142febf2fa493ec7$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $97723c9940354b38$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.formToJSON = (thing)=>(0, $a91febb88049dece$export$2e2bcd8739ae039)((0, $4457f145f4fd6a49$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $f311d0388b14bc21$export$2e2bcd8739ae039).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $9f6607e590634381$export$2e2bcd8739ae039);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $18d826a12788a23d$export$1c00760e9e5a4e95, AxiosError: $18d826a12788a23d$export$c1fbed17c2f6a328, CanceledError: $18d826a12788a23d$export$1ab0c6b20d94fa14, isCancel: $18d826a12788a23d$export$3b22524397b493c6, CancelToken: $18d826a12788a23d$export$fd08e3cb425f0d61, VERSION: $18d826a12788a23d$export$a4ad2735b021c132, all: $18d826a12788a23d$export$84bf76cd7afc7469, Cancel: $18d826a12788a23d$export$848c9b7ead0df967, isAxiosError: $18d826a12788a23d$export$fbafdbe06a5b5a9a, spread: $18d826a12788a23d$export$3ae0fd4797ed47c8, toFormData: $18d826a12788a23d$export$10ae0d317ea97f8b, AxiosHeaders: $18d826a12788a23d$export$4e7d6ff0f3e6520, HttpStatusCode: $18d826a12788a23d$export$a972f69c851492b3, formToJSON: $18d826a12788a23d$export$86d7c59254d6a2c9, getAdapter: $18d826a12788a23d$export$17ddc20a97d669e2, mergeConfig: $18d826a12788a23d$export$7ec1ebcfa9d8bd6a } = (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039);


const $84a973f6a13a2051$var$baseUrl = "https://onfarma-b2b.barikreativa.com/api/";
const $84a973f6a13a2051$export$3988ae62b71be9a3 = ({ path: path, params: params, local: local, headers: headers })=>{
    const _baseUrl = local ? "" : $84a973f6a13a2051$var$baseUrl;
    return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).get(_baseUrl + path, {
        headers: headers
    });
};
const $84a973f6a13a2051$export$299ba2dee77727e9 = ({ path: path, data: data })=>{
    return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).post($84a973f6a13a2051$var$baseUrl + path, data);
};
const $84a973f6a13a2051$export$327f7b26ebf455db = ({ path: path, data: data })=>{
    // console.log(baseUrl + path);
    // console.log(data)
    return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).put($84a973f6a13a2051$var$baseUrl + path, data);
};
const $84a973f6a13a2051$export$cd7f480d6b8286c3 = ({ path: path })=>{
    return (0, $c9a85f19e57c70f8$export$2e2bcd8739ae039).delete($84a973f6a13a2051$var$baseUrl + path);
};


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $8c000611b10ddc14$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $8c000611b10ddc14$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $8c000611b10ddc14$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $8c000611b10ddc14$var$isGlobalObj(window) || typeof self == "object" && $8c000611b10ddc14$var$isGlobalObj(self) || typeof $parcel$global == "object" && $8c000611b10ddc14$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $8c000611b10ddc14$export$256479dc0cea61c4() {
    return $8c000611b10ddc14$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $8c000611b10ddc14$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $8c000611b10ddc14$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $a7a440407ad76e9c$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$e6127cc7fe7395c3(wat) {
    switch($a7a440407ad76e9c$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $a7a440407ad76e9c$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$var$isBuiltin(wat, className) {
    return $a7a440407ad76e9c$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$9f9636d330b71954(wat) {
    return $a7a440407ad76e9c$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$ef9e2056653f0c8e(wat) {
    return $a7a440407ad76e9c$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$12e869b2a583f783(wat) {
    return $a7a440407ad76e9c$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$844ec244b1367d54(wat) {
    return $a7a440407ad76e9c$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$c3825b437cbdea5c(wat) {
    return wat === null || $a7a440407ad76e9c$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$53b83ca8eaab0383(wat) {
    return $a7a440407ad76e9c$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $a7a440407ad76e9c$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $a7a440407ad76e9c$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$49841c62b9eff15(wat) {
    return $a7a440407ad76e9c$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $a7a440407ad76e9c$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$bc2894c7158efbac(wat) {
    return $a7a440407ad76e9c$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $a7a440407ad76e9c$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e7355d6486215205$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/** Prefix for logging strings */ const $fa8e8d8acc41a310$var$PREFIX = "Sentry Logger ";
const $fa8e8d8acc41a310$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $fa8e8d8acc41a310$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $fa8e8d8acc41a310$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fa8e8d8acc41a310$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fa8e8d8acc41a310$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fa8e8d8acc41a310$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $e7355d6486215205$export$16a28057038b10ef) $fa8e8d8acc41a310$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $fa8e8d8acc41a310$export$cda52e2a8927a2ca(()=>{
                (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).console[name](`${$fa8e8d8acc41a310$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $fa8e8d8acc41a310$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $fa8e8d8acc41a310$export$af88d00dbe7f521 = $fa8e8d8acc41a310$var$makeLogger();


const $b44690d12ec59e52$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $b44690d12ec59e52$export$7740643b9eeaf0c4() {
    return Date.now() / $b44690d12ec59e52$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b44690d12ec59e52$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $b44690d12ec59e52$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $b44690d12ec59e52$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $b44690d12ec59e52$export$ee52dced521e3e18 = $b44690d12ec59e52$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $b44690d12ec59e52$export$c5907b5a8838db13 = $b44690d12ec59e52$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $b44690d12ec59e52$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $b44690d12ec59e52$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $b44690d12ec59e52$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $b44690d12ec59e52$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $b44690d12ec59e52$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $b44690d12ec59e52$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();



// eslint-disable-next-line deprecation/deprecation
const $987d30935b5a1a43$var$WINDOW = (0, $8c000611b10ddc14$export$256479dc0cea61c4)();
const $987d30935b5a1a43$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $987d30935b5a1a43$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $987d30935b5a1a43$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $987d30935b5a1a43$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $987d30935b5a1a43$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($987d30935b5a1a43$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $a7a440407ad76e9c$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $987d30935b5a1a43$export$1cfafeee2987818b() {
    try {
        return $987d30935b5a1a43$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $987d30935b5a1a43$export$c660c1f3ab49225c(selector) {
    if ($987d30935b5a1a43$var$WINDOW.document && $987d30935b5a1a43$var$WINDOW.document.querySelector) return $987d30935b5a1a43$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $987d30935b5a1a43$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$987d30935b5a1a43$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $3ded168be62470b2$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $3ded168be62470b2$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3ded168be62470b2$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $a7a440407ad76e9c$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $3ded168be62470b2$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $a7a440407ad76e9c$export$844ec244b1367d54)(value)) return false;
    if ((0, $a7a440407ad76e9c$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $a7a440407ad76e9c$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $3ded168be62470b2$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$3ded168be62470b2$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $4f81a26afd00acb9$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $4f81a26afd00acb9$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $4f81a26afd00acb9$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $e7355d6486215205$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $4f81a26afd00acb9$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $4f81a26afd00acb9$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $4f81a26afd00acb9$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $4f81a26afd00acb9$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $4f81a26afd00acb9$export$62ff257738bf57f5(value) {
    if ((0, $a7a440407ad76e9c$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$4f81a26afd00acb9$var$getOwnProperties(value)
    };
    else if ((0, $a7a440407ad76e9c$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $4f81a26afd00acb9$var$serializeEventTarget(value.target),
            currentTarget: $4f81a26afd00acb9$var$serializeEventTarget(value.currentTarget),
            ...$4f81a26afd00acb9$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $a7a440407ad76e9c$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $4f81a26afd00acb9$var$serializeEventTarget(target) {
    try {
        return (0, $a7a440407ad76e9c$export$45a5e7f76e0caa8d)(target) ? (0, $987d30935b5a1a43$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $4f81a26afd00acb9$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $4f81a26afd00acb9$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($4f81a26afd00acb9$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $3ded168be62470b2$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $3ded168be62470b2$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $4f81a26afd00acb9$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $4f81a26afd00acb9$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $4f81a26afd00acb9$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($4f81a26afd00acb9$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $4f81a26afd00acb9$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($4f81a26afd00acb9$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $4f81a26afd00acb9$var$isPojo(input) {
    if (!(0, $a7a440407ad76e9c$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $4f81a26afd00acb9$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $a7a440407ad76e9c$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $8e0411c1e39b6e49$export$19f53698e68b2496() {
    const gbl = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $8e0411c1e39b6e49$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $8e0411c1e39b6e49$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $8e0411c1e39b6e49$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $8e0411c1e39b6e49$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $8e0411c1e39b6e49$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $8e0411c1e39b6e49$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $8e0411c1e39b6e49$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $8e0411c1e39b6e49$export$d364f2020ab30578(input) {
    const match = input.match($8e0411c1e39b6e49$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $8e0411c1e39b6e49$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $3ded168be62470b2$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $3ded168be62470b2$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $3ded168be62470b2$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $8e0411c1e39b6e49$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $4f81a26afd00acb9$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $8e0411c1e39b6e49$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $f60795d5a02e7c59$export$849dbeeeda01ae98 = "production";


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $bde2af06c0721643$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;







/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $4747a4c76d129580$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($4747a4c76d129580$var$States || ($4747a4c76d129580$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $4747a4c76d129580$export$1fda8aa4d135f8aa(value) {
    return new $4747a4c76d129580$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $4747a4c76d129580$export$78e43115b553f358(reason) {
    return new $4747a4c76d129580$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $4747a4c76d129580$export$6f292d4960313241 {
    constructor(executor){
        $4747a4c76d129580$export$6f292d4960313241.prototype.__init.call(this);
        $4747a4c76d129580$export$6f292d4960313241.prototype.__init2.call(this);
        $4747a4c76d129580$export$6f292d4960313241.prototype.__init3.call(this);
        $4747a4c76d129580$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $4747a4c76d129580$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $4747a4c76d129580$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $4747a4c76d129580$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($4747a4c76d129580$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($4747a4c76d129580$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $4747a4c76d129580$var$States.PENDING) return;
            if ((0, $a7a440407ad76e9c$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $4747a4c76d129580$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $4747a4c76d129580$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $4747a4c76d129580$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $65c4134494606319$export$3c4238858b85e8ac() {
    return (0, $8c000611b10ddc14$export$7e223ec222791509)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $65c4134494606319$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $65c4134494606319$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $65c4134494606319$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $4747a4c76d129580$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $bde2af06c0721643$export$16a28057038b10ef) && processor.id && result === null && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $a7a440407ad76e9c$export$f5b060c2914b97c8)(result)) result.then((final)=>$65c4134494606319$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $65c4134494606319$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ef9951805bf8afdb$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $b44690d12ec59e52$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ef9951805bf8afdb$var$sessionToJSON(session)
    };
    if (context) $ef9951805bf8afdb$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ef9951805bf8afdb$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $b44690d12ec59e52$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ef9951805bf8afdb$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ef9951805bf8afdb$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ef9951805bf8afdb$var$sessionToJSON(session) {
    return (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $91673f51e515ea64$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}





const $d79b002e88fa3f5d$export$9ca9946bd449ac06 = "baggage";
const $d79b002e88fa3f5d$export$6e69537d67fa20f = "sentry-";
const $d79b002e88fa3f5d$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $d79b002e88fa3f5d$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $d79b002e88fa3f5d$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $a7a440407ad76e9c$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $d79b002e88fa3f5d$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $d79b002e88fa3f5d$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($d79b002e88fa3f5d$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($d79b002e88fa3f5d$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $d79b002e88fa3f5d$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$d79b002e88fa3f5d$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $d79b002e88fa3f5d$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $d79b002e88fa3f5d$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $d79b002e88fa3f5d$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $d79b002e88fa3f5d$export$bdd844ddb2def819) {
            (0, $e7355d6486215205$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $b93579c61bd25af0$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $b93579c61bd25af0$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($b93579c61bd25af0$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $b93579c61bd25af0$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $b93579c61bd25af0$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $d79b002e88fa3f5d$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(),
            spanId: (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16),
            spanId: (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $b93579c61bd25af0$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $b93579c61bd25af0$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $d79b002e88fa3f5d$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(),
        spanId: (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16),
        spanId: (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $b93579c61bd25af0$export$f35d907436da45cf(traceId = (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(), spanId = (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $3c6c3464b56596d8$export$208d5b368507fb8b = 0x0;
const $3c6c3464b56596d8$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $3c6c3464b56596d8$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $3c6c3464b56596d8$export$92d8c23565496537(span);
    return (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $3c6c3464b56596d8$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $3c6c3464b56596d8$export$5caecac1caaf3a71(span);
    return (0, $b93579c61bd25af0$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $3c6c3464b56596d8$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $3c6c3464b56596d8$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $3c6c3464b56596d8$var$ensureTimestampInSeconds(input.getTime());
    return (0, $b44690d12ec59e52$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $3c6c3464b56596d8$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $3c6c3464b56596d8$export$92d8c23565496537(span) {
    if ($3c6c3464b56596d8$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $3c6c3464b56596d8$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $3c6c3464b56596d8$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $3c6c3464b56596d8$export$eb571cd9b5d98de8);
}


/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $d404105fdf00f3e3$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
        environment: options.environment || (0, $f60795d5a02e7c59$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $d404105fdf00f3e3$export$a117f995597e25df(span) {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $d404105fdf00f3e3$export$366bad00d6815eed((0, $3c6c3464b56596d8$export$92d8c23565496537)(span).trace_id || "", client, (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $91673f51e515ea64$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $3c6c3464b56596d8$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $3c6c3464b56596d8$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $cb66237bd8d055d4$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $cb66237bd8d055d4$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $cb66237bd8d055d4$var$applySpanToEvent(event, span);
    $cb66237bd8d055d4$var$applyFingerprintToEvent(event, fingerprint);
    $cb66237bd8d055d4$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $cb66237bd8d055d4$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $cb66237bd8d055d4$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $cb66237bd8d055d4$export$b1a120a2871faa46(data, "extra", extra);
    $cb66237bd8d055d4$export$b1a120a2871faa46(data, "tags", tags);
    $cb66237bd8d055d4$export$b1a120a2871faa46(data, "user", user);
    $cb66237bd8d055d4$export$b1a120a2871faa46(data, "contexts", contexts);
    $cb66237bd8d055d4$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $cb66237bd8d055d4$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $cb66237bd8d055d4$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $4f81a26afd00acb9$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $4f81a26afd00acb9$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $4f81a26afd00acb9$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $4f81a26afd00acb9$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $cb66237bd8d055d4$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $cb66237bd8d055d4$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $cb66237bd8d055d4$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $3c6c3464b56596d8$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $91673f51e515ea64$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $d404105fdf00f3e3$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $3c6c3464b56596d8$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $cb66237bd8d055d4$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $8e0411c1e39b6e49$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $a6d4c8ec12de874d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $a6d4c8ec12de874d$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $a6d4c8ec12de874d$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $a6d4c8ec12de874d$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $a6d4c8ec12de874d$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $a6d4c8ec12de874d$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $ef9951805bf8afdb$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $a6d4c8ec12de874d$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $a7a440407ad76e9c$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $a6d4c8ec12de874d$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $a6d4c8ec12de874d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $b44690d12ec59e52$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $cb66237bd8d055d4$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $65c4134494606319$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $65c4134494606319$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $a6d4c8ec12de874d$export$aa55d5ab8e05984f() {
    if (!$a6d4c8ec12de874d$var$globalScope) $a6d4c8ec12de874d$var$globalScope = new $a6d4c8ec12de874d$export$775b6bb06e53a214();
    return $a6d4c8ec12de874d$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $a6d4c8ec12de874d$export$c83048efd17527d6(scope) {
    $a6d4c8ec12de874d$var$globalScope = scope;
}
function $a6d4c8ec12de874d$var$generatePropagationContext() {
    return {
        traceId: (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(),
        spanId: (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16)
    };
}



const $4608b21abbbf1c5b$export$31499a9cd224b78c = "7.107.0";


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $9c33807712fa1c9d$export$24a86ef7798177e4 = parseFloat((0, $4608b21abbbf1c5b$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $9c33807712fa1c9d$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $9c33807712fa1c9d$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $9c33807712fa1c9d$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $a6d4c8ec12de874d$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $a6d4c8ec12de874d$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $a7a440407ad76e9c$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $9c33807712fa1c9d$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $b44690d12ec59e52$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $fa8e8d8acc41a310$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $9c33807712fa1c9d$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $9c33807712fa1c9d$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $bde2af06c0721643$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $ef9951805bf8afdb$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $f60795d5a02e7c59$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $ef9951805bf8afdb$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $ef9951805bf8afdb$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $9c33807712fa1c9d$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $9c33807712fa1c9d$export$19eade501500c6c1() {
    (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $8c000611b10ddc14$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ function $9c33807712fa1c9d$export$4188a14ad302d1bc(hub) {
    const registry = $9c33807712fa1c9d$export$19eade501500c6c1();
    const oldHub = $9c33807712fa1c9d$export$bfa8a924a84a76b7(registry);
    $9c33807712fa1c9d$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ function $9c33807712fa1c9d$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $9c33807712fa1c9d$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $9c33807712fa1c9d$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $9c33807712fa1c9d$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $9c33807712fa1c9d$export$a07cdf6544bbd7c().getIsolationScope();
}
function $9c33807712fa1c9d$var$getGlobalHub(registry = $9c33807712fa1c9d$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$9c33807712fa1c9d$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $9c33807712fa1c9d$export$bfa8a924a84a76b7(registry).isOlderThan($9c33807712fa1c9d$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $9c33807712fa1c9d$export$849f05434e95d2f2(registry, new $9c33807712fa1c9d$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $9c33807712fa1c9d$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $9c33807712fa1c9d$export$236689a79f5aa020(carrier, parent = $9c33807712fa1c9d$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$9c33807712fa1c9d$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $9c33807712fa1c9d$export$bfa8a924a84a76b7(carrier).isOlderThan($9c33807712fa1c9d$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $9c33807712fa1c9d$export$849f05434e95d2f2(carrier, new $9c33807712fa1c9d$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $9c33807712fa1c9d$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $9c33807712fa1c9d$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $9c33807712fa1c9d$export$70d775fb1f267027(callback, options = {}) {
    const registry = $9c33807712fa1c9d$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $9c33807712fa1c9d$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $9c33807712fa1c9d$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $8c000611b10ddc14$export$7e223ec222791509)("hub", ()=>new $9c33807712fa1c9d$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $9c33807712fa1c9d$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $6ca652bf6c3651b8$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $cc59e30a67d030d7$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $cc59e30a67d030d7$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $cc59e30a67d030d7$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $95cb566e529ce096$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $95cb566e529ce096$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $95cb566e529ce096$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $95cb566e529ce096$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $95cb566e529ce096$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($95cb566e529ce096$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $95cb566e529ce096$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $95cb566e529ce096$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $95cb566e529ce096$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $95cb566e529ce096$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $95cb566e529ce096$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($95cb566e529ce096$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($95cb566e529ce096$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $95cb566e529ce096$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $95cb566e529ce096$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $95cb566e529ce096$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $95cb566e529ce096$var$defaultFunctionName;
        return fn.name || $95cb566e529ce096$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $95cb566e529ce096$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $95cb566e529ce096$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $cc59e30a67d030d7$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $35a80961bb361df7$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $35a80961bb361df7$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $35a80961bb361df7$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $35a80961bb361df7$export$a3295358bff77e(object, depth);
    if ($35a80961bb361df7$var$jsonSize(normalized) > maxSize) return $35a80961bb361df7$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $35a80961bb361df7$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $6ca652bf6c3651b8$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $a7a440407ad76e9c$export$c9f5652083b8129d)(value)) return value;
    const stringified = $35a80961bb361df7$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $35a80961bb361df7$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $4f81a26afd00acb9$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $35a80961bb361df7$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $35a80961bb361df7$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $a7a440407ad76e9c$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $a7a440407ad76e9c$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $95cb566e529ce096$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $35a80961bb361df7$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $35a80961bb361df7$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $35a80961bb361df7$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $35a80961bb361df7$var$jsonSize(value) {
    return $35a80961bb361df7$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $35a80961bb361df7$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $e424e8186a197aac$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $b44690d12ec59e52$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $e424e8186a197aac$var$applyClientOptions(prepared, options);
    $e424e8186a197aac$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $e424e8186a197aac$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $e424e8186a197aac$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $8e0411c1e39b6e49$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $a6d4c8ec12de874d$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $cb66237bd8d055d4$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $cb66237bd8d055d4$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $cb66237bd8d055d4$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $65c4134494606319$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $65c4134494606319$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $e424e8186a197aac$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $e424e8186a197aac$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $e424e8186a197aac$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $f60795d5a02e7c59$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $3ded168be62470b2$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $3ded168be62470b2$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $3ded168be62470b2$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $e424e8186a197aac$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $e424e8186a197aac$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $e424e8186a197aac$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $e424e8186a197aac$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $e424e8186a197aac$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $e424e8186a197aac$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $e424e8186a197aac$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $35a80961bb361df7$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $35a80961bb361df7$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $35a80961bb361df7$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $35a80961bb361df7$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $35a80961bb361df7$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $3c6c3464b56596d8$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $35a80961bb361df7$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $e424e8186a197aac$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $a6d4c8ec12de874d$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $e424e8186a197aac$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($e424e8186a197aac$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($e424e8186a197aac$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $e424e8186a197aac$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $a6d4c8ec12de874d$export$775b6bb06e53a214) || typeof hint === "function";
}
const $e424e8186a197aac$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $e424e8186a197aac$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$e424e8186a197aac$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $dbaa48b6af64d774$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().captureException(exception, (0, $e424e8186a197aac$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $dbaa48b6af64d774$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $dbaa48b6af64d774$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ function $dbaa48b6af64d774$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $dbaa48b6af64d774$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dbaa48b6af64d774$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $dbaa48b6af64d774$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $dbaa48b6af64d774$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $dbaa48b6af64d774$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $dbaa48b6af64d774$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $dbaa48b6af64d774$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $dbaa48b6af64d774$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $dbaa48b6af64d774$export$9a4fed82c350c2bd(callback) {
    return (0, $9c33807712fa1c9d$export$70d775fb1f267027)(()=>{
        return callback((0, $9c33807712fa1c9d$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $dbaa48b6af64d774$export$e57ac09b143d92a2(span, callback) {
    return $dbaa48b6af64d774$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $dbaa48b6af64d774$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $dbaa48b6af64d774$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $dbaa48b6af64d774$export$c7be4b0125a10cba();
    const client = $dbaa48b6af64d774$export$6bb76d6eba7e258c();
    if (!client) (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $dbaa48b6af64d774$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $dbaa48b6af64d774$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $b44690d12ec59e52$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $dbaa48b6af64d774$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $b44690d12ec59e52$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $a7a440407ad76e9c$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $dbaa48b6af64d774$export$4909b86c8034bf73(timeout) {
    const client = $dbaa48b6af64d774$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $dbaa48b6af64d774$export$8360e631d277ea4d(timeout) {
    const client = $dbaa48b6af64d774$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 * @deprecated This function will be removed in the next major version of the Sentry SDK.
 */ function $dbaa48b6af64d774$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $dbaa48b6af64d774$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $dbaa48b6af64d774$export$3f95c6f800b78024() {
    return !!$dbaa48b6af64d774$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $dbaa48b6af64d774$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $dbaa48b6af64d774$export$c0d84948cecf78d8(context) {
    const client = $dbaa48b6af64d774$export$6bb76d6eba7e258c();
    const isolationScope = (0, $9c33807712fa1c9d$export$68f3af03034c9e90)();
    const currentScope = $dbaa48b6af64d774$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $f60795d5a02e7c59$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $ef9951805bf8afdb$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $ef9951805bf8afdb$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $dbaa48b6af64d774$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $dbaa48b6af64d774$export$17a5be43989a0bc1() {
    const isolationScope = (0, $9c33807712fa1c9d$export$68f3af03034c9e90)();
    const currentScope = $dbaa48b6af64d774$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $ef9951805bf8afdb$export$56521d9ba90f62ee)(session);
    $dbaa48b6af64d774$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $dbaa48b6af64d774$var$_sendSessionUpdate() {
    const isolationScope = (0, $9c33807712fa1c9d$export$68f3af03034c9e90)();
    const currentScope = $dbaa48b6af64d774$export$c7be4b0125a10cba();
    const client = $dbaa48b6af64d774$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $dbaa48b6af64d774$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $dbaa48b6af64d774$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $dbaa48b6af64d774$var$_sendSessionUpdate();
}


function $d8918e33b5816ce2$export$2e2bcd8739ae039({ dataset: dataset, setFormId: setFormId, setFormName: setFormName, dispatcherName: dispatcherName, formId: formId, customerId: customerId }) {
    const [forms, setForms] = (0, $6cds3.useState)([]); // [forms, setForms
    const retrieveForms = async ()=>{
        const response = await (0, $84a973f6a13a2051$export$3988ae62b71be9a3)({
            path: "forms"
        }).catch((error)=>{
            $dbaa48b6af64d774$export$f5282963edea4a68(error);
        });
        setForms(response.data.data);
    };
    (0, $6cds3.useEffect)(()=>{
        console.log("retrieveForms");
        retrieveForms();
    }, [
        dataset
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (dispatcherName) setTimeout(()=>{
            setFormId(forms.find((form)=>form.attributes.title === dispatcherName).id);
        }, 2000);
    }, [
        dispatcherName
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "cf-select-wrap",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                htmlFor: "form_id",
                children: "TIPO DI CLIENTE *"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                style: {
                    width: "100%"
                },
                value: formId,
                onChange: (e)=>{
                    setFormId(e.target.value);
                    setFormName(e.target.options[e.target.selectedIndex].text);
                },
                name: "form_id",
                id: "form_id",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                        value: "",
                        children: "Seleziona"
                    }),
                    forms.map((form)=>{
                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                            value: form.id,
                            children: form.attributes.title
                        });
                    })
                ]
            })
        ]
    });
}




var $6cds3 = parcelRequire("6cds3");
var $ba34d1ebd6528b77$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $ba34d1ebd6528b77$var$isDateObject = (value1)=>value1 instanceof Date;
var $ba34d1ebd6528b77$var$isNullOrUndefined = (value1)=>value1 == null;
const $ba34d1ebd6528b77$var$isObjectType = (value1)=>typeof value1 === "object";
var $ba34d1ebd6528b77$var$isObject = (value1)=>!$ba34d1ebd6528b77$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $ba34d1ebd6528b77$var$isObjectType(value1) && !$ba34d1ebd6528b77$var$isDateObject(value1);
var $ba34d1ebd6528b77$var$getEventValue = (event)=>$ba34d1ebd6528b77$var$isObject(event) && event.target ? $ba34d1ebd6528b77$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $ba34d1ebd6528b77$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $ba34d1ebd6528b77$var$isNameInFieldArray = (names, name)=>names.has($ba34d1ebd6528b77$var$getNodeParentName(name));
var $ba34d1ebd6528b77$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $ba34d1ebd6528b77$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $ba34d1ebd6528b77$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $ba34d1ebd6528b77$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($ba34d1ebd6528b77$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $ba34d1ebd6528b77$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$ba34d1ebd6528b77$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $ba34d1ebd6528b77$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $ba34d1ebd6528b77$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $ba34d1ebd6528b77$var$isUndefined = (val)=>val === undefined;
var $ba34d1ebd6528b77$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$ba34d1ebd6528b77$var$isObject(obj)) return defaultValue;
    const result = $ba34d1ebd6528b77$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$ba34d1ebd6528b77$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $ba34d1ebd6528b77$var$isUndefined(result) || result === obj ? $ba34d1ebd6528b77$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
var $ba34d1ebd6528b77$var$isBoolean = (value1)=>typeof value1 === "boolean";
const $ba34d1ebd6528b77$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $ba34d1ebd6528b77$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $ba34d1ebd6528b77$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ba34d1ebd6528b77$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useContext($ba34d1ebd6528b77$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $ba34d1ebd6528b77$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement($ba34d1ebd6528b77$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $ba34d1ebd6528b77$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $ba34d1ebd6528b77$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $ba34d1ebd6528b77$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $ba34d1ebd6528b77$var$isEmptyObject = (value1)=>$ba34d1ebd6528b77$var$isObject(value1) && !Object.keys(value1).length;
var $ba34d1ebd6528b77$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $ba34d1ebd6528b77$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $ba34d1ebd6528b77$var$VALIDATION_MODE.all));
};
var $ba34d1ebd6528b77$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $ba34d1ebd6528b77$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $ba34d1ebd6528b77$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $ba34d1ebd6528b77$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$606f11b2eb45ecc6(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    _name.current = name;
    $ba34d1ebd6528b77$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $ba34d1ebd6528b77$var$shouldSubscribeByName(_name.current, value1.name, exact) && $ba34d1ebd6528b77$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $ba34d1ebd6528b77$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $ba34d1ebd6528b77$var$isString = (value1)=>typeof value1 === "string";
var $ba34d1ebd6528b77$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($ba34d1ebd6528b77$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $ba34d1ebd6528b77$export$3c773aa2b84f29e0(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    _name.current = name;
    $ba34d1ebd6528b77$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($ba34d1ebd6528b77$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $ba34d1ebd6528b77$var$isKey = (value1)=>/^\w*$/.test(value1);
var $ba34d1ebd6528b77$var$stringToPath = (input)=>$ba34d1ebd6528b77$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $ba34d1ebd6528b77$var$isKey(path) ? [
        path
    ] : $ba34d1ebd6528b77$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $ba34d1ebd6528b77$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$e8c786024a2b0a79(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $ba34d1ebd6528b77$var$isNameInFieldArray(control._names.array, name);
    const value1 = $ba34d1ebd6528b77$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $ba34d1ebd6528b77$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    _registerProps.current = control.register(name, props.rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $ba34d1ebd6528b77$var$cloneObject($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($ba34d1ebd6528b77$var$isUndefined($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name))) $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if ($ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$ba34d1ebd6528b77$var$isBoolean(disabled) || $ba34d1ebd6528b77$var$isBoolean(formState.disabled) ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $ba34d1ebd6528b77$var$getEventValue(event),
                        name: name
                    },
                    type: $ba34d1ebd6528b77$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $ba34d1ebd6528b77$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$ba34d1ebd6528b77$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $ba34d1ebd6528b77$export$bd0bf19f25da8474 = (props)=>props.render($ba34d1ebd6528b77$export$e8c786024a2b0a79(props));
const $ba34d1ebd6528b77$var$POST_REQUEST = "post";
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$a7fed597f4b8afd8(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $ba34d1ebd6528b77$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = "";
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = "";
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            for (const name of control._names.mount)formData.append(name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(data, name));
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers["Content-Type"],
                    encType
                ].some((value1)=>value1 && value1.includes("json"));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            "Content-Type": encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError("root.server", {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $ba34d1ebd6528b77$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $ba34d1ebd6528b77$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $ba34d1ebd6528b77$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $ba34d1ebd6528b77$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$ba34d1ebd6528b77$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $ba34d1ebd6528b77$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all,
        isOnTouch: mode === $ba34d1ebd6528b77$var$VALIDATION_MODE.onTouched
    });
var $ba34d1ebd6528b77$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $ba34d1ebd6528b77$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) break;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) break;
            } else if ($ba34d1ebd6528b77$var$isObject(currentField)) $ba34d1ebd6528b77$var$iterateFieldsByAction(currentField, action);
        }
    }
};
var $ba34d1ebd6528b77$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name));
    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $ba34d1ebd6528b77$var$isFileInput = (element)=>element.type === "file";
var $ba34d1ebd6528b77$var$isFunction = (value1)=>typeof value1 === "function";
var $ba34d1ebd6528b77$var$isHTMLElement = (value1)=>{
    if (!$ba34d1ebd6528b77$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $ba34d1ebd6528b77$var$isMessage = (value1)=>$ba34d1ebd6528b77$var$isString(value1);
var $ba34d1ebd6528b77$var$isRadioInput = (element)=>element.type === "radio";
var $ba34d1ebd6528b77$var$isRegex = (value1)=>value1 instanceof RegExp;
const $ba34d1ebd6528b77$var$defaultResult = {
    value: false,
    isValid: false
};
const $ba34d1ebd6528b77$var$validResult = {
    value: true,
    isValid: true
};
var $ba34d1ebd6528b77$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$ba34d1ebd6528b77$var$isUndefined(options[0].attributes.value) ? $ba34d1ebd6528b77$var$isUndefined(options[0].value) || options[0].value === "" ? $ba34d1ebd6528b77$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $ba34d1ebd6528b77$var$validResult : $ba34d1ebd6528b77$var$defaultResult;
    }
    return $ba34d1ebd6528b77$var$defaultResult;
};
const $ba34d1ebd6528b77$var$defaultReturn = {
    isValid: false,
    value: null
};
var $ba34d1ebd6528b77$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $ba34d1ebd6528b77$var$defaultReturn) : $ba34d1ebd6528b77$var$defaultReturn;
function $ba34d1ebd6528b77$var$getValidateError(result, ref, type = "validate") {
    if ($ba34d1ebd6528b77$var$isMessage(result) || Array.isArray(result) && result.every($ba34d1ebd6528b77$var$isMessage) || $ba34d1ebd6528b77$var$isBoolean(result) && !result) return {
        type: type,
        message: $ba34d1ebd6528b77$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $ba34d1ebd6528b77$var$getValueAndMessage = (validationData)=>$ba34d1ebd6528b77$var$isObject(validationData) && !$ba34d1ebd6528b77$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $ba34d1ebd6528b77$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $ba34d1ebd6528b77$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($ba34d1ebd6528b77$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $ba34d1ebd6528b77$var$isRadioInput(ref);
    const isCheckBox = $ba34d1ebd6528b77$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $ba34d1ebd6528b77$var$isFileInput(ref)) && $ba34d1ebd6528b77$var$isUndefined(ref.value) && $ba34d1ebd6528b77$var$isUndefined(inputValue) || $ba34d1ebd6528b77$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $ba34d1ebd6528b77$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.maxLength, minType = $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $ba34d1ebd6528b77$var$isNullOrUndefined(inputValue)) || $ba34d1ebd6528b77$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$ba34d1ebd6528b77$var$getCheckboxValue(refs).isValid || isRadio && !$ba34d1ebd6528b77$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $ba34d1ebd6528b77$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $ba34d1ebd6528b77$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$ba34d1ebd6528b77$var$isNullOrUndefined(min) || !$ba34d1ebd6528b77$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $ba34d1ebd6528b77$var$getValueAndMessage(max);
        const minOutput = $ba34d1ebd6528b77$var$getValueAndMessage(min);
        if (!$ba34d1ebd6528b77$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$ba34d1ebd6528b77$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$ba34d1ebd6528b77$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($ba34d1ebd6528b77$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($ba34d1ebd6528b77$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.max, $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($ba34d1ebd6528b77$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $ba34d1ebd6528b77$var$getValueAndMessage(maxLength);
        const minLengthOutput = $ba34d1ebd6528b77$var$getValueAndMessage(minLength);
        const exceedMax = !$ba34d1ebd6528b77$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$ba34d1ebd6528b77$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $ba34d1ebd6528b77$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $ba34d1ebd6528b77$var$getValueAndMessage(pattern);
        if ($ba34d1ebd6528b77$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($ba34d1ebd6528b77$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $ba34d1ebd6528b77$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($ba34d1ebd6528b77$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($ba34d1ebd6528b77$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$ba34d1ebd6528b77$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $ba34d1ebd6528b77$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$ba34d1ebd6528b77$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $ba34d1ebd6528b77$var$append(data, value1) {
    return [
        ...data,
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(value1)
    ];
}
var $ba34d1ebd6528b77$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $ba34d1ebd6528b77$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $ba34d1ebd6528b77$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($ba34d1ebd6528b77$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $ba34d1ebd6528b77$var$prepend(data, value1) {
    return [
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(value1),
        ...$ba34d1ebd6528b77$var$convertToArrayPayload(data)
    ];
}
function $ba34d1ebd6528b77$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $ba34d1ebd6528b77$var$compact(temp).length ? temp : [];
}
var $ba34d1ebd6528b77$var$removeArrayAt = (data, index)=>$ba34d1ebd6528b77$var$isUndefined(index) ? [] : $ba34d1ebd6528b77$var$removeAtIndexes(data, $ba34d1ebd6528b77$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $ba34d1ebd6528b77$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $ba34d1ebd6528b77$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $ba34d1ebd6528b77$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $ba34d1ebd6528b77$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$ba34d1ebd6528b77$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $ba34d1ebd6528b77$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $ba34d1ebd6528b77$var$isKey(path) ? [
        path
    ] : $ba34d1ebd6528b77$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $ba34d1ebd6528b77$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($ba34d1ebd6528b77$var$isObject(childObject) && $ba34d1ebd6528b77$var$isEmptyObject(childObject) || Array.isArray(childObject) && $ba34d1ebd6528b77$var$isEmptyArray(childObject))) $ba34d1ebd6528b77$var$unset(object, paths.slice(0, -1));
    return object;
}
var $ba34d1ebd6528b77$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$310131896651d559(props) {
    const methods = $ba34d1ebd6528b77$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(control._getFieldArray(name).map($ba34d1ebd6528b77$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $ba34d1ebd6528b77$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($ba34d1ebd6528b77$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $ba34d1ebd6528b77$var$append(ids.current, appendValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$append, {
            argA: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, 0, options);
        ids.current = $ba34d1ebd6528b77$var$prepend(ids.current, prependValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$prepend, {
            argA: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $ba34d1ebd6528b77$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $ba34d1ebd6528b77$var$getFocusFieldName(name, index, options);
        ids.current = $ba34d1ebd6528b77$var$insert(ids.current, index, insertValue.map($ba34d1ebd6528b77$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$insert, {
            argA: index,
            argB: $ba34d1ebd6528b77$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ba34d1ebd6528b77$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $ba34d1ebd6528b77$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $ba34d1ebd6528b77$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $ba34d1ebd6528b77$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $ba34d1ebd6528b77$var$cloneObject(value1);
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $ba34d1ebd6528b77$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $ba34d1ebd6528b77$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $ba34d1ebd6528b77$var$convertToArrayPayload($ba34d1ebd6528b77$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($ba34d1ebd6528b77$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        control._state.action = false;
        $ba34d1ebd6528b77$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$ba34d1ebd6528b77$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $ba34d1ebd6528b77$var$validateField(field, control._formValues, control._options.criteriaMode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$ba34d1ebd6528b77$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $ba34d1ebd6528b77$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $ba34d1ebd6528b77$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = "";
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        !$ba34d1ebd6528b77$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $ba34d1ebd6528b77$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $ba34d1ebd6528b77$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $ba34d1ebd6528b77$var$isPrimitive = (value1)=>$ba34d1ebd6528b77$var$isNullOrUndefined(value1) || !$ba34d1ebd6528b77$var$isObjectType(value1);
function $ba34d1ebd6528b77$var$deepEqual(object1, object2) {
    if ($ba34d1ebd6528b77$var$isPrimitive(object1) || $ba34d1ebd6528b77$var$isPrimitive(object2)) return object1 === object2;
    if ($ba34d1ebd6528b77$var$isDateObject(object1) && $ba34d1ebd6528b77$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($ba34d1ebd6528b77$var$isDateObject(val1) && $ba34d1ebd6528b77$var$isDateObject(val2) || $ba34d1ebd6528b77$var$isObject(val1) && $ba34d1ebd6528b77$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$ba34d1ebd6528b77$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $ba34d1ebd6528b77$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $ba34d1ebd6528b77$var$isRadioOrCheckbox = (ref)=>$ba34d1ebd6528b77$var$isRadioInput(ref) || $ba34d1ebd6528b77$var$isCheckBoxInput(ref);
var $ba34d1ebd6528b77$var$live = (ref)=>$ba34d1ebd6528b77$var$isHTMLElement(ref) && ref.isConnected;
var $ba34d1ebd6528b77$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($ba34d1ebd6528b77$var$isFunction(data[key])) return true;
    }
    return false;
};
function $ba34d1ebd6528b77$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($ba34d1ebd6528b77$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $ba34d1ebd6528b77$var$isObject(data[key]) && !$ba34d1ebd6528b77$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $ba34d1ebd6528b77$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$ba34d1ebd6528b77$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($ba34d1ebd6528b77$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $ba34d1ebd6528b77$var$isObject(data[key]) && !$ba34d1ebd6528b77$var$objectHasFunction(data[key])) {
            if ($ba34d1ebd6528b77$var$isUndefined(formValues) || $ba34d1ebd6528b77$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $ba34d1ebd6528b77$var$markFieldsDirty(data[key], []) : {
                ...$ba34d1ebd6528b77$var$markFieldsDirty(data[key])
            };
            else $ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(data[key], $ba34d1ebd6528b77$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$ba34d1ebd6528b77$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $ba34d1ebd6528b77$var$getDirtyFields = (defaultValues, formValues)=>$ba34d1ebd6528b77$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $ba34d1ebd6528b77$var$markFieldsDirty(formValues));
var $ba34d1ebd6528b77$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$ba34d1ebd6528b77$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $ba34d1ebd6528b77$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $ba34d1ebd6528b77$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($ba34d1ebd6528b77$var$isFileInput(ref)) return ref.files;
    if ($ba34d1ebd6528b77$var$isRadioInput(ref)) return $ba34d1ebd6528b77$var$getRadioValue(_f.refs).value;
    if ($ba34d1ebd6528b77$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($ba34d1ebd6528b77$var$isCheckBoxInput(ref)) return $ba34d1ebd6528b77$var$getCheckboxValue(_f.refs).value;
    return $ba34d1ebd6528b77$var$getFieldValueAs($ba34d1ebd6528b77$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $ba34d1ebd6528b77$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        field && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $ba34d1ebd6528b77$var$getRuleValue = (rule)=>$ba34d1ebd6528b77$var$isUndefined(rule) ? rule : $ba34d1ebd6528b77$var$isRegex(rule) ? rule.source : $ba34d1ebd6528b77$var$isObject(rule) ? $ba34d1ebd6528b77$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $ba34d1ebd6528b77$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $ba34d1ebd6528b77$var$schemaErrorLookup(errors, _fields, name) {
    const error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name);
    if (error || $ba34d1ebd6528b77$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $ba34d1ebd6528b77$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $ba34d1ebd6528b77$var$unsetEmptyArray = (ref, name)=>!$ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(ref, name)).length && $ba34d1ebd6528b77$var$unset(ref, name);
const $ba34d1ebd6528b77$var$defaultOptions = {
    mode: $ba34d1ebd6528b77$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $ba34d1ebd6528b77$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $ba34d1ebd6528b77$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$ba34d1ebd6528b77$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $ba34d1ebd6528b77$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
        disabled: false
    };
    let _fields = {};
    let _defaultValues = $ba34d1ebd6528b77$var$isObject(_options.defaultValues) || $ba34d1ebd6528b77$var$isObject(_options.values) ? $ba34d1ebd6528b77$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $ba34d1ebd6528b77$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $ba34d1ebd6528b77$var$createSubject(),
        array: $ba34d1ebd6528b77$var$createSubject(),
        state: $ba34d1ebd6528b77$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $ba34d1ebd6528b77$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $ba34d1ebd6528b77$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $ba34d1ebd6528b77$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $ba34d1ebd6528b77$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $ba34d1ebd6528b77$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, name, $ba34d1ebd6528b77$var$isUndefined(value1) ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $ba34d1ebd6528b77$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $ba34d1ebd6528b77$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $ba34d1ebd6528b77$var$deepEqual($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, name) : $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $ba34d1ebd6528b77$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(_formState.errors, name);
        }
        if ((error ? !$ba34d1ebd6528b77$var$deepEqual(previousFieldError, error) : previousFieldError) || !$ba34d1ebd6528b77$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $ba34d1ebd6528b77$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $ba34d1ebd6528b77$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name);
            error ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $ba34d1ebd6528b77$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $ba34d1ebd6528b77$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($ba34d1ebd6528b77$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $ba34d1ebd6528b77$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $ba34d1ebd6528b77$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$ba34d1ebd6528b77$var$live(ref)) : !$ba34d1ebd6528b77$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, data), !$ba34d1ebd6528b77$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$ba34d1ebd6528b77$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $ba34d1ebd6528b77$var$isUndefined(defaultValue) ? _defaultValues : $ba34d1ebd6528b77$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$ba34d1ebd6528b77$var$compact($ba34d1ebd6528b77$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, $ba34d1ebd6528b77$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $ba34d1ebd6528b77$var$isHTMLElement(fieldReference.ref) && $ba34d1ebd6528b77$var$isNullOrUndefined(value1) ? "" : value1;
                if ($ba34d1ebd6528b77$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($ba34d1ebd6528b77$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($ba34d1ebd6528b77$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$ba34d1ebd6528b77$var$isPrimitive(fieldValue) || field && !field._f) && !$ba34d1ebd6528b77$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $ba34d1ebd6528b77$var$cloneObject(value1);
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$ba34d1ebd6528b77$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $ba34d1ebd6528b77$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $ba34d1ebd6528b77$var$getFieldValue(field._f) : $ba34d1ebd6528b77$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || fieldValue === $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $ba34d1ebd6528b77$var$EVENTS.BLUR || event.type === $ba34d1ebd6528b77$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$ba34d1ebd6528b77$var$hasValidation(field._f) && !_options.resolver && !$ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $ba34d1ebd6528b77$var$skipValidation(isBlurEvent, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $ba34d1ebd6528b77$var$isWatched(name, _names, isBlurEvent);
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$ba34d1ebd6528b77$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $ba34d1ebd6528b77$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $ba34d1ebd6528b77$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $ba34d1ebd6528b77$var$isEmptyObject(errors);
                }
            } else {
                error = (await $ba34d1ebd6528b77$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $ba34d1ebd6528b77$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($ba34d1ebd6528b77$var$isUndefined(name) ? name : fieldNames);
            isValid = $ba34d1ebd6528b77$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$ba34d1ebd6528b77$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$ba34d1ebd6528b77$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $ba34d1ebd6528b77$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $ba34d1ebd6528b77$var$isUndefined(fieldNames) ? values : $ba34d1ebd6528b77$var$isString(fieldNames) ? $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$ba34d1ebd6528b77$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $ba34d1ebd6528b77$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $ba34d1ebd6528b77$var$convertToArrayPayload(name).forEach((inputName)=>$ba34d1ebd6528b77$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$ba34d1ebd6528b77$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $ba34d1ebd6528b77$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $ba34d1ebd6528b77$var$unset(_fields, fieldName);
                $ba34d1ebd6528b77$var$unset(_formValues, fieldName);
            }
            !options.keepError && $ba34d1ebd6528b77$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $ba34d1ebd6528b77$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $ba34d1ebd6528b77$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($ba34d1ebd6528b77$var$isBoolean(disabled)) {
            const inputValue = disabled ? undefined : $ba34d1ebd6528b77$var$isUndefined(value1) ? $ba34d1ebd6528b77$var$getFieldValue(field ? field._f : $ba34d1ebd6528b77$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $ba34d1ebd6528b77$var$isBoolean(options.disabled);
        $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $ba34d1ebd6528b77$var$getRuleValue(options.min),
                max: $ba34d1ebd6528b77$var$getRuleValue(options.max),
                minLength: $ba34d1ebd6528b77$var$getRuleValue(options.minLength),
                maxLength: $ba34d1ebd6528b77$var$getRuleValue(options.maxLength),
                pattern: $ba34d1ebd6528b77$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $ba34d1ebd6528b77$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $ba34d1ebd6528b77$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($ba34d1ebd6528b77$var$live),
                                    fieldRef,
                                    ...Array.isArray($ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($ba34d1ebd6528b77$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $ba34d1ebd6528b77$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($ba34d1ebd6528b77$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $ba34d1ebd6528b77$var$iterateFieldsByAction(_fields, (ref)=>{
                ref.disabled = disabled;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $ba34d1ebd6528b77$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $ba34d1ebd6528b77$var$unset(_formState.errors, "root");
            if ($ba34d1ebd6528b77$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $ba34d1ebd6528b77$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name)) {
            if ($ba34d1ebd6528b77$var$isUndefined(options.defaultValue)) setValue(name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $ba34d1ebd6528b77$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $ba34d1ebd6528b77$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $ba34d1ebd6528b77$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $ba34d1ebd6528b77$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $ba34d1ebd6528b77$var$cloneObject(updatedValues);
        const values = formValues && !$ba34d1ebd6528b77$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$ba34d1ebd6528b77$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $ba34d1ebd6528b77$export$adaa4cf7ef1b65be(values, fieldName, $ba34d1ebd6528b77$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $ba34d1ebd6528b77$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($ba34d1ebd6528b77$var$isWeb && $ba34d1ebd6528b77$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($ba34d1ebd6528b77$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $ba34d1ebd6528b77$var$cloneObject(_defaultValues) : {} : $ba34d1ebd6528b77$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$ba34d1ebd6528b77$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $ba34d1ebd6528b77$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($ba34d1ebd6528b77$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $ba34d1ebd6528b77$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$ba34d1ebd6528b77$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $ba34d1ebd6528b77$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $ba34d1ebd6528b77$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        disabled: false,
        defaultValues: $ba34d1ebd6528b77$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$ba34d1ebd6528b77$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $ba34d1ebd6528b77$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($ba34d1ebd6528b77$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (props.values && !$ba34d1ebd6528b77$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $ba34d1ebd6528b77$var$getProxyFormState(formState, control);
    return _formControl.current;
}









const $7b807498fd0c5452$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $7b807498fd0c5452$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $7b807498fd0c5452$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $8e0411c1e39b6e49$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $7b807498fd0c5452$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $7b807498fd0c5452$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $7b807498fd0c5452$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $7b807498fd0c5452$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $7b807498fd0c5452$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $7b807498fd0c5452$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($7b807498fd0c5452$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $65c4134494606319$export$8e4e25f54d456511), (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c));
        $7b807498fd0c5452$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $7b807498fd0c5452$export$2d8f5188773bcddd(integration) {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $7b807498fd0c5452$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $7b807498fd0c5452$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $7b807498fd0c5452$export$2323046b9414659f(fn) {
    return fn;
}


let $3ede77ad8b2617c4$var$originalFunctionToString;
const $3ede77ad8b2617c4$var$INTEGRATION_NAME = "FunctionToString";
const $3ede77ad8b2617c4$var$SETUP_CLIENTS = new WeakMap();
const $3ede77ad8b2617c4$var$_functionToStringIntegration = ()=>{
    return {
        name: $3ede77ad8b2617c4$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $3ede77ad8b2617c4$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $4f81a26afd00acb9$export$e6cc1e135e2092e5)(this);
                    const context = $3ede77ad8b2617c4$var$SETUP_CLIENTS.has((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $3ede77ad8b2617c4$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $3ede77ad8b2617c4$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $3ede77ad8b2617c4$export$7918117e9202e4fb = (0, $7b807498fd0c5452$export$2323046b9414659f)($3ede77ad8b2617c4$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3ede77ad8b2617c4$export$da4704525c20ae79 = (0, $7b807498fd0c5452$export$afa219bf23651160)($3ede77ad8b2617c4$var$INTEGRATION_NAME, $3ede77ad8b2617c4$export$7918117e9202e4fb);



/** Regular expression used to parse a Dsn. */ const $f8f86f8015b1c1d3$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $f8f86f8015b1c1d3$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $f8f86f8015b1c1d3$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $f8f86f8015b1c1d3$export$b892860177f70a30(str) {
    const match = $f8f86f8015b1c1d3$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $fa8e8d8acc41a310$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $f8f86f8015b1c1d3$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $f8f86f8015b1c1d3$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $f8f86f8015b1c1d3$var$validateDsn(dsn) {
    if (!(0, $e7355d6486215205$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$f8f86f8015b1c1d3$var$isValidProtocol(protocol)) {
        (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $f8f86f8015b1c1d3$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $f8f86f8015b1c1d3$export$b892860177f70a30(from) : $f8f86f8015b1c1d3$var$dsnFromComponents(from);
    if (!components || !$f8f86f8015b1c1d3$var$validateDsn(components)) return undefined;
    return components;
}


const $82a1ccaba8b17eaf$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $82a1ccaba8b17eaf$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $82a1ccaba8b17eaf$var$_getIngestEndpoint(dsn) {
    return `${$82a1ccaba8b17eaf$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $82a1ccaba8b17eaf$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $4f81a26afd00acb9$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $82a1ccaba8b17eaf$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $82a1ccaba8b17eaf$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$82a1ccaba8b17eaf$var$_getIngestEndpoint(dsn)}?${$82a1ccaba8b17eaf$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $82a1ccaba8b17eaf$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $f8f86f8015b1c1d3$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$82a1ccaba8b17eaf$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $f8f86f8015b1c1d3$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $19eeae6f74ee5364$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $19eeae6f74ee5364$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $19eeae6f74ee5364$var$INTEGRATION_NAME = "InboundFilters";
const $19eeae6f74ee5364$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $19eeae6f74ee5364$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $19eeae6f74ee5364$var$_mergeOptions(options, clientOptions);
            return $19eeae6f74ee5364$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $19eeae6f74ee5364$export$cb3c5c2ceb9818ba = (0, $7b807498fd0c5452$export$2323046b9414659f)($19eeae6f74ee5364$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $19eeae6f74ee5364$export$2ffbb5359dcc6be4 = (0, $7b807498fd0c5452$export$afa219bf23651160)($19eeae6f74ee5364$var$INTEGRATION_NAME, $19eeae6f74ee5364$export$cb3c5c2ceb9818ba);
function $19eeae6f74ee5364$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $19eeae6f74ee5364$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $19eeae6f74ee5364$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $19eeae6f74ee5364$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $19eeae6f74ee5364$var$_isSentryError(event)) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($19eeae6f74ee5364$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($19eeae6f74ee5364$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($19eeae6f74ee5364$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)}.\nUrl: ${$19eeae6f74ee5364$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$19eeae6f74ee5364$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)}.\nUrl: ${$19eeae6f74ee5364$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $19eeae6f74ee5364$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $19eeae6f74ee5364$var$_getPossibleEventMessages(event).some((message)=>(0, $3ded168be62470b2$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $19eeae6f74ee5364$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $3ded168be62470b2$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $19eeae6f74ee5364$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $19eeae6f74ee5364$var$_getEventFilterUrl(event);
    return !url ? false : (0, $3ded168be62470b2$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $19eeae6f74ee5364$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $19eeae6f74ee5364$var$_getEventFilterUrl(event);
    return !url ? true : (0, $3ded168be62470b2$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $19eeae6f74ee5364$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $bde2af06c0721643$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $19eeae6f74ee5364$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $19eeae6f74ee5364$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $19eeae6f74ee5364$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $19eeae6f74ee5364$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $1da1845d526a4969$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $bde2af06c0721643$export$16a28057038b10ef) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $fa8e8d8acc41a310$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $1da1845d526a4969$export$ecb76f41d43c0e43(client);
    $1da1845d526a4969$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $1da1845d526a4969$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $1da1845d526a4969$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $285fefa85e6899bb$var$WINDOW = (0, $8c000611b10ddc14$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $285fefa85e6899bb$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $285fefa85e6899bb$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $285fefa85e6899bb$var$WINDOW && !!$285fefa85e6899bb$var$WINDOW.history.pushState && !!$285fefa85e6899bb$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}





// We keep the handlers globally
const $4f224eef0fd97e12$var$handlers = {};
const $4f224eef0fd97e12$var$instrumented = {};
/** Add a handler function. */ function $4f224eef0fd97e12$export$a4e09611e30da72e(type, handler) {
    $4f224eef0fd97e12$var$handlers[type] = $4f224eef0fd97e12$var$handlers[type] || [];
    $4f224eef0fd97e12$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $4f224eef0fd97e12$export$b17eab759a1cb5fe() {
    Object.keys($4f224eef0fd97e12$var$handlers).forEach((key)=>{
        $4f224eef0fd97e12$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $4f224eef0fd97e12$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$4f224eef0fd97e12$var$instrumented[type]) {
        instrumentFn();
        $4f224eef0fd97e12$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $4f224eef0fd97e12$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $4f224eef0fd97e12$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e7355d6486215205$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $95cb566e529ce096$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


const $ea2feddc8f99ab63$var$WINDOW = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
let $ea2feddc8f99ab63$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ea2feddc8f99ab63$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $4f224eef0fd97e12$export$a4e09611e30da72e)(type, handler);
    (0, $4f224eef0fd97e12$export$e18d6c5462c01368)(type, $ea2feddc8f99ab63$var$instrumentHistory);
}
function $ea2feddc8f99ab63$var$instrumentHistory() {
    if (!(0, $285fefa85e6899bb$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $ea2feddc8f99ab63$var$WINDOW.onpopstate;
    $ea2feddc8f99ab63$var$WINDOW.onpopstate = function(...args) {
        const to = $ea2feddc8f99ab63$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $ea2feddc8f99ab63$var$lastHref;
        $ea2feddc8f99ab63$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $4f224eef0fd97e12$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $ea2feddc8f99ab63$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $ea2feddc8f99ab63$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $4f224eef0fd97e12$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)($ea2feddc8f99ab63$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)($ea2feddc8f99ab63$var$WINDOW.history, "replaceState", historyReplacementFunction);
}




// eslint-disable-next-line deprecation/deprecation
const $760edf8bbb06fab3$var$WINDOW = (0, $8c000611b10ddc14$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $760edf8bbb06fab3$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $760edf8bbb06fab3$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $760edf8bbb06fab3$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $760edf8bbb06fab3$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $760edf8bbb06fab3$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $760edf8bbb06fab3$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $760edf8bbb06fab3$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$760edf8bbb06fab3$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($760edf8bbb06fab3$export$18cf36ed71d733e7($760edf8bbb06fab3$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $760edf8bbb06fab3$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $760edf8bbb06fab3$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $e7355d6486215205$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $760edf8bbb06fab3$export$531055a6c684a70a() {
    return "ReportingObserver" in $760edf8bbb06fab3$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $760edf8bbb06fab3$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$760edf8bbb06fab3$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $6b9df3523dcb41cf$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $4608b21abbbf1c5b$export$31499a9cd224b78c)
            })),
        version: (0, $4608b21abbbf1c5b$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1acad3161cb11d68$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $1acad3161cb11d68$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $1acad3161cb11d68$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $1acad3161cb11d68$export$604a45d95a155e2b(envelope, types) {
    return $1acad3161cb11d68$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $1acad3161cb11d68$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $1acad3161cb11d68$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $1acad3161cb11d68$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $1acad3161cb11d68$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $35a80961bb361df7$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $1acad3161cb11d68$var$concatBuffers(parts);
}
function $1acad3161cb11d68$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $1acad3161cb11d68$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $1acad3161cb11d68$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $1acad3161cb11d68$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $1acad3161cb11d68$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    // TODO: This is a temporary workaround until we have a proper data category for metrics
    statsd: "unknown"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $1acad3161cb11d68$export$b11169581eeaf237(type) {
    return $1acad3161cb11d68$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $1acad3161cb11d68$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $1acad3161cb11d68$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f8f86f8015b1c1d3$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $c261a6f0a7a606e0$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $e88e342c3cc174a3$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $e88e342c3cc174a3$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $1acad3161cb11d68$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $f8f86f8015b1c1d3$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $1acad3161cb11d68$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $e88e342c3cc174a3$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $1acad3161cb11d68$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $e88e342c3cc174a3$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $1acad3161cb11d68$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $1acad3161cb11d68$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}







const $60aad032888f9cc2$export$ffbd59c90957aeda = "c";
const $60aad032888f9cc2$export$41106537ee4dbdd = "g";
const $60aad032888f9cc2$export$d2e7506772279f4e = "s";
const $60aad032888f9cc2$export$9818d6472d7991f0 = "d";
/**
 * Normalization regex for metric names and metric tag names.
 *
 * This enforces that names and tag keys only contain alphanumeric characters,
 * underscores, forward slashes, periods, and dashes.
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $60aad032888f9cc2$export$73db7eda248c6468 = /[^a-zA-Z0-9_/.-]+/g;
/**
 * Normalization regex for metric tag values.
 *
 * This enforces that values only contain words, digits, or the following
 * special characters: _:/@.{}[\]$-
 *
 * See: https://develop.sentry.dev/sdk/metrics/#normalization
 */ const $60aad032888f9cc2$export$2699a97e88d47e55 = /[^\w\d\s_:/@.{}[\]$-]+/g;
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ const $60aad032888f9cc2$export$9fcf9b73aae4b12 = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ const $60aad032888f9cc2$export$8f071e089fcfe0c = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ const $60aad032888f9cc2$export$aa41e9d920739c1a = 10000;


/**
 * Generate bucket key from metric properties.
 */ function $802103e6ab07930c$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $4f81a26afd00acb9$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $802103e6ab07930c$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $802103e6ab07930c$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/**
 * Sanitizes tags.
 */ function $802103e6ab07930c$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = key.replace((0, $60aad032888f9cc2$export$73db7eda248c6468), "_");
        tags[sanitizedKey] = String(unsanitizedTags[key]).replace((0, $60aad032888f9cc2$export$2699a97e88d47e55), "");
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $fcfded46e1bb12f9$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $f8f86f8015b1c1d3$export$44d472fbb931a776)(dsn);
    const item = $fcfded46e1bb12f9$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $1acad3161cb11d68$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $fcfded46e1bb12f9$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $802103e6ab07930c$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $650e462234d20c92$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $650e462234d20c92$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $f8f86f8015b1c1d3$export$128827c3562ec0cb)(options.dsn);
        else (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $82a1ccaba8b17eaf$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $8e0411c1e39b6e49$export$6de4ffac6a2f1098)(exception)) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log($650e462234d20c92$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $a7a440407ad76e9c$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $a7a440407ad76e9c$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $8e0411c1e39b6e49$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log($650e462234d20c92$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $ef9951805bf8afdb$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $4747a4c76d129580$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $7b807498fd0c5452$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $7b807498fd0c5452$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $e88e342c3cc174a3$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $1acad3161cb11d68$export$d650323442802f6f)(env, (0, $1acad3161cb11d68$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $e88e342c3cc174a3$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $fcfded46e1bb12f9$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $7b807498fd0c5452$export$51abed9797baa598)(this, integrations);
        (0, $7b807498fd0c5452$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $ef9951805bf8afdb$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $4747a4c76d129580$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $9c33807712fa1c9d$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $e424e8186a197aac$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $d404105fdf00f3e3$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $bde2af06c0721643$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $650e462234d20c92$var$isTransactionEvent(event);
        const isError = $650e462234d20c92$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $4747a4c76d129580$export$78e43115b553f358)(new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $650e462234d20c92$var$processBeforeSend(options, prepared, hint);
            return $650e462234d20c92$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("Error while sending event:", reason);
        });
        else (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $650e462234d20c92$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $a7a440407ad76e9c$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $a7a440407ad76e9c$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $a7a440407ad76e9c$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $650e462234d20c92$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($650e462234d20c92$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($650e462234d20c92$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $650e462234d20c92$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $650e462234d20c92$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $650e462234d20c92$export$9aac0b9f77928fbf(callback) {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $eaa4c2ed268b6e5e$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $b44690d12ec59e52$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $1acad3161cb11d68$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $4FDWC = parcelRequire("4FDWC");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $51dc5506a547d78a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $a59702b4a7d75b9f$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $a59702b4a7d75b9f$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $a59702b4a7d75b9f$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $a59702b4a7d75b9f$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $a7a440407ad76e9c$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $a59702b4a7d75b9f$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $35a80961bb361df7$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $a59702b4a7d75b9f$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $a59702b4a7d75b9f$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $a59702b4a7d75b9f$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $a59702b4a7d75b9f$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $a59702b4a7d75b9f$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $a59702b4a7d75b9f$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a59702b4a7d75b9f$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($a59702b4a7d75b9f$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a59702b4a7d75b9f$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $a59702b4a7d75b9f$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a59702b4a7d75b9f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $8e0411c1e39b6e49$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $4747a4c76d129580$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $a59702b4a7d75b9f$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $a59702b4a7d75b9f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $4747a4c76d129580$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $a59702b4a7d75b9f$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $a7a440407ad76e9c$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $a59702b4a7d75b9f$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $a7a440407ad76e9c$export$ef9e2056653f0c8e)(exception) || (0, $a7a440407ad76e9c$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $a59702b4a7d75b9f$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $a7a440407ad76e9c$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $a59702b4a7d75b9f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $8e0411c1e39b6e49$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $a7a440407ad76e9c$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $a59702b4a7d75b9f$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $a7a440407ad76e9c$export$53b83ca8eaab0383)(exception) || (0, $a7a440407ad76e9c$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $a59702b4a7d75b9f$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $8e0411c1e39b6e49$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a59702b4a7d75b9f$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $8e0411c1e39b6e49$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $8e0411c1e39b6e49$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $a59702b4a7d75b9f$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $a59702b4a7d75b9f$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $a7a440407ad76e9c$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $a59702b4a7d75b9f$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $4f81a26afd00acb9$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $a7a440407ad76e9c$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $a7a440407ad76e9c$export$9671ea99bd126ace)(exception)) {
        const className = $a59702b4a7d75b9f$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $a59702b4a7d75b9f$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}





const $67837210becc2ddc$export$56d8a8a25bd48b81 = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
let $67837210becc2ddc$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $67837210becc2ddc$export$b79738ab10c590b2() {
    return $67837210becc2ddc$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $67837210becc2ddc$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $67837210becc2ddc$var$ignoreOnError++;
    setTimeout(()=>{
        $67837210becc2ddc$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $67837210becc2ddc$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $4f81a26afd00acb9$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$67837210becc2ddc$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $67837210becc2ddc$export$1265a142ff5ba165();
            (0, $dbaa48b6af64d774$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $8e0411c1e39b6e49$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $8e0411c1e39b6e49$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $dbaa48b6af64d774$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $4f81a26afd00acb9$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $4f81a26afd00acb9$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $f2be44dae3aabc9a$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $f8f86f8015b1c1d3$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $f2be44dae3aabc9a$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $1acad3161cb11d68$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $f2be44dae3aabc9a$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $0ecf60cb4be3f8fc$export$1df9218a526d318d extends (0, $650e462234d20c92$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $4FDWC.getSDKSource)();
        (0, $6b9df3523dcb41cf$export$b9f95b027256052c)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document) (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $67837210becc2ddc$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $a59702b4a7d75b9f$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $a59702b4a7d75b9f$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $f2be44dae3aabc9a$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $eaa4c2ed268b6e5e$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $f8f86f8015b1c1d3$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $3d9d919d2542148e$var$WINDOW = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
const $3d9d919d2542148e$var$DEBOUNCE_DURATION = 1000;
let $3d9d919d2542148e$var$debounceTimerID;
let $3d9d919d2542148e$var$lastCapturedEventType;
let $3d9d919d2542148e$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d9d919d2542148e$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $4f224eef0fd97e12$export$a4e09611e30da72e)(type, handler);
    (0, $4f224eef0fd97e12$export$e18d6c5462c01368)(type, $3d9d919d2542148e$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $3d9d919d2542148e$export$3014bbf0af0e1d4a() {
    if (!$3d9d919d2542148e$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $4f224eef0fd97e12$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $3d9d919d2542148e$var$makeDOMEventHandler(triggerDOMHandler, true);
    $3d9d919d2542148e$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $3d9d919d2542148e$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $3d9d919d2542148e$var$WINDOW[target] && $3d9d919d2542148e$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $3d9d919d2542148e$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $3d9d919d2542148e$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $3d9d919d2542148e$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $3d9d919d2542148e$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $3d9d919d2542148e$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $3d9d919d2542148e$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $3d9d919d2542148e$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($3d9d919d2542148e$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $4f81a26afd00acb9$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $4f81a26afd00acb9$export$e73679ffaf56810e)(target, "_sentryId", (0, $8e0411c1e39b6e49$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$3d9d919d2542148e$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $3d9d919d2542148e$var$lastCapturedEventType = event.type;
            $3d9d919d2542148e$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($3d9d919d2542148e$var$debounceTimerID);
        $3d9d919d2542148e$var$debounceTimerID = $3d9d919d2542148e$var$WINDOW.setTimeout(()=>{
            $3d9d919d2542148e$var$lastCapturedEventTargetId = undefined;
            $3d9d919d2542148e$var$lastCapturedEventType = undefined;
        }, $3d9d919d2542148e$var$DEBOUNCE_DURATION);
    };
}
function $3d9d919d2542148e$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8427cde22a4f95fe$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $4f224eef0fd97e12$export$a4e09611e30da72e)(type, handler);
    (0, $4f224eef0fd97e12$export$e18d6c5462c01368)(type, $8427cde22a4f95fe$var$instrumentConsole);
}
function $8427cde22a4f95fe$var$instrumentConsole() {
    if (!("console" in (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1))) return;
    (0, $fa8e8d8acc41a310$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).console)) return;
        (0, $4f81a26afd00acb9$export$9563e054e6f787fb)((0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $fa8e8d8acc41a310$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $4f224eef0fd97e12$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $fa8e8d8acc41a310$export$77c4ce905194557b)[level];
                log && log.apply((0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $393ca4cf55d29319$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $4f224eef0fd97e12$export$a4e09611e30da72e)(type, handler);
    (0, $4f224eef0fd97e12$export$e18d6c5462c01368)(type, $393ca4cf55d29319$var$instrumentFetch);
}
function $393ca4cf55d29319$var$instrumentFetch() {
    if (!(0, $760edf8bbb06fab3$export$c82d238e23c40b21)()) return;
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)((0, $8c000611b10ddc14$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $393ca4cf55d29319$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $4f224eef0fd97e12$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $8c000611b10ddc14$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $4f224eef0fd97e12$export$b18c893e424d3127)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $4f224eef0fd97e12$export$b18c893e424d3127)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $393ca4cf55d29319$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $393ca4cf55d29319$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($393ca4cf55d29319$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $393ca4cf55d29319$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $393ca4cf55d29319$var$getUrlFromResource(url),
            method: $393ca4cf55d29319$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $393ca4cf55d29319$var$getUrlFromResource(arg),
        method: $393ca4cf55d29319$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}





const $85fd56d95444000b$var$WINDOW = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
const $85fd56d95444000b$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $85fd56d95444000b$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $4f224eef0fd97e12$export$a4e09611e30da72e)(type, handler);
    (0, $4f224eef0fd97e12$export$e18d6c5462c01368)(type, $85fd56d95444000b$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $85fd56d95444000b$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$85fd56d95444000b$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $a7a440407ad76e9c$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $85fd56d95444000b$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$85fd56d95444000b$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$85fd56d95444000b$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $4f224eef0fd97e12$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$85fd56d95444000b$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $a7a440407ad76e9c$export$844ec244b1367d54)(header) && (0, $a7a440407ad76e9c$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$85fd56d95444000b$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $4f224eef0fd97e12$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $85fd56d95444000b$var$parseUrl(url) {
    if ((0, $a7a440407ad76e9c$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $3b64804f5aea203a$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $3b64804f5aea203a$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $3b64804f5aea203a$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $3b64804f5aea203a$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $cb87d6c6fca94a68$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $cb87d6c6fca94a68$export$e01cef29b4327697(level) {
    return $cb87d6c6fca94a68$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $cb87d6c6fca94a68$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $cb87d6c6fca94a68$export$411d0ffdba845b6c.includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $cf5760c92822f4d2$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $cf5760c92822f4d2$var$INTEGRATION_NAME = "Breadcrumbs";
const $cf5760c92822f4d2$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $cf5760c92822f4d2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $8427cde22a4f95fe$export$1d6e0d073f9e6723)($cf5760c92822f4d2$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $3d9d919d2542148e$export$5aeffd3db2cf9df7)($cf5760c92822f4d2$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $85fd56d95444000b$export$26ace48dd54c9aea)($cf5760c92822f4d2$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $393ca4cf55d29319$export$f75d3c772c923df0)($cf5760c92822f4d2$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $ea2feddc8f99ab63$export$3f18c56c58114e75)($cf5760c92822f4d2$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $cf5760c92822f4d2$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $cf5760c92822f4d2$export$c079d904b326663a = (0, $7b807498fd0c5452$export$2323046b9414659f)($cf5760c92822f4d2$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $cf5760c92822f4d2$export$2dc68d50d56fbbd = (0, $7b807498fd0c5452$export$afa219bf23651160)($cf5760c92822f4d2$var$INTEGRATION_NAME, $cf5760c92822f4d2$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $cf5760c92822f4d2$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client) return;
        (0, $dbaa48b6af64d774$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $8e0411c1e39b6e49$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $cf5760c92822f4d2$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $cf5760c92822f4d2$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$cf5760c92822f4d2$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$cf5760c92822f4d2$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $cf5760c92822f4d2$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $cf5760c92822f4d2$var$_isEvent(event) ? event.target : event;
            target = (0, $987d30935b5a1a43$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $987d30935b5a1a43$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $dbaa48b6af64d774$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $cf5760c92822f4d2$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $cb87d6c6fca94a68$export$d771ef054122c30a)(handlerData.level),
            message: (0, $3ded168be62470b2$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $3ded168be62470b2$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $dbaa48b6af64d774$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $cf5760c92822f4d2$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $85fd56d95444000b$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $dbaa48b6af64d774$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $cf5760c92822f4d2$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $dbaa48b6af64d774$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $dbaa48b6af64d774$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $cf5760c92822f4d2$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $3b64804f5aea203a$export$7a5253c0f62e0150)((0, $67837210becc2ddc$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $3b64804f5aea203a$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $3b64804f5aea203a$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $dbaa48b6af64d774$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $cf5760c92822f4d2$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $4d7de9a46d0ee425$var$INTEGRATION_NAME = "Dedupe";
const $4d7de9a46d0ee425$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $4d7de9a46d0ee425$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($4d7de9a46d0ee425$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $4d7de9a46d0ee425$export$6d39aa44cd0c7567 = (0, $7b807498fd0c5452$export$2323046b9414659f)($4d7de9a46d0ee425$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4d7de9a46d0ee425$export$688d98c249d31ad3 = (0, $7b807498fd0c5452$export$afa219bf23651160)($4d7de9a46d0ee425$var$INTEGRATION_NAME, $4d7de9a46d0ee425$export$6d39aa44cd0c7567);
function $4d7de9a46d0ee425$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($4d7de9a46d0ee425$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($4d7de9a46d0ee425$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $4d7de9a46d0ee425$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$4d7de9a46d0ee425$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$4d7de9a46d0ee425$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $4d7de9a46d0ee425$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $4d7de9a46d0ee425$var$_getExceptionFromEvent(previousEvent);
    const currentException = $4d7de9a46d0ee425$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$4d7de9a46d0ee425$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$4d7de9a46d0ee425$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $4d7de9a46d0ee425$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $4d7de9a46d0ee425$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $4d7de9a46d0ee425$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $4d7de9a46d0ee425$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $4d7de9a46d0ee425$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $4d7de9a46d0ee425$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}





let $f5dc47c9a4257aae$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f5dc47c9a4257aae$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $4f224eef0fd97e12$export$a4e09611e30da72e)(type, handler);
    (0, $4f224eef0fd97e12$export$e18d6c5462c01368)(type, $f5dc47c9a4257aae$var$instrumentError);
}
function $f5dc47c9a4257aae$var$instrumentError() {
    $f5dc47c9a4257aae$var$_oldOnErrorHandler = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).onerror;
    (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $4f224eef0fd97e12$export$b18c893e424d3127)("error", handlerData);
        if ($f5dc47c9a4257aae$var$_oldOnErrorHandler && !$f5dc47c9a4257aae$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $f5dc47c9a4257aae$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $06bfcd06ab0bcd86$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $06bfcd06ab0bcd86$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $4f224eef0fd97e12$export$a4e09611e30da72e)(type, handler);
    (0, $4f224eef0fd97e12$export$e18d6c5462c01368)(type, $06bfcd06ab0bcd86$var$instrumentUnhandledRejection);
}
function $06bfcd06ab0bcd86$var$instrumentUnhandledRejection() {
    $06bfcd06ab0bcd86$var$_oldOnUnhandledRejectionHandler = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $4f224eef0fd97e12$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($06bfcd06ab0bcd86$var$_oldOnUnhandledRejectionHandler && !$06bfcd06ab0bcd86$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $06bfcd06ab0bcd86$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $9888c56b0ad0b319$var$INTEGRATION_NAME = "GlobalHandlers";
const $9888c56b0ad0b319$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $9888c56b0ad0b319$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $9888c56b0ad0b319$var$_installGlobalOnErrorHandler(client);
                $9888c56b0ad0b319$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $9888c56b0ad0b319$var$_installGlobalOnUnhandledRejectionHandler(client);
                $9888c56b0ad0b319$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $9888c56b0ad0b319$export$66acc70e8cf2b71a = (0, $7b807498fd0c5452$export$2323046b9414659f)($9888c56b0ad0b319$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9888c56b0ad0b319$export$204155decbc90e5a = (0, $7b807498fd0c5452$export$afa219bf23651160)($9888c56b0ad0b319$var$INTEGRATION_NAME, $9888c56b0ad0b319$export$66acc70e8cf2b71a);
function $9888c56b0ad0b319$var$_installGlobalOnErrorHandler(client) {
    (0, $f5dc47c9a4257aae$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9888c56b0ad0b319$var$getOptions();
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client || (0, $67837210becc2ddc$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $a7a440407ad76e9c$export$844ec244b1367d54)(msg) ? $9888c56b0ad0b319$var$_eventFromIncompleteOnError(msg, url, line, column) : $9888c56b0ad0b319$var$_enhanceEventWithInitialFrame((0, $a59702b4a7d75b9f$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $dbaa48b6af64d774$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $9888c56b0ad0b319$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $06bfcd06ab0bcd86$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9888c56b0ad0b319$var$getOptions();
        if ((0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)() !== client || (0, $67837210becc2ddc$export$b79738ab10c590b2)()) return;
        const error = $9888c56b0ad0b319$var$_getUnhandledRejectionError(e);
        const event = (0, $a7a440407ad76e9c$export$c3825b437cbdea5c)(error) ? $9888c56b0ad0b319$var$_eventFromRejectionWithPrimitive(error) : (0, $a59702b4a7d75b9f$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $dbaa48b6af64d774$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $9888c56b0ad0b319$var$_getUnhandledRejectionError(error) {
    if ((0, $a7a440407ad76e9c$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9888c56b0ad0b319$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9888c56b0ad0b319$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $a7a440407ad76e9c$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $9888c56b0ad0b319$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9888c56b0ad0b319$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $a7a440407ad76e9c$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $987d30935b5a1a43$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $9888c56b0ad0b319$var$globalHandlerLog(type) {
    (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $9888c56b0ad0b319$var$getOptions() {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $da7c787d486b8899$var$INTEGRATION_NAME = "HttpContext";
const $da7c787d486b8899$var$_httpContextIntegration = ()=>{
    return {
        name: $da7c787d486b8899$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $67837210becc2ddc$export$56d8a8a25bd48b81).navigator && !(0, $67837210becc2ddc$export$56d8a8a25bd48b81).location && !(0, $67837210becc2ddc$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $67837210becc2ddc$export$56d8a8a25bd48b81).location && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $da7c787d486b8899$export$1378794447170364 = (0, $7b807498fd0c5452$export$2323046b9414659f)($da7c787d486b8899$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $da7c787d486b8899$export$5d2ee9a544b09a94 = (0, $7b807498fd0c5452$export$afa219bf23651160)($da7c787d486b8899$var$INTEGRATION_NAME, $da7c787d486b8899$export$1378794447170364);





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $ffb0b47ea671a891$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $a7a440407ad76e9c$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $ffb0b47ea671a891$var$truncateAggregateExceptions($ffb0b47ea671a891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $ffb0b47ea671a891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $a7a440407ad76e9c$export$49034edbe6b62415)(error[key], Error)) {
        $ffb0b47ea671a891$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $ffb0b47ea671a891$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $ffb0b47ea671a891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $a7a440407ad76e9c$export$49034edbe6b62415)(childError, Error)) {
            $ffb0b47ea671a891$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $ffb0b47ea671a891$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $ffb0b47ea671a891$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $ffb0b47ea671a891$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $ffb0b47ea671a891$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $ffb0b47ea671a891$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $3ded168be62470b2$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $02d36478718dedcc$var$DEFAULT_KEY = "cause";
const $02d36478718dedcc$var$DEFAULT_LIMIT = 5;
const $02d36478718dedcc$var$INTEGRATION_NAME = "LinkedErrors";
const $02d36478718dedcc$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $02d36478718dedcc$var$DEFAULT_LIMIT;
    const key = options.key || $02d36478718dedcc$var$DEFAULT_KEY;
    return {
        name: $02d36478718dedcc$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $ffb0b47ea671a891$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $a59702b4a7d75b9f$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $02d36478718dedcc$export$ebabb00eb7f3a395 = (0, $7b807498fd0c5452$export$2323046b9414659f)($02d36478718dedcc$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $02d36478718dedcc$export$8d1e60aaf616fb4f = (0, $7b807498fd0c5452$export$afa219bf23651160)($02d36478718dedcc$var$INTEGRATION_NAME, $02d36478718dedcc$export$ebabb00eb7f3a395);





const $58e9cb642f2241a0$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $58e9cb642f2241a0$var$INTEGRATION_NAME = "TryCatch";
const $58e9cb642f2241a0$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $58e9cb642f2241a0$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $4f81a26afd00acb9$export$9563e054e6f787fb)((0, $67837210becc2ddc$export$56d8a8a25bd48b81), "setTimeout", $58e9cb642f2241a0$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $4f81a26afd00acb9$export$9563e054e6f787fb)((0, $67837210becc2ddc$export$56d8a8a25bd48b81), "setInterval", $58e9cb642f2241a0$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $4f81a26afd00acb9$export$9563e054e6f787fb)((0, $67837210becc2ddc$export$56d8a8a25bd48b81), "requestAnimationFrame", $58e9cb642f2241a0$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $67837210becc2ddc$export$56d8a8a25bd48b81)) (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $58e9cb642f2241a0$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $58e9cb642f2241a0$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($58e9cb642f2241a0$var$_wrapEventTarget);
            }
        }
    };
};
const $58e9cb642f2241a0$export$59bfe9f1c76150e = (0, $7b807498fd0c5452$export$2323046b9414659f)($58e9cb642f2241a0$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $58e9cb642f2241a0$export$f1a018517668e6d3 = (0, $7b807498fd0c5452$export$afa219bf23651160)($58e9cb642f2241a0$var$INTEGRATION_NAME, $58e9cb642f2241a0$export$59bfe9f1c76150e);
function $58e9cb642f2241a0$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $67837210becc2ddc$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $95cb566e529ce096$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $58e9cb642f2241a0$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $67837210becc2ddc$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $95cb566e529ce096$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $58e9cb642f2241a0$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $95cb566e529ce096$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $4f81a26afd00acb9$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $95cb566e529ce096$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $67837210becc2ddc$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $58e9cb642f2241a0$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $67837210becc2ddc$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $67837210becc2ddc$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $95cb566e529ce096$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $67837210becc2ddc$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $95cb566e529ce096$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $dd8932ad5055e55e$var$UNKNOWN_FUNCTION = "?";
const $dd8932ad5055e55e$var$OPERA10_PRIORITY = 10;
const $dd8932ad5055e55e$var$OPERA11_PRIORITY = 20;
const $dd8932ad5055e55e$var$CHROME_PRIORITY = 30;
const $dd8932ad5055e55e$var$WINJS_PRIORITY = 40;
const $dd8932ad5055e55e$var$GECKO_PRIORITY = 50;
function $dd8932ad5055e55e$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $dd8932ad5055e55e$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $dd8932ad5055e55e$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $dd8932ad5055e55e$var$chromeStackParserFn = (line)=>{
    const parts = $dd8932ad5055e55e$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $dd8932ad5055e55e$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $dd8932ad5055e55e$var$extractSafariExtensionDetails(parts[1] || $dd8932ad5055e55e$var$UNKNOWN_FUNCTION, parts[2]);
        return $dd8932ad5055e55e$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $dd8932ad5055e55e$export$263a749fff749872 = [
    $dd8932ad5055e55e$var$CHROME_PRIORITY,
    $dd8932ad5055e55e$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $dd8932ad5055e55e$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $dd8932ad5055e55e$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $dd8932ad5055e55e$var$gecko = (line)=>{
    const parts = $dd8932ad5055e55e$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $dd8932ad5055e55e$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $dd8932ad5055e55e$var$UNKNOWN_FUNCTION;
        [func, filename] = $dd8932ad5055e55e$var$extractSafariExtensionDetails(func, filename);
        return $dd8932ad5055e55e$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $dd8932ad5055e55e$export$cdba47a5dd2804d = [
    $dd8932ad5055e55e$var$GECKO_PRIORITY,
    $dd8932ad5055e55e$var$gecko
];
const $dd8932ad5055e55e$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $dd8932ad5055e55e$var$winjs = (line)=>{
    const parts = $dd8932ad5055e55e$var$winjsRegex.exec(line);
    return parts ? $dd8932ad5055e55e$var$createFrame(parts[2], parts[1] || $dd8932ad5055e55e$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $dd8932ad5055e55e$export$179460296da408e8 = [
    $dd8932ad5055e55e$var$WINJS_PRIORITY,
    $dd8932ad5055e55e$var$winjs
];
const $dd8932ad5055e55e$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $dd8932ad5055e55e$var$opera10 = (line)=>{
    const parts = $dd8932ad5055e55e$var$opera10Regex.exec(line);
    return parts ? $dd8932ad5055e55e$var$createFrame(parts[2], parts[3] || $dd8932ad5055e55e$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $dd8932ad5055e55e$export$f892b52c880ffc7a = [
    $dd8932ad5055e55e$var$OPERA10_PRIORITY,
    $dd8932ad5055e55e$var$opera10
];
const $dd8932ad5055e55e$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $dd8932ad5055e55e$var$opera11 = (line)=>{
    const parts = $dd8932ad5055e55e$var$opera11Regex.exec(line);
    return parts ? $dd8932ad5055e55e$var$createFrame(parts[5], parts[3] || parts[4] || $dd8932ad5055e55e$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $dd8932ad5055e55e$export$af11af13f09fb0dc = [
    $dd8932ad5055e55e$var$OPERA11_PRIORITY,
    $dd8932ad5055e55e$var$opera11
];
const $dd8932ad5055e55e$export$7197c0fe6554c079 = [
    $dd8932ad5055e55e$export$263a749fff749872,
    $dd8932ad5055e55e$export$cdba47a5dd2804d,
    $dd8932ad5055e55e$export$179460296da408e8
];
const $dd8932ad5055e55e$export$2b2b997d81bf3907 = (0, $95cb566e529ce096$export$a5739666fb2d03d4)(...$dd8932ad5055e55e$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $dd8932ad5055e55e$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $dd8932ad5055e55e$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $abdb270ed536ed67$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $abdb270ed536ed67$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $abdb270ed536ed67$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $abdb270ed536ed67$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $abdb270ed536ed67$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $abdb270ed536ed67$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $abdb270ed536ed67$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $abdb270ed536ed67$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $0a566e2c1f122273$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $4747a4c76d129580$export$78e43115b553f358)(new (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $4747a4c76d129580$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $4747a4c76d129580$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $439284286ec7ac6f$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $439284286ec7ac6f$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $0a566e2c1f122273$export$85a4f67f852183e6)(options.bufferSize || $439284286ec7ac6f$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $1acad3161cb11d68$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $1acad3161cb11d68$export$b11169581eeaf237)(type);
            if ((0, $abdb270ed536ed67$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $439284286ec7ac6f$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $4747a4c76d129580$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $1acad3161cb11d68$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $1acad3161cb11d68$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $439284286ec7ac6f$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $1acad3161cb11d68$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $1acad3161cb11d68$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $abdb270ed536ed67$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $c261a6f0a7a606e0$export$5949942ba2a7c0e2)) {
                (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $4747a4c76d129580$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $439284286ec7ac6f$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}






let $fdde9e7b71e8f52d$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $fdde9e7b71e8f52d$export$8be2119ce08e3379() {
    if ($fdde9e7b71e8f52d$var$cachedFetchImpl) return $fdde9e7b71e8f52d$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $760edf8bbb06fab3$export$18cf36ed71d733e7)((0, $67837210becc2ddc$export$56d8a8a25bd48b81).fetch)) return $fdde9e7b71e8f52d$var$cachedFetchImpl = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).fetch.bind((0, $67837210becc2ddc$export$56d8a8a25bd48b81));
    const document = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $fdde9e7b71e8f52d$var$cachedFetchImpl = fetchImpl.bind((0, $67837210becc2ddc$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $fdde9e7b71e8f52d$export$d499686d2dd738c6() {
    $fdde9e7b71e8f52d$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $844cd801ff0a9745$export$b2311068c46d7cc8(options, nativeFetch = (0, $fdde9e7b71e8f52d$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $fdde9e7b71e8f52d$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $4747a4c76d129580$export$78e43115b553f358)(e);
        }
    }
    return (0, $439284286ec7ac6f$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $e21193d488a9b475$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $e21193d488a9b475$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $4747a4c76d129580$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $e21193d488a9b475$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $439284286ec7ac6f$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $6aae8890e6743536$export$5ef831fccfce35e5 = [
    (0, $19eeae6f74ee5364$export$cb3c5c2ceb9818ba)(),
    (0, $3ede77ad8b2617c4$export$7918117e9202e4fb)(),
    (0, $58e9cb642f2241a0$export$59bfe9f1c76150e)(),
    (0, $cf5760c92822f4d2$export$c079d904b326663a)(),
    (0, $9888c56b0ad0b319$export$66acc70e8cf2b71a)(),
    (0, $02d36478718dedcc$export$ebabb00eb7f3a395)(),
    (0, $4d7de9a46d0ee425$export$6d39aa44cd0c7567)(),
    (0, $da7c787d486b8899$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $6aae8890e6743536$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$6aae8890e6743536$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $6aae8890e6743536$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $6aae8890e6743536$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $67837210becc2ddc$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $95cb566e529ce096$export$1d5cf88b347146d4)(options.stackParser || (0, $dd8932ad5055e55e$export$2b2b997d81bf3907)),
        integrations: (0, $7b807498fd0c5452$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $760edf8bbb06fab3$export$edf3cb81fd7d2a3e)() ? (0, $844cd801ff0a9745$export$b2311068c46d7cc8) : (0, $e21193d488a9b475$export$5e1441cee30d5a39))
    };
    (0, $1da1845d526a4969$export$5333c3f1c58d9bc1)((0, $0ecf60cb4be3f8fc$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $6aae8890e6743536$var$startSessionTracking();
}
const $6aae8890e6743536$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $67837210becc2ddc$export$56d8a8a25bd48b81).document) {
        (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    // TODO(v8): Remove this entire if statement. `eventId` will be a required option.
    // eslint-disable-next-line deprecation/deprecation
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $82a1ccaba8b17eaf$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $67837210becc2ddc$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $67837210becc2ddc$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document.head || (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $6aae8890e6743536$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $6aae8890e6743536$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6aae8890e6743536$export$4997ffc0176396a6(fn) {
    return (0, $67837210becc2ddc$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $6aae8890e6743536$var$startSessionTracking() {
    if (typeof (0, $67837210becc2ddc$export$56d8a8a25bd48b81).document === "undefined") {
        (0, $51dc5506a547d78a$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $dbaa48b6af64d774$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $dbaa48b6af64d774$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $ea2feddc8f99ab63$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $dbaa48b6af64d774$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $dbaa48b6af64d774$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $6aae8890e6743536$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $47b105bf0f2247b7$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $6b9df3523dcb41cf$export$b9f95b027256052c)(opts, "react");
    (0, $6aae8890e6743536$export$2cd8252107eb640b)(opts);
}









/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ function $409fa067a29db8cd$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $409fa067a29db8cd$export$8e9a29865c0a1226 = (0, $b93579c61bd25af0$export$8e9a29865c0a1226);


let $ac70934bdfa86eff$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $ac70934bdfa86eff$export$637857c1d87b640c() {
    if ($ac70934bdfa86eff$var$errorsInstrumented) return;
    $ac70934bdfa86eff$var$errorsInstrumented = true;
    (0, $f5dc47c9a4257aae$export$55b5c3ba2194f0c6)($ac70934bdfa86eff$var$errorCallback);
    (0, $06bfcd06ab0bcd86$export$8bf4fc6858821a4e)($ac70934bdfa86eff$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $ac70934bdfa86eff$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $409fa067a29db8cd$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$ac70934bdfa86eff$var$errorCallback.tag = "sentry_tracingErrorCallback";




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $01152a5dcf3b702c$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $01152a5dcf3b702c$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $01152a5dcf3b702c$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $a7a440407ad76e9c$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $2d4efe7dc74c5c45$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $6e4ea71dfdcc0bfd$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
    const scope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $6e4ea71dfdcc0bfd$var$normalizeContext(context);
    const activeSpan = $6e4ea71dfdcc0bfd$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $01152a5dcf3b702c$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus("internal_error");
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6e4ea71dfdcc0bfd$export$a1bd95187356f372(context, callback) {
    const spanContext = $6e4ea71dfdcc0bfd$var$normalizeContext(context);
    return (0, $9c33807712fa1c9d$export$70d775fb1f267027)(()=>{
        return (0, $dbaa48b6af64d774$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6e4ea71dfdcc0bfd$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $01152a5dcf3b702c$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $3c6c3464b56596d8$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $6e4ea71dfdcc0bfd$export$cb9e396e6b90b703 = $6e4ea71dfdcc0bfd$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6e4ea71dfdcc0bfd$export$c10292ad04b92aea(context, callback) {
    const spanContext = $6e4ea71dfdcc0bfd$var$normalizeContext(context);
    return (0, $9c33807712fa1c9d$export$70d775fb1f267027)(()=>{
        return (0, $dbaa48b6af64d774$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $6e4ea71dfdcc0bfd$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $01152a5dcf3b702c$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $3c6c3464b56596d8$export$92d8c23565496537)(activeSpan);
                    if (!status || status === "ok") activeSpan.setStatus("internal_error");
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $6e4ea71dfdcc0bfd$export$63dbba021a6b4047(context) {
    if (!(0, $2d4efe7dc74c5c45$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $6e4ea71dfdcc0bfd$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $6e4ea71dfdcc0bfd$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $6e4ea71dfdcc0bfd$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $6e4ea71dfdcc0bfd$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)().getSpan();
}
const $6e4ea71dfdcc0bfd$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $b93579c61bd25af0$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $bde2af06c0721643$export$16a28057038b10ef) && traceparentData) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $9c33807712fa1c9d$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $6e4ea71dfdcc0bfd$var$createChildSpanOrTransaction(hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $2d4efe7dc74c5c45$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $9c33807712fa1c9d$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $d404105fdf00f3e3$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $3c6c3464b56596d8$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $6e4ea71dfdcc0bfd$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $6e4ea71dfdcc0bfd$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $3c6c3464b56596d8$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $6e4ea71dfdcc0bfd$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $6e4ea71dfdcc0bfd$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
function $6e4ea71dfdcc0bfd$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $4f81a26afd00acb9$export$e73679ffaf56810e)(span, $6e4ea71dfdcc0bfd$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $4f81a26afd00acb9$export$e73679ffaf56810e)(span, $6e4ea71dfdcc0bfd$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $6e4ea71dfdcc0bfd$export$c08fbc656a245d03(span) {
    return {
        scope: span[$6e4ea71dfdcc0bfd$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$6e4ea71dfdcc0bfd$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $112ea2f29b0a852c$var$SPAN_METRIC_SUMMARY;
function $112ea2f29b0a852c$var$getMetricStorageForSpan(span) {
    return $112ea2f29b0a852c$var$SPAN_METRIC_SUMMARY ? $112ea2f29b0a852c$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $112ea2f29b0a852c$export$2e7205e45c58797d(span) {
    const storage = $112ea2f29b0a852c$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $4f81a26afd00acb9$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $112ea2f29b0a852c$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $6e4ea71dfdcc0bfd$export$1be426a8e585c83e)();
    if (span) {
        const storage = $112ea2f29b0a852c$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$112ea2f29b0a852c$var$SPAN_METRIC_SUMMARY) $112ea2f29b0a852c$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $112ea2f29b0a852c$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $96dae9fbf54762e8$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $96dae9fbf54762e8$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $96dae9fbf54762e8$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $96dae9fbf54762e8$export$cca8dd30f57f805e = "sentry.origin";
/**
 * The id of the profile that this span occured in.
 */ const $96dae9fbf54762e8$export$1efec95406bbe327 = "profile_id";




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $1301771f54e43546$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = "ok";
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = "deadline_exceeded";
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = "unauthenticated";
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = "permission_denied";
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = "not_found";
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = "resource_exhausted";
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = "invalid_argument";
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = "unimplemented";
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = "unavailable";
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = "internal_error";
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = "unknown_error";
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = "cancelled";
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = "already_exists";
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = "failed_precondition";
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = "aborted";
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = "out_of_range";
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = "data_loss";
    SpanStatus["DataLoss"] = DataLoss;
})($1301771f54e43546$export$beb8e6a823e89c5d || ($1301771f54e43546$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $1301771f54e43546$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $1301771f54e43546$export$ac65c70d78fcdb55 = $1301771f54e43546$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $1301771f54e43546$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag("http.status_code", String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData("http.response.status_code", httpStatus);
    const spanStatus = $1301771f54e43546$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== "unknown_error") span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $b8a9b349dba88a1c$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $b8a9b349dba88a1c$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $b44690d12ec59e52$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || "sentry";
        this._attributes = {};
        this.setAttributes({
            [(0, $96dae9fbf54762e8$export$cca8dd30f57f805e)]: spanContext.origin || "manual",
            [(0, $96dae9fbf54762e8$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || "";
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $96dae9fbf54762e8$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $96dae9fbf54762e8$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $96dae9fbf54762e8$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $96dae9fbf54762e8$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $3c6c3464b56596d8$export$eb571cd9b5d98de8) : (0, $3c6c3464b56596d8$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $b8a9b349dba88a1c$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $91673f51e515ea64$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $bde2af06c0721643$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = (0, $3c6c3464b56596d8$export$92d8c23565496537)(childSpan).description || "< unknown name >";
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $1301771f54e43546$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === "ok";
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $91673f51e515ea64$export$c4c6a79b1260ca1b)(this);
        if ((0, $bde2af06c0721643$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this._endTime = (0, $3c6c3464b56596d8$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $3c6c3464b56596d8$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $3c6c3464b56596d8$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $96dae9fbf54762e8$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $96dae9fbf54762e8$export$cca8dd30f57f805e],
            _metrics_summary: (0, $112ea2f29b0a852c$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $96dae9fbf54762e8$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $f3785279e21850ac$export$febc5573c75cefb0 extends (0, $b8a9b349dba88a1c$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: "custom",
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $96dae9fbf54762e8$export$d7a7d984b0791405] && {
                source: this._attributes[0, $96dae9fbf54762e8$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $96dae9fbf54762e8$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $96dae9fbf54762e8$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = "custom") {
        this._name = name;
        this.setAttribute((0, $96dae9fbf54762e8$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $b8a9b349dba88a1c$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $3c6c3464b56596d8$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $d404105fdf00f3e3$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts["profile"] !== undefined) return this._contexts["profile"].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $3c6c3464b56596d8$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $3c6c3464b56596d8$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $6e4ea71dfdcc0bfd$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $3c6c3464b56596d8$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $d404105fdf00f3e3$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $112ea2f29b0a852c$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $8e8ced41294f62be$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $8e8ced41294f62be$var$FINISH_REASON_TAG = "finishReason";
const $8e8ced41294f62be$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $8e8ced41294f62be$export$370d6113c18ba86c extends (0, $b8a9b349dba88a1c$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $3c6c3464b56596d8$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $8e8ced41294f62be$export$b279e6bd7040371f extends (0, $f3785279e21850ac$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $8e8ced41294f62be$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $8e8ced41294f62be$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $8e8ced41294f62be$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $8e8ced41294f62be$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $8e8ced41294f62be$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $3c6c3464b56596d8$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === "ui.action.click") this.setAttribute($8e8ced41294f62be$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $3c6c3464b56596d8$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus("cancelled");
                    span.end(endTimestampInS);
                    (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $3c6c3464b56596d8$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $bde2af06c0721643$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $8e8ced41294f62be$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $8e8ced41294f62be$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] Received finish signal for idle transaction.");
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $8e8ced41294f62be$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $b44690d12ec59e52$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $8e8ced41294f62be$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
                this.setStatus("deadline_exceeded");
                this._finishReason = $8e8ced41294f62be$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $dc3f546e63db4684$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $2d4efe7dc74c5c45$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $96dae9fbf54762e8$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $96dae9fbf54762e8$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $96dae9fbf54762e8$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $96dae9fbf54762e8$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$dc3f546e63db4684$export$2603c8d332a51c42(sampleRate)) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $bde2af06c0721643$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $3c6c3464b56596d8$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $dc3f546e63db4684$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $a7a440407ad76e9c$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ function $72990ff5ee5b53d0$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": (0, $3c6c3464b56596d8$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $72990ff5ee5b53d0$var$_startTransaction(transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $bde2af06c0721643$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $f3785279e21850ac$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $dc3f546e63db4684$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $72990ff5ee5b53d0$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $8e8ced41294f62be$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $dc3f546e63db4684$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $72990ff5ee5b53d0$export$653d0ef2bad9cdf9() {
    const carrier = (0, $9c33807712fa1c9d$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $72990ff5ee5b53d0$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $72990ff5ee5b53d0$var$traceHeaders;
    (0, $ac70934bdfa86eff$export$637857c1d87b640c)();
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c97b186cc9b0f0a6$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






const $2cc2c52a42990302$export$56d8a8a25bd48b81 = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $2ff167fd1293372c$export$6f18f55521af71a1() {
    if ((0, $2cc2c52a42990302$export$56d8a8a25bd48b81) && (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document) (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $409fa067a29db8cd$export$a7feb32fdd923295)();
        if ((0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            const { op: op, status: status } = (0, $3c6c3464b56596d8$export$92d8c23565496537)(activeTransaction);
            (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.end();
        }
    });
    else (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




const $7796788c5ccb5c56$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $a2cf55ad9e69e0a8$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $77a51a8135763218$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $77a51a8135763218$export$6431553786c94949 = ()=>{
    if ((0, $2cc2c52a42990302$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $77a51a8135763218$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5b144b31b1afa7da$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $77a51a8135763218$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0c91bf84b1c36115$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $77a51a8135763218$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.prerendering || (0, $5b144b31b1afa7da$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $a2cf55ad9e69e0a8$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $647daf5381ebe2e8$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $261bbd478ff47d03$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $e0304c6799c0ccf0$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $0c91bf84b1c36115$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $647daf5381ebe2e8$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $7796788c5ccb5c56$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $261bbd478ff47d03$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $d294dc2b59cca4cf$var$firstHiddenTime = -1;
const $d294dc2b59cca4cf$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $d294dc2b59cca4cf$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $261bbd478ff47d03$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $d294dc2b59cca4cf$var$firstHiddenTime = timeStamp;
    }, true);
};
const $d294dc2b59cca4cf$export$443f86b2c77012c4 = ()=>{
    if ($d294dc2b59cca4cf$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $d294dc2b59cca4cf$var$firstHiddenTime = $d294dc2b59cca4cf$var$initHiddenTime();
        $d294dc2b59cca4cf$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $d294dc2b59cca4cf$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $6d987a3a7be85228$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $d294dc2b59cca4cf$export$443f86b2c77012c4)();
    const metric = (0, $0c91bf84b1c36115$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $647daf5381ebe2e8$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $7796788c5ccb5c56$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $261bbd478ff47d03$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $87ffa268ff3cf829$var$interactionCountEstimate = 0;
let $87ffa268ff3cf829$var$minKnownInteractionId = Infinity;
let $87ffa268ff3cf829$var$maxKnownInteractionId = 0;
const $87ffa268ff3cf829$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $87ffa268ff3cf829$var$minKnownInteractionId = Math.min($87ffa268ff3cf829$var$minKnownInteractionId, e.interactionId);
            $87ffa268ff3cf829$var$maxKnownInteractionId = Math.max($87ffa268ff3cf829$var$maxKnownInteractionId, e.interactionId);
            $87ffa268ff3cf829$var$interactionCountEstimate = $87ffa268ff3cf829$var$maxKnownInteractionId ? ($87ffa268ff3cf829$var$maxKnownInteractionId - $87ffa268ff3cf829$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $87ffa268ff3cf829$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $87ffa268ff3cf829$export$8a962f2683a476d1 = ()=>{
    return $87ffa268ff3cf829$var$po ? $87ffa268ff3cf829$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $87ffa268ff3cf829$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $87ffa268ff3cf829$var$po) return;
    $87ffa268ff3cf829$var$po = (0, $647daf5381ebe2e8$export$d1203567a167490e)("event", $87ffa268ff3cf829$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $5dbaa80b173e24f7$var$getInteractionCountForNavigation = ()=>{
    return (0, $87ffa268ff3cf829$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $5dbaa80b173e24f7$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $5dbaa80b173e24f7$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $5dbaa80b173e24f7$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $5dbaa80b173e24f7$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $5dbaa80b173e24f7$var$longestInteractionList[$5dbaa80b173e24f7$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $5dbaa80b173e24f7$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $5dbaa80b173e24f7$var$longestInteractionList.length < $5dbaa80b173e24f7$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $5dbaa80b173e24f7$var$longestInteractionMap[interaction.id] = interaction;
            $5dbaa80b173e24f7$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $5dbaa80b173e24f7$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $5dbaa80b173e24f7$var$longestInteractionList.splice($5dbaa80b173e24f7$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $5dbaa80b173e24f7$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $5dbaa80b173e24f7$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($5dbaa80b173e24f7$var$longestInteractionList.length - 1, Math.floor($5dbaa80b173e24f7$var$getInteractionCountForNavigation() / 50));
    return $5dbaa80b173e24f7$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $5dbaa80b173e24f7$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $87ffa268ff3cf829$export$67d90cda6b78a2eb)();
    const metric = (0, $0c91bf84b1c36115$export$3c29b44508a0612b)("INP");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $5dbaa80b173e24f7$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === "first-input") {
                const noMatchingEntry = !$5dbaa80b173e24f7$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $5dbaa80b173e24f7$var$processEntry(entry);
            }
        });
        const inp = $5dbaa80b173e24f7$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $647daf5381ebe2e8$export$d1203567a167490e)("event", handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $7796788c5ccb5c56$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: "first-input",
            buffered: true
        });
        (0, $261bbd478ff47d03$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $5dbaa80b173e24f7$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b3aadb94d60f95cf$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $b3aadb94d60f95cf$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $d294dc2b59cca4cf$export$443f86b2c77012c4)();
    const metric = (0, $0c91bf84b1c36115$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $5b144b31b1afa7da$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $647daf5381ebe2e8$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $7796788c5ccb5c56$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$b3aadb94d60f95cf$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $b3aadb94d60f95cf$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $261bbd478ff47d03$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};



const $673eae9aafa78d9e$var$handlers = {};
const $673eae9aafa78d9e$var$instrumented = {};
let $673eae9aafa78d9e$var$_previousCls;
let $673eae9aafa78d9e$var$_previousFid;
let $673eae9aafa78d9e$var$_previousLcp;
let $673eae9aafa78d9e$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $673eae9aafa78d9e$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $673eae9aafa78d9e$var$addMetricObserver("cls", callback, $673eae9aafa78d9e$var$instrumentCls, $673eae9aafa78d9e$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $673eae9aafa78d9e$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $673eae9aafa78d9e$var$addMetricObserver("lcp", callback, $673eae9aafa78d9e$var$instrumentLcp, $673eae9aafa78d9e$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $673eae9aafa78d9e$export$2707d7471c0b918f(callback) {
    return $673eae9aafa78d9e$var$addMetricObserver("fid", callback, $673eae9aafa78d9e$var$instrumentFid, $673eae9aafa78d9e$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $673eae9aafa78d9e$export$da3b76aa2022cbd7(callback) {
    return $673eae9aafa78d9e$var$addMetricObserver("inp", callback, $673eae9aafa78d9e$var$instrumentInp, $673eae9aafa78d9e$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $673eae9aafa78d9e$export$69816c1a049f8db6(type, callback) {
    $673eae9aafa78d9e$var$addHandler(type, callback);
    if (!$673eae9aafa78d9e$var$instrumented[type]) {
        $673eae9aafa78d9e$var$instrumentPerformanceObserver(type);
        $673eae9aafa78d9e$var$instrumented[type] = true;
    }
    return $673eae9aafa78d9e$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $673eae9aafa78d9e$var$triggerHandlers(type, data) {
    const typeHandlers = $673eae9aafa78d9e$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $95cb566e529ce096$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $673eae9aafa78d9e$var$instrumentCls() {
    return (0, $e0304c6799c0ccf0$export$a7873055838e5ad8)((metric)=>{
        $673eae9aafa78d9e$var$triggerHandlers("cls", {
            metric: metric
        });
        $673eae9aafa78d9e$var$_previousCls = metric;
    });
}
function $673eae9aafa78d9e$var$instrumentFid() {
    return (0, $6d987a3a7be85228$export$39705a25c49af873)((metric)=>{
        $673eae9aafa78d9e$var$triggerHandlers("fid", {
            metric: metric
        });
        $673eae9aafa78d9e$var$_previousFid = metric;
    });
}
function $673eae9aafa78d9e$var$instrumentLcp() {
    return (0, $b3aadb94d60f95cf$export$947b1626ab8d5632)((metric)=>{
        $673eae9aafa78d9e$var$triggerHandlers("lcp", {
            metric: metric
        });
        $673eae9aafa78d9e$var$_previousLcp = metric;
    });
}
function $673eae9aafa78d9e$var$instrumentInp() {
    return (0, $5dbaa80b173e24f7$export$7df4b36ecaed99e1)((metric)=>{
        $673eae9aafa78d9e$var$triggerHandlers("inp", {
            metric: metric
        });
        $673eae9aafa78d9e$var$_previousInp = metric;
    });
}
function $673eae9aafa78d9e$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $673eae9aafa78d9e$var$addHandler(type, callback);
    let stopListening;
    if (!$673eae9aafa78d9e$var$instrumented[type]) {
        stopListening = instrumentFn();
        $673eae9aafa78d9e$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $673eae9aafa78d9e$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $673eae9aafa78d9e$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $647daf5381ebe2e8$export$d1203567a167490e)(type, (entries)=>{
        $673eae9aafa78d9e$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $673eae9aafa78d9e$var$addHandler(type, handler) {
    $673eae9aafa78d9e$var$handlers[type] = $673eae9aafa78d9e$var$handlers[type] || [];
    $673eae9aafa78d9e$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $673eae9aafa78d9e$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $673eae9aafa78d9e$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}



/**
 * Create envelope from Span item.
 */ function $5c0aee7c2bcb4adb$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $f8f86f8015b1c1d3$export$44d472fbb931a776)(dsn);
    const items = spans.map($5c0aee7c2bcb4adb$var$createSpanItem);
    return (0, $1acad3161cb11d68$export$f93f7f385160c44e)(headers, items);
}
function $5c0aee7c2bcb4adb$var$createSpanItem(span) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $b47a58f57ac43e9d$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $409fa067a29db8cd$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}







/**
 * Checks if a given value is a valid measurement value.
 */ function $503418b9e4f9de59$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $503418b9e4f9de59$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


const $e0e48a318c70a9d0$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $e0e48a318c70a9d0$var$msToSec(time) {
    return time / 1000;
}
function $e0e48a318c70a9d0$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $2cc2c52a42990302$export$56d8a8a25bd48b81) && (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).addEventListener && (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).performance;
}
let $e0e48a318c70a9d0$var$_performanceCursor = 0;
let $e0e48a318c70a9d0$var$_measurements = {};
let $e0e48a318c70a9d0$var$_lcpEntry;
let $e0e48a318c70a9d0$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $e0e48a318c70a9d0$export$7c69f0412d101b88() {
    const performance = $e0e48a318c70a9d0$var$getBrowserPerformanceAPI();
    if (performance && (0, $b44690d12ec59e52$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCallback = $e0e48a318c70a9d0$var$_trackFID();
        const clsCallback = $e0e48a318c70a9d0$var$_trackCLS();
        const lcpCallback = $e0e48a318c70a9d0$var$_trackLCP();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $e0e48a318c70a9d0$export$f396d19077034ad2() {
    (0, $673eae9aafa78d9e$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $409fa067a29db8cd$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $e0e48a318c70a9d0$var$msToSec((0, $b44690d12ec59e52$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $e0e48a318c70a9d0$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $e0e48a318c70a9d0$export$e27543e0976315e4() {
    (0, $673eae9aafa78d9e$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $409fa067a29db8cd$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $e0e48a318c70a9d0$var$msToSec((0, $b44690d12ec59e52$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $e0e48a318c70a9d0$var$msToSec(entry.duration);
                const span = {
                    description: (0, $987d30935b5a1a43$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $987d30935b5a1a43$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    "ui.component_name": componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $e0e48a318c70a9d0$export$f17d06681a4744a3(interactionIdtoRouteNameMapping) {
    const performance = $e0e48a318c70a9d0$var$getBrowserPerformanceAPI();
    if (performance && (0, $b44690d12ec59e52$export$baf075a948ffc0bf)) {
        const inpCallback = $e0e48a318c70a9d0$var$_trackINP(interactionIdtoRouteNameMapping);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $e0e48a318c70a9d0$var$_trackCLS() {
    return (0, $673eae9aafa78d9e$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $e0e48a318c70a9d0$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $e0e48a318c70a9d0$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $e0e48a318c70a9d0$var$_trackLCP() {
    return (0, $673eae9aafa78d9e$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $e0e48a318c70a9d0$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $e0e48a318c70a9d0$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $e0e48a318c70a9d0$var$_trackFID() {
    return (0, $673eae9aafa78d9e$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $e0e48a318c70a9d0$var$msToSec((0, $b44690d12ec59e52$export$baf075a948ffc0bf));
        const startTime = $e0e48a318c70a9d0$var$msToSec(entry.startTime);
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $e0e48a318c70a9d0$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $e0e48a318c70a9d0$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Starts tracking the Interaction to Next Paint on the current page. */ function $e0e48a318c70a9d0$var$_trackINP(interactionIdtoRouteNameMapping) {
    return (0, $673eae9aafa78d9e$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        const entry = metric.entries.find((e)=>e.name === "click" || e.name === "pointerdown");
        const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $e0e48a318c70a9d0$var$msToSec((0, $b44690d12ec59e52$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $e0e48a318c70a9d0$var$msToSec(metric.value);
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = entry.interactionId !== undefined ? interactionIdtoRouteNameMapping[entry.interactionId] : {
            routeName: undefined,
            parentContext: undefined,
            activeTransaction: undefined,
            user: undefined,
            replayId: undefined
        };
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $b8a9b349dba88a1c$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: "ui.interaction.click",
            name: (0, $987d30935b5a1a43$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== "" ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: "millisecond"
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $e0e48a318c70a9d0$var$getSampleRate(parentContext, options);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $5c0aee7c2bcb4adb$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("Error while sending interaction:", reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $e0e48a318c70a9d0$export$5f8fa6b3467a7443(transaction) {
    const performance = $e0e48a318c70a9d0$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $2cc2c52a42990302$export$56d8a8a25bd48b81).performance.getEntries || !(0, $b44690d12ec59e52$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $e0e48a318c70a9d0$var$msToSec((0, $b44690d12ec59e52$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    const { op: op, start_timestamp: transactionStartTime } = (0, $3c6c3464b56596d8$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($e0e48a318c70a9d0$var$_performanceCursor).forEach((entry)=>{
        const startTime = $e0e48a318c70a9d0$var$msToSec(entry.startTime);
        const duration = $e0e48a318c70a9d0$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $e0e48a318c70a9d0$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $e0e48a318c70a9d0$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $e0e48a318c70a9d0$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $e0e48a318c70a9d0$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $d294dc2b59cca4cf$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $e0e48a318c70a9d0$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $e0e48a318c70a9d0$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                $e0e48a318c70a9d0$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $e0e48a318c70a9d0$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $e0e48a318c70a9d0$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $e0e48a318c70a9d0$export$45095b07f0832bb1($e0e48a318c70a9d0$var$_measurements, responseStartTimestamp, requestStartTimestamp, transactionStartTime);
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$e0e48a318c70a9d0$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $e0e48a318c70a9d0$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $e0e48a318c70a9d0$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $e0e48a318c70a9d0$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $e0e48a318c70a9d0$var$_measurements["mark.fid"];
        if (fidMark && $e0e48a318c70a9d0$var$_measurements["fid"]) {
            // create span for FID
            (0, $503418b9e4f9de59$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $e0e48a318c70a9d0$var$msToSec($e0e48a318c70a9d0$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $e0e48a318c70a9d0$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $e0e48a318c70a9d0$var$_measurements)) delete $e0e48a318c70a9d0$var$_measurements.cls;
        Object.keys($e0e48a318c70a9d0$var$_measurements).forEach((measurementName)=>{
            (0, $b47a58f57ac43e9d$export$7cc31b475d33a706)(measurementName, $e0e48a318c70a9d0$var$_measurements[measurementName].value, $e0e48a318c70a9d0$var$_measurements[measurementName].unit);
        });
        $e0e48a318c70a9d0$var$_tagMetricInfo(transaction);
    }
    $e0e48a318c70a9d0$var$_lcpEntry = undefined;
    $e0e48a318c70a9d0$var$_clsEntry = undefined;
    $e0e48a318c70a9d0$var$_measurements = {};
}
/** Create measure related spans */ function $e0e48a318c70a9d0$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $503418b9e4f9de59$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e0e48a318c70a9d0$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $e0e48a318c70a9d0$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $e0e48a318c70a9d0$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $e0e48a318c70a9d0$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $e0e48a318c70a9d0$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $e0e48a318c70a9d0$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $e0e48a318c70a9d0$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $503418b9e4f9de59$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $e0e48a318c70a9d0$var$msToSec(start),
        endTimestamp: timeOrigin + $e0e48a318c70a9d0$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e0e48a318c70a9d0$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $503418b9e4f9de59$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "request",
            startTimestamp: timeOrigin + $e0e48a318c70a9d0$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $e0e48a318c70a9d0$var$msToSec(entry.responseEnd)
        });
        (0, $503418b9e4f9de59$export$8bd469e1f37aa721)(transaction, {
            op: "browser",
            origin: "auto.browser.browser.metrics",
            description: "response",
            startTimestamp: timeOrigin + $e0e48a318c70a9d0$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $e0e48a318c70a9d0$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $e0e48a318c70a9d0$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $3b64804f5aea203a$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $e0e48a318c70a9d0$var$setResourceEntrySizeData(data, entry, "transferSize", "http.response_transfer_size");
    $e0e48a318c70a9d0$var$setResourceEntrySizeData(data, entry, "encodedBodySize", "http.response_content_length");
    $e0e48a318c70a9d0$var$setResourceEntrySizeData(data, entry, "decodedBodySize", "http.decoded_response_content_length");
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data["server.address"] = parsedUrl.host;
    data["url.same_origin"] = resourceUrl.includes((0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $503418b9e4f9de59$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location.origin, ""),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $e0e48a318c70a9d0$var$_trackNavigator(transaction) {
    const navigator = (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("connectionType", connection.type);
        if ((0, $503418b9e4f9de59$export$27169ccae1b439e3)(connection.rtt)) $e0e48a318c70a9d0$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $503418b9e4f9de59$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $503418b9e4f9de59$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $e0e48a318c70a9d0$var$_tagMetricInfo(transaction) {
    if ($e0e48a318c70a9d0$var$_lcpEntry) {
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($e0e48a318c70a9d0$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.element", (0, $987d30935b5a1a43$export$5647df6b7814ac86)($e0e48a318c70a9d0$var$_lcpEntry.element));
        if ($e0e48a318c70a9d0$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.id", $e0e48a318c70a9d0$var$_lcpEntry.id);
        if ($e0e48a318c70a9d0$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.url", $e0e48a318c70a9d0$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag("lcp.size", $e0e48a318c70a9d0$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($e0e48a318c70a9d0$var$_clsEntry && $e0e48a318c70a9d0$var$_clsEntry.sources) {
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $e0e48a318c70a9d0$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $987d30935b5a1a43$export$5647df6b7814ac86)(source.node)));
    }
}
function $e0e48a318c70a9d0$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $e0e48a318c70a9d0$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb information to measurements
 *
 * Exported for tests
 */ function $e0e48a318c70a9d0$export$45095b07f0832bb1(_measurements, responseStartTimestamp, requestStartTimestamp, transactionStartTime) {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === "number" && transactionStartTime) {
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
        _measurements["ttfb"] = {
            // As per https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStart,
            // responseStart can be 0 if the request is coming straight from the cache.
            // This might lead us to calculate a negative ttfb if we don't use Math.max here.
            //
            // This logic is the same as what is in the web-vitals library to calculate ttfb
            // https://github.com/GoogleChrome/web-vitals/blob/2301de5015e82b09925238a228a0893635854587/src/onTTFB.ts#L92
            // TODO(abhi): We should use the web-vitals library instead of this custom calculation.
            value: Math.max(responseStartTimestamp - transactionStartTime, 0) * 1000,
            unit: "millisecond"
        };
        if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements["ttfb.requestTime"] = {
            value: (responseStartTimestamp - requestStartTimestamp) * 1000,
            unit: "millisecond"
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $e0e48a318c70a9d0$var$getSampleRate(transactionContext, options) {
    if (!(0, $2d4efe7dc74c5c45$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === "function") sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $dc3f546e63db4684$export$2603c8d332a51c42)(sampleRate)) {
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return false;
    }
    return sampleRate;
}






/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $fb16389c21b4669d$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!(0, $2d4efe7dc74c5c45$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                (0, $1301771f54e43546$export$2ad6630ec8164254)(span, handlerData.response.status);
                const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                if (contentLength) {
                    const contentLengthNum = parseInt(contentLength);
                    if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
                }
            } else if (handlerData.error) span.setStatus("internal_error");
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult ? (0, $6e4ea71dfdcc0bfd$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            [(0, $96dae9fbf54762e8$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $fb16389c21b4669d$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $fb16389c21b4669d$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $9c33807712fa1c9d$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $3c6c3464b56596d8$export$7e9f8ae9e4a328ab)(span) : (0, $b93579c61bd25af0$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $d79b002e88fa3f5d$export$56766feef403f365)(dsc || (span ? (0, $d404105fdf00f3e3$export$a117f995597e25df)(span) : (0, $d404105fdf00f3e3$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== "undefined" && (0, $a7a440407ad76e9c$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $a7a440407ad76e9c$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $d79b002e88fa3f5d$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $d79b002e88fa3f5d$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}



/* eslint-disable max-lines */ const $1de68d06eecdd0e8$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $1de68d06eecdd0e8$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $1de68d06eecdd0e8$export$15bd0305d05ad07b,
    tracePropagationTargets: $1de68d06eecdd0e8$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $1de68d06eecdd0e8$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $1de68d06eecdd0e8$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $1de68d06eecdd0e8$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$1de68d06eecdd0e8$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $393ca4cf55d29319$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $fb16389c21b4669d$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $1de68d06eecdd0e8$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $85fd56d95444000b$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $1de68d06eecdd0e8$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $1de68d06eecdd0e8$var$addHTTPTimings(createdSpan);
    });
}
function $1de68d06eecdd0e8$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $1de68d06eecdd0e8$var$addHTTPTimings(span) {
    const { url: url } = (0, $3c6c3464b56596d8$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $673eae9aafa78d9e$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($1de68d06eecdd0e8$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $1de68d06eecdd0e8$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $1de68d06eecdd0e8$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $1de68d06eecdd0e8$var$getAbsoluteTime(time = 0) {
    return (((0, $b44690d12ec59e52$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $1de68d06eecdd0e8$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $1de68d06eecdd0e8$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $b44690d12ec59e52$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $1de68d06eecdd0e8$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $1de68d06eecdd0e8$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $3ded168be62470b2$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $1de68d06eecdd0e8$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $1de68d06eecdd0e8$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $85fd56d95444000b$export$55b6bb1e45c6cf59];
    if (!(0, $2d4efe7dc74c5c45$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $1301771f54e43546$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    const isolationScope = (0, $9c33807712fa1c9d$export$68f3af03034c9e90)();
    const span = shouldCreateSpanResult ? (0, $6e4ea71dfdcc0bfd$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url,
            [(0, $96dae9fbf54762e8$export$cca8dd30f57f805e)]: "auto.http.browser"
        },
        op: "http.client"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $3c6c3464b56596d8$export$7e9f8ae9e4a328ab)(span) : (0, $b93579c61bd25af0$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $d79b002e88fa3f5d$export$56766feef403f365)(dsc || (span ? (0, $d404105fdf00f3e3$export$a117f995597e25df)(span) : (0, $d404105fdf00f3e3$export$366bad00d6815eed)(traceId, client, scope)));
        $1de68d06eecdd0e8$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $1de68d06eecdd0e8$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $d79b002e88fa3f5d$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}



const $5623538de79d54f3$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $5623538de79d54f3$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $8e8ced41294f62be$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    _experiments: {},
    ...(0, $1de68d06eecdd0e8$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $5623538de79d54f3$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $72990ff5ee5b53d0$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$5623538de79d54f3$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $e0e48a318c70a9d0$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdtoRouteNameMapping = {};
    if (options.enableInp) (0, $e0e48a318c70a9d0$export$f17d06681a4744a3)(interactionIdtoRouteNameMapping);
    if (options.enableLongTask) (0, $e0e48a318c70a9d0$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $e0e48a318c70a9d0$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === "pageload";
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $5623538de79d54f3$export$f147b32b03c9cf11("sentry-trace") : "";
            const baggage = isPageloadTransaction ? $5623538de79d54f3$export$f147b32b03c9cf11("baggage") : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $b93579c61bd25af0$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $2cc2c52a42990302$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $72990ff5ee5b53d0$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document) {
            (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                if ([
                    "interactive",
                    "complete"
                ].includes((0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                "interactive",
                "complete"
            ].includes((0, $2cc2c52a42990302$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $e0e48a318c70a9d0$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $5623538de79d54f3$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
            let activeSpan;
            let startingUrl = (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location && (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on("startNavigationSpan", (context)=>{
                    if (activeSpan) {
                        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $3c6c3464b56596d8$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "navigation",
                        ...context
                    });
                });
                client.on("startPageLoadSpan", (context)=>{
                    if (activeSpan) {
                        (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $3c6c3464b56596d8$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: "pageload",
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $b44690d12ec59e52$export$baf075a948ffc0bf) ? (0, $b44690d12ec59e52$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: "auto.pageload.browser",
                    attributes: {
                        [(0, $96dae9fbf54762e8$export$d7a7d984b0791405)]: "url"
                    }
                };
                $5623538de79d54f3$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location) (0, $ea2feddc8f99ab63$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $2cc2c52a42990302$export$56d8a8a25bd48b81).location.pathname,
                        origin: "auto.navigation.browser",
                        attributes: {
                            [(0, $96dae9fbf54762e8$export$d7a7d984b0791405)]: "url"
                        }
                    };
                    $5623538de79d54f3$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $2ff167fd1293372c$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $5623538de79d54f3$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $5623538de79d54f3$var$registerInpInteractionListener(interactionIdtoRouteNameMapping, latestRoute);
            (0, $1de68d06eecdd0e8$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $5623538de79d54f3$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startPageLoadSpan", spanOptions);
    const span = (0, $6e4ea71dfdcc0bfd$export$1be426a8e585c83e)();
    const op = span && (0, $3c6c3464b56596d8$export$92d8c23565496537)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $5623538de79d54f3$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit("startNavigationSpan", spanOptions);
    const span = (0, $6e4ea71dfdcc0bfd$export$1be426a8e585c83e)();
    const op = span && (0, $3c6c3464b56596d8$export$92d8c23565496537)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $5623538de79d54f3$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $987d30935b5a1a43$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $5623538de79d54f3$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = "ui.action.click";
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $409fa067a29db8cd$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            "navigation",
            "pageload"
        ].includes(currentTransaction.op)) {
            (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason("interactionInterrupted");
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $c97b186cc9b0f0a6$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $2cc2c52a42990302$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $96dae9fbf54762e8$export$d7a7d984b0791405)]: latestRoute.context ? $5623538de79d54f3$var$getSource(latestRoute.context) : "url"
            }
        };
        inflightInteractionTransaction = (0, $72990ff5ee5b53d0$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $9c33807712fa1c9d$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        "click"
    ].forEach((type)=>{
        addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $5623538de79d54f3$var$isPerformanceEventTiming(entry) {
    return "duration" in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $5623538de79d54f3$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $5623538de79d54f3$var$registerInpInteractionListener(interactionIdtoRouteNameMapping, latestRoute) {
    (0, $673eae9aafa78d9e$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName("Replay") : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $409fa067a29db8cd$export$a7feb32fdd923295)();
        const currentScope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        for (const entry of entries)if ($5623538de79d54f3$var$isPerformanceEventTiming(entry)) {
            const duration = entry.duration;
            const keys = Object.keys(interactionIdtoRouteNameMapping);
            const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                return interactionIdtoRouteNameMapping[a].duration < interactionIdtoRouteNameMapping[b].duration ? a : b;
            }) : undefined;
            if (minInteractionId === undefined || duration > interactionIdtoRouteNameMapping[minInteractionId].duration) {
                const interactionId = entry.interactionId;
                const routeName = latestRoute.name;
                const parentContext = latestRoute.context;
                if (interactionId && routeName && parentContext) {
                    if (minInteractionId && Object.keys(interactionIdtoRouteNameMapping).length >= $5623538de79d54f3$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete interactionIdtoRouteNameMapping[minInteractionId];
                    interactionIdtoRouteNameMapping[interactionId] = {
                        routeName: routeName,
                        duration: duration,
                        parentContext: parentContext,
                        user: user,
                        activeTransaction: activeTransaction,
                        replayId: replayId
                    };
                }
            }
        }
    });
}
function $5623538de79d54f3$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $96dae9fbf54762e8$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $96dae9fbf54762e8$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

































/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ function $03b7478e7775e363$export$d92e61f5600202af(url, hubOrClient) {
    const client = hubOrClient && $03b7478e7775e363$var$isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $03b7478e7775e363$var$checkDsn(url, dsn) || $03b7478e7775e363$var$checkTunnel(url, tunnel);
}
function $03b7478e7775e363$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $03b7478e7775e363$var$removeTrailingSlash(url) === $03b7478e7775e363$var$removeTrailingSlash(tunnel);
}
function $03b7478e7775e363$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $03b7478e7775e363$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}
function $03b7478e7775e363$var$isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}













var $e65bdcddef6e1bb2$exports = {};

$parcel$export($e65bdcddef6e1bb2$exports, "FunctionToString", function () { return $3ede77ad8b2617c4$export$da4704525c20ae79; });
$parcel$export($e65bdcddef6e1bb2$exports, "InboundFilters", function () { return $19eeae6f74ee5364$export$2ffbb5359dcc6be4; });
$parcel$export($e65bdcddef6e1bb2$exports, "LinkedErrors", function () { return $f9052008f253b7d2$export$8d1e60aaf616fb4f; });






/**
 * Extracts stack frames from the error.stack string
 */ function $93b524a98ef18fe9$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $93b524a98ef18fe9$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $93b524a98ef18fe9$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $93b524a98ef18fe9$var$getMessageForObject(exception) {
    if ("name" in exception && typeof exception.name === "string") {
        let message = `'${exception.name}' captured as exception`;
        if ("message" in exception && typeof exception.message === "string") message += ` with message '${exception.message}'`;
        return message;
    } else if ("message" in exception && typeof exception.message === "string") return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $4f81a26afd00acb9$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $93b524a98ef18fe9$export$9dd56ed1ef0c3420(getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === "function" ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: "generic"
    };
    let extras;
    if (!(0, $a7a440407ad76e9c$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $a7a440407ad76e9c$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ["__serialized__"]: (0, $35a80961bb361df7$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $93b524a98ef18fe9$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $93b524a98ef18fe9$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $8e0411c1e39b6e49$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $8e0411c1e39b6e49$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $93b524a98ef18fe9$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $93b524a98ef18fe9$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $a7a440407ad76e9c$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $f9052008f253b7d2$var$DEFAULT_KEY = "cause";
const $f9052008f253b7d2$var$DEFAULT_LIMIT = 5;
const $f9052008f253b7d2$var$INTEGRATION_NAME = "LinkedErrors";
const $f9052008f253b7d2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $f9052008f253b7d2$var$DEFAULT_LIMIT;
    const key = options.key || $f9052008f253b7d2$var$DEFAULT_KEY;
    return {
        name: $f9052008f253b7d2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $ffb0b47ea671a891$export$b91c38ed7d8ae9b2)((0, $93b524a98ef18fe9$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $f9052008f253b7d2$export$ebabb00eb7f3a395 = (0, $7b807498fd0c5452$export$2323046b9414659f)($f9052008f253b7d2$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f9052008f253b7d2$export$8d1e60aaf616fb4f = (0, $7b807498fd0c5452$export$afa219bf23651160)($f9052008f253b7d2$var$INTEGRATION_NAME, $f9052008f253b7d2$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $aee0925ccd2f4df9$export$99d02219d259eb94 = $e65bdcddef6e1bb2$exports;
















var $276e39e69e01803e$exports = {};

$parcel$export($276e39e69e01803e$exports, "GlobalHandlers", function () { return $9888c56b0ad0b319$export$204155decbc90e5a; });
$parcel$export($276e39e69e01803e$exports, "TryCatch", function () { return $58e9cb642f2241a0$export$f1a018517668e6d3; });
$parcel$export($276e39e69e01803e$exports, "Breadcrumbs", function () { return $cf5760c92822f4d2$export$2dc68d50d56fbbd; });
$parcel$export($276e39e69e01803e$exports, "LinkedErrors", function () { return $02d36478718dedcc$export$8d1e60aaf616fb4f; });
$parcel$export($276e39e69e01803e$exports, "HttpContext", function () { return $da7c787d486b8899$export$5d2ee9a544b09a94; });
$parcel$export($276e39e69e01803e$exports, "Dedupe", function () { return $4d7de9a46d0ee425$export$688d98c249d31ad3; });






 /* eslint-disable deprecation/deprecation */ 

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $b71765357b9a58a3$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $eca130af7684dd65$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}


var $bmgOM = parcelRequire("bmgOM");

/**
 * Returns true if we are in the browser.
 */ function $0a5a77464a1317ad$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $bmgOM.isNodeEnv)() || $0a5a77464a1317ad$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $0a5a77464a1317ad$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).process !== undefined && (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1).process.type === "renderer");
}




// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $1e78293c4d0a3fa1$var$WINDOW = (0, $8c000611b10ddc14$export$f1a6cdb1459e81d1);
const $1e78293c4d0a3fa1$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $1e78293c4d0a3fa1$var$REPLAY_EVENT_NAME = "replay_event";
const $1e78293c4d0a3fa1$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $1e78293c4d0a3fa1$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $1e78293c4d0a3fa1$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $1e78293c4d0a3fa1$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $1e78293c4d0a3fa1$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $1e78293c4d0a3fa1$var$BUFFER_CHECKOUT_TIME = 60000;
const $1e78293c4d0a3fa1$var$RETRY_BASE_INTERVAL = 5000;
const $1e78293c4d0a3fa1$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $1e78293c4d0a3fa1$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $1e78293c4d0a3fa1$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $1e78293c4d0a3fa1$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $1e78293c4d0a3fa1$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $1e78293c4d0a3fa1$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $1e78293c4d0a3fa1$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $1e78293c4d0a3fa1$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $1e78293c4d0a3fa1$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $1e78293c4d0a3fa1$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $1e78293c4d0a3fa1$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $1e78293c4d0a3fa1$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($1e78293c4d0a3fa1$var$NodeType$1 || ($1e78293c4d0a3fa1$var$NodeType$1 = {}));
function $1e78293c4d0a3fa1$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $1e78293c4d0a3fa1$var$isShadowRoot(n) {
    const host = $1e78293c4d0a3fa1$var$_optionalChain$5([
        n,
        "optionalAccess",
        (_)=>_.host
    ]);
    return Boolean($1e78293c4d0a3fa1$var$_optionalChain$5([
        host,
        "optionalAccess",
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $1e78293c4d0a3fa1$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function $1e78293c4d0a3fa1$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) cssText = cssText.replace(" background-clip: text;", " -webkit-background-clip: text; background-clip: text;");
    return cssText;
}
function $1e78293c4d0a3fa1$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        "@import",
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === "") statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(" ") + ";";
}
function $1e78293c4d0a3fa1$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $1e78293c4d0a3fa1$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $1e78293c4d0a3fa1$var$stringifyRule).join("")) : null;
    } catch (error) {
        return null;
    }
}
function $1e78293c4d0a3fa1$var$stringifyRule(rule) {
    let importStringified;
    if ($1e78293c4d0a3fa1$var$isCSSImportRule(rule)) try {
        importStringified = $1e78293c4d0a3fa1$var$stringifyStylesheet(rule.styleSheet) || $1e78293c4d0a3fa1$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($1e78293c4d0a3fa1$var$isCSSStyleRule(rule) && rule.selectorText.includes(":")) return $1e78293c4d0a3fa1$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $1e78293c4d0a3fa1$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, "$1\\$2");
}
function $1e78293c4d0a3fa1$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $1e78293c4d0a3fa1$var$isCSSStyleRule(rule) {
    return "selectorText" in rule;
}
class $1e78293c4d0a3fa1$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $1e78293c4d0a3fa1$var$_optionalChain$5([
            this,
            "access",
            (_3)=>_3.getMeta,
            "call",
            (_4)=>_4(n),
            "optionalAccess",
            (_5)=>_5.id
        ]);
        return $1e78293c4d0a3fa1$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $1e78293c4d0a3fa1$var$createMirror() {
    return new $1e78293c4d0a3fa1$var$Mirror();
}
function $1e78293c4d0a3fa1$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === "OPTION") tagName = "SELECT";
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || tagName === "INPUT" && !type && maskInputOptions["text"]);
}
function $1e78293c4d0a3fa1$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return "*".repeat(text.length);
}
function $1e78293c4d0a3fa1$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $1e78293c4d0a3fa1$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $1e78293c4d0a3fa1$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $1e78293c4d0a3fa1$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $1e78293c4d0a3fa1$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$1e78293c4d0a3fa1$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $1e78293c4d0a3fa1$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? $1e78293c4d0a3fa1$var$toLowerCase(type) : null;
}
function $1e78293c4d0a3fa1$var$getInputValue(el, tagName, type) {
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $1e78293c4d0a3fa1$var$_id = 1;
const $1e78293c4d0a3fa1$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $1e78293c4d0a3fa1$var$IGNORED_NODE = -2;
function $1e78293c4d0a3fa1$var$genId() {
    return $1e78293c4d0a3fa1$var$_id++;
}
function $1e78293c4d0a3fa1$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = $1e78293c4d0a3fa1$var$toLowerCase(element.tagName);
    if ($1e78293c4d0a3fa1$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $1e78293c4d0a3fa1$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $1e78293c4d0a3fa1$var$canvasService;
let $1e78293c4d0a3fa1$var$canvasCtx;
const $1e78293c4d0a3fa1$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $1e78293c4d0a3fa1$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $1e78293c4d0a3fa1$var$URL_WWW_MATCH = /^www\..*/i;
const $1e78293c4d0a3fa1$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $1e78293c4d0a3fa1$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($1e78293c4d0a3fa1$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if ($1e78293c4d0a3fa1$var$URL_PROTOCOL_MATCH.test(filePath) || $1e78293c4d0a3fa1$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($1e78293c4d0a3fa1$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$1e78293c4d0a3fa1$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $1e78293c4d0a3fa1$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $1e78293c4d0a3fa1$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $1e78293c4d0a3fa1$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    const output = [];
    while(true){
        collectCharacters($1e78293c4d0a3fa1$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($1e78293c4d0a3fa1$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $1e78293c4d0a3fa1$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $1e78293c4d0a3fa1$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $1e78293c4d0a3fa1$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $1e78293c4d0a3fa1$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $1e78293c4d0a3fa1$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $1e78293c4d0a3fa1$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) return $1e78293c4d0a3fa1$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $1e78293c4d0a3fa1$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $1e78293c4d0a3fa1$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $1e78293c4d0a3fa1$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $1e78293c4d0a3fa1$var$absoluteToStylesheet(value, $1e78293c4d0a3fa1$var$getHref());
    else if (tagName === "object" && name === "data") return $1e78293c4d0a3fa1$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === "function") return maskAttributeFn(name, value, element);
    return value;
}
function $1e78293c4d0a3fa1$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function $1e78293c4d0a3fa1$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === "string") {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $1e78293c4d0a3fa1$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $1e78293c4d0a3fa1$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $1e78293c4d0a3fa1$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $1e78293c4d0a3fa1$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === "string") {
                    if (el.matches(`.${className}`)) return true;
                } else if ($1e78293c4d0a3fa1$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $1e78293c4d0a3fa1$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === "INPUT") {
            const autocomplete = el.getAttribute("autocomplete");
            const disallowedAutocompleteValues = [
                "current-password",
                "new-password",
                "cc-number",
                "cc-exp",
                "cc-exp-month",
                "cc-exp-year",
                "cc-csc"
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $1e78293c4d0a3fa1$var$distanceToMatch(el, $1e78293c4d0a3fa1$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $1e78293c4d0a3fa1$var$distanceToMatch(el, $1e78293c4d0a3fa1$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $1e78293c4d0a3fa1$var$distanceToMatch(el, $1e78293c4d0a3fa1$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $1e78293c4d0a3fa1$var$distanceToMatch(el, $1e78293c4d0a3fa1$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $1e78293c4d0a3fa1$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return iframeEl.addEventListener("load", listener);
    }
    iframeEl.addEventListener("load", listener);
}
function $1e78293c4d0a3fa1$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener("load", ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $1e78293c4d0a3fa1$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $1e78293c4d0a3fa1$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $1e78293c4d0a3fa1$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $1e78293c4d0a3fa1$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $1e78293c4d0a3fa1$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $1e78293c4d0a3fa1$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $1e78293c4d0a3fa1$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $1e78293c4d0a3fa1$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $1e78293c4d0a3fa1$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $1e78293c4d0a3fa1$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $1e78293c4d0a3fa1$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === "STYLE" ? true : undefined;
    const isScript = parentTagName === "SCRIPT" ? true : undefined;
    const isTextarea = parentTagName === "TEXTAREA" ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($1e78293c4d0a3fa1$var$_optionalChain$5([
                n,
                "access",
                (_6)=>_6.parentNode,
                "access",
                (_7)=>_7.sheet,
                "optionalAccess",
                (_8)=>_8.cssRules
            ])) textContent = $1e78293c4d0a3fa1$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $1e78293c4d0a3fa1$var$absoluteToStylesheet(textContent, $1e78293c4d0a3fa1$var$getHref());
    }
    if (isScript) textContent = "SCRIPT_PLACEHOLDER";
    const forceMask = $1e78293c4d0a3fa1$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent) : textContent.replace(/[\S]/g, "*");
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, "*");
    if (parentTagName === "OPTION" && textContent) {
        const isInputMasked = $1e78293c4d0a3fa1$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $1e78293c4d0a3fa1$var$maskInputValue({
            isMasked: $1e78293c4d0a3fa1$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $1e78293c4d0a3fa1$var$NodeType$1.Text,
        textContent: textContent || "",
        isStyle: isStyle,
        rootId: rootId
    };
}
function $1e78293c4d0a3fa1$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $1e78293c4d0a3fa1$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $1e78293c4d0a3fa1$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$1e78293c4d0a3fa1$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $1e78293c4d0a3fa1$var$transformAttribute(doc, tagName, $1e78293c4d0a3fa1$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === "link" && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $1e78293c4d0a3fa1$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $1e78293c4d0a3fa1$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
        const cssText = $1e78293c4d0a3fa1$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $1e78293c4d0a3fa1$var$absoluteToStylesheet(cssText, $1e78293c4d0a3fa1$var$getHref());
    }
    if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
        const el = n;
        const type = $1e78293c4d0a3fa1$var$getInputType(el);
        const value = $1e78293c4d0a3fa1$var$getInputValue(el, $1e78293c4d0a3fa1$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== "submit" && type !== "button" && value) {
            const forceMask = $1e78293c4d0a3fa1$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $1e78293c4d0a3fa1$var$shouldMaskInput({
                type: type,
                tagName: $1e78293c4d0a3fa1$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $1e78293c4d0a3fa1$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === "option") {
        if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === "canvas" && recordCanvas) {
        if (n.__context === "2d") {
            if (!$1e78293c4d0a3fa1$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!("__context" in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement("canvas");
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === "img" && inlineImages) {
        if (!$1e78293c4d0a3fa1$var$canvasService) {
            $1e78293c4d0a3fa1$var$canvasService = doc.createElement("canvas");
            $1e78293c4d0a3fa1$var$canvasCtx = $1e78293c4d0a3fa1$var$canvasService.getContext("2d");
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = "anonymous";
        const recordInlineImage = ()=>{
            image.removeEventListener("load", recordInlineImage);
            try {
                $1e78293c4d0a3fa1$var$canvasService.width = image.naturalWidth;
                $1e78293c4d0a3fa1$var$canvasService.height = image.naturalHeight;
                $1e78293c4d0a3fa1$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $1e78293c4d0a3fa1$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute("crossorigin");
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener("load", recordInlineImage);
    }
    if (tagName === "audio" || tagName === "video") {
        attributes.rr_mediaState = n.paused ? "paused" : "played";
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $1e78293c4d0a3fa1$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $1e78293c4d0a3fa1$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $1e78293c4d0a3fa1$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $1e78293c4d0a3fa1$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $1e78293c4d0a3fa1$var$NodeType$1.Comment) return true;
    else if (sn.type === $1e78293c4d0a3fa1$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "application-name" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.rel) === "icon" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "robots" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "googlebot" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "author" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "generator" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "framework" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "publisher" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "progid" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "verification" || $1e78293c4d0a3fa1$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $1e78293c4d0a3fa1$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $1e78293c4d0a3fa1$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($1e78293c4d0a3fa1$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $1e78293c4d0a3fa1$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $1e78293c4d0a3fa1$var$IGNORED_NODE;
    else id = $1e78293c4d0a3fa1$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $1e78293c4d0a3fa1$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $1e78293c4d0a3fa1$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $1e78293c4d0a3fa1$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $1e78293c4d0a3fa1$var$NodeType$1.Document || serializedNode.type === $1e78293c4d0a3fa1$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $1e78293c4d0a3fa1$var$NodeType$1.Element && serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $1e78293c4d0a3fa1$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($1e78293c4d0a3fa1$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $1e78293c4d0a3fa1$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $1e78293c4d0a3fa1$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $1e78293c4d0a3fa1$var$isShadowRoot(n.parentNode) && $1e78293c4d0a3fa1$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $1e78293c4d0a3fa1$var$NodeType$1.Element && serializedNode.tagName === "iframe") $1e78293c4d0a3fa1$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $1e78293c4d0a3fa1$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $1e78293c4d0a3fa1$var$NodeType$1.Element && serializedNode.tagName === "link" && serializedNode.attributes.rel === "stylesheet") $1e78293c4d0a3fa1$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $1e78293c4d0a3fa1$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $1e78293c4d0a3fa1$var$snapshot(n, options) {
    const { mirror: mirror = new $1e78293c4d0a3fa1$var$Mirror(), blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $1e78293c4d0a3fa1$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $1e78293c4d0a3fa1$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $1e78293c4d0a3fa1$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $1e78293c4d0a3fa1$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $1e78293c4d0a3fa1$var$_mirror = {
    map: {},
    getId () {
        console.error($1e78293c4d0a3fa1$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($1e78293c4d0a3fa1$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($1e78293c4d0a3fa1$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($1e78293c4d0a3fa1$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($1e78293c4d0a3fa1$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $1e78293c4d0a3fa1$var$_mirror = new Proxy($1e78293c4d0a3fa1$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($1e78293c4d0a3fa1$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $1e78293c4d0a3fa1$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $1e78293c4d0a3fa1$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$1e78293c4d0a3fa1$var$hookSetter(target, key, original || {}, true);
}
function $1e78293c4d0a3fa1$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $1e78293c4d0a3fa1$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $1e78293c4d0a3fa1$var$nowTimestamp = ()=>new Date().getTime();
function $1e78293c4d0a3fa1$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $1e78293c4d0a3fa1$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_)=>_.documentElement,
            "access",
            (_2)=>_2.scrollLeft
        ]) || $1e78293c4d0a3fa1$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_3)=>_3.body,
            "optionalAccess",
            (_4)=>_4.parentElement,
            "optionalAccess",
            (_5)=>_5.scrollLeft
        ]) || $1e78293c4d0a3fa1$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_6)=>_6.body,
            "optionalAccess",
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $1e78293c4d0a3fa1$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_8)=>_8.documentElement,
            "access",
            (_9)=>_9.scrollTop
        ]) || $1e78293c4d0a3fa1$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_10)=>_10.body,
            "optionalAccess",
            (_11)=>_11.parentElement,
            "optionalAccess",
            (_12)=>_12.scrollTop
        ]) || $1e78293c4d0a3fa1$var$_optionalChain$4([
            doc,
            "optionalAccess",
            (_13)=>_13.body,
            "optionalAccess",
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $1e78293c4d0a3fa1$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $1e78293c4d0a3fa1$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $1e78293c4d0a3fa1$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (!el) return false;
    const blockedPredicate = $1e78293c4d0a3fa1$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $1e78293c4d0a3fa1$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $1e78293c4d0a3fa1$var$distanceToMatch(el, $1e78293c4d0a3fa1$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $1e78293c4d0a3fa1$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $1e78293c4d0a3fa1$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $1e78293c4d0a3fa1$var$IGNORED_NODE;
}
function $1e78293c4d0a3fa1$var$isAncestorRemoved(target, mirror) {
    if ($1e78293c4d0a3fa1$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $1e78293c4d0a3fa1$var$isAncestorRemoved(target.parentNode, mirror);
}
function $1e78293c4d0a3fa1$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $1e78293c4d0a3fa1$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $1e78293c4d0a3fa1$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === "IFRAME" && mirror.getMeta(n));
}
function $1e78293c4d0a3fa1$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === "LINK" && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute("rel") === "stylesheet" && mirror.getMeta(n));
}
function $1e78293c4d0a3fa1$var$hasShadowRoot(n) {
    return Boolean($1e78293c4d0a3fa1$var$_optionalChain$4([
        n,
        "optionalAccess",
        (_18)=>_18.shadowRoot
    ]));
}
class $1e78293c4d0a3fa1$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $b71765357b9a58a3$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $1e78293c4d0a3fa1$var$getShadowHost(n) {
    let shadowHost = null;
    if ($1e78293c4d0a3fa1$var$_optionalChain$4([
        n,
        "access",
        (_19)=>_19.getRootNode,
        "optionalCall",
        (_20)=>_20(),
        "optionalAccess",
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $1e78293c4d0a3fa1$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $1e78293c4d0a3fa1$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $1e78293c4d0a3fa1$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $1e78293c4d0a3fa1$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $1e78293c4d0a3fa1$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $1e78293c4d0a3fa1$var$shadowHostInDom(n);
}
let $1e78293c4d0a3fa1$var$cachedRequestAnimationFrameImplementation;
function $1e78293c4d0a3fa1$var$getRequestAnimationFrameImplementation() {
    if ($1e78293c4d0a3fa1$var$cachedRequestAnimationFrameImplementation) return $1e78293c4d0a3fa1$var$cachedRequestAnimationFrameImplementation;
    const document1 = window.document;
    let requestAnimationFrameImplementation = window.requestAnimationFrame;
    if (document1 && typeof document1.createElement === "function") try {
        const sandbox = document1.createElement("iframe");
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.requestAnimationFrame) requestAnimationFrameImplementation = contentWindow.requestAnimationFrame;
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $1e78293c4d0a3fa1$var$cachedRequestAnimationFrameImplementation = requestAnimationFrameImplementation.bind(window);
}
function $1e78293c4d0a3fa1$var$onRequestAnimationFrame(...rest) {
    return $1e78293c4d0a3fa1$var$getRequestAnimationFrameImplementation()(...rest);
}
var $1e78293c4d0a3fa1$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($1e78293c4d0a3fa1$var$EventType || {});
var $1e78293c4d0a3fa1$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($1e78293c4d0a3fa1$var$IncrementalSource || {});
var $1e78293c4d0a3fa1$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($1e78293c4d0a3fa1$var$MouseInteractions || {});
var $1e78293c4d0a3fa1$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($1e78293c4d0a3fa1$var$PointerTypes || {});
function $1e78293c4d0a3fa1$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $1e78293c4d0a3fa1$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $1e78293c4d0a3fa1$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = $1e78293c4d0a3fa1$var$_optionalChain$3([
            current,
            "optionalAccess",
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $1e78293c4d0a3fa1$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $1e78293c4d0a3fa1$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $1e78293c4d0a3fa1$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $1e78293c4d0a3fa1$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $1e78293c4d0a3fa1$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $1e78293c4d0a3fa1$var$IGNORED_NODE;
                while(nextId === $1e78293c4d0a3fa1$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$1e78293c4d0a3fa1$var$inDom(n)) return;
                const parentId = $1e78293c4d0a3fa1$var$isShadowRoot(n.parentNode) ? this.mirror.getId($1e78293c4d0a3fa1$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $1e78293c4d0a3fa1$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($1e78293c4d0a3fa1$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($1e78293c4d0a3fa1$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($1e78293c4d0a3fa1$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($1e78293c4d0a3fa1$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$1e78293c4d0a3fa1$var$isAncestorInSet(this.droppedSet, n) && !$1e78293c4d0a3fa1$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($1e78293c4d0a3fa1$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === "string") {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($1e78293c4d0a3fa1$var$isIgnored(m.target, this.mirror)) return;
            let unattachedDoc;
            try {
                unattachedDoc = document.implementation.createHTMLDocument();
            } catch (e) {
                unattachedDoc = this.doc;
            }
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$1e78293c4d0a3fa1$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $1e78293c4d0a3fa1$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === "value") {
                            const type = $1e78293c4d0a3fa1$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $1e78293c4d0a3fa1$var$getInputValue(target, tagName, type);
                            const isInputMasked = $1e78293c4d0a3fa1$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $1e78293c4d0a3fa1$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $1e78293c4d0a3fa1$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($1e78293c4d0a3fa1$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = "rr_src";
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                        }
                        if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (!$1e78293c4d0a3fa1$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $1e78293c4d0a3fa1$var$transformAttribute(this.doc, $1e78293c4d0a3fa1$var$toLowerCase(target.tagName), $1e78293c4d0a3fa1$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === "style") {
                                const old = unattachedDoc.createElement("span");
                                if (m.oldValue) old.setAttribute("style", m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case "childList":
                    if ($1e78293c4d0a3fa1$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $1e78293c4d0a3fa1$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($1e78293c4d0a3fa1$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $1e78293c4d0a3fa1$var$isIgnored(n, this.mirror) || !$1e78293c4d0a3fa1$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $1e78293c4d0a3fa1$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($1e78293c4d0a3fa1$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$1e78293c4d0a3fa1$var$moveKey(nodeId, parentId)]) $1e78293c4d0a3fa1$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $1e78293c4d0a3fa1$var$isShadowRoot(m.target) && $1e78293c4d0a3fa1$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($1e78293c4d0a3fa1$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$1e78293c4d0a3fa1$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$1e78293c4d0a3fa1$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($1e78293c4d0a3fa1$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskAllText",
            "maskTextClass",
            "unmaskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "inlineStylesheet",
            "maskInputOptions",
            "maskAttributeFn",
            "maskTextFn",
            "maskInputFn",
            "keepIframeSrcFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "dataURLOptions",
            "doc",
            "mirror",
            "iframeManager",
            "stylesheetManager",
            "shadowDomManager",
            "canvasManager",
            "processedNodeManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $1e78293c4d0a3fa1$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$1e78293c4d0a3fa1$var$deepDelete(addsSet, childN));
}
function $1e78293c4d0a3fa1$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $1e78293c4d0a3fa1$var$_isParentRemoved(removes, n, mirror);
}
function $1e78293c4d0a3fa1$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $1e78293c4d0a3fa1$var$_isParentRemoved(removes, parentNode, mirror);
}
function $1e78293c4d0a3fa1$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $1e78293c4d0a3fa1$var$_isAncestorInSet(set, n);
}
function $1e78293c4d0a3fa1$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $1e78293c4d0a3fa1$var$_isAncestorInSet(set, parentNode);
}
let $1e78293c4d0a3fa1$var$errorHandler;
function $1e78293c4d0a3fa1$var$registerErrorHandler(handler) {
    $1e78293c4d0a3fa1$var$errorHandler = handler;
}
function $1e78293c4d0a3fa1$var$unregisterErrorHandler() {
    $1e78293c4d0a3fa1$var$errorHandler = undefined;
}
const $1e78293c4d0a3fa1$var$callbackWrapper = (cb)=>{
    if (!$1e78293c4d0a3fa1$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($1e78293c4d0a3fa1$var$errorHandler && $1e78293c4d0a3fa1$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $1e78293c4d0a3fa1$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $1e78293c4d0a3fa1$var$mutationBuffers = [];
function $1e78293c4d0a3fa1$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $1e78293c4d0a3fa1$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $1e78293c4d0a3fa1$var$MutationBuffer();
    $1e78293c4d0a3fa1$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $1e78293c4d0a3fa1$var$_optionalChain$2([
        window,
        "optionalAccess",
        (_)=>_.Zone,
        "optionalAccess",
        (_2)=>_2.__symbol__,
        "optionalCall",
        (_3)=>_3("MutationObserver")
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($1e78293c4d0a3fa1$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $1e78293c4d0a3fa1$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $1e78293c4d0a3fa1$var$throttle$1($1e78293c4d0a3fa1$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $1e78293c4d0a3fa1$var$callbackWrapper($1e78293c4d0a3fa1$var$throttle$1($1e78293c4d0a3fa1$var$callbackWrapper((evt)=>{
        const target = $1e78293c4d0a3fa1$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $1e78293c4d0a3fa1$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $1e78293c4d0a3fa1$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $1e78293c4d0a3fa1$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $1e78293c4d0a3fa1$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $1e78293c4d0a3fa1$var$IncrementalSource.MouseMove : $1e78293c4d0a3fa1$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $1e78293c4d0a3fa1$var$on("mousemove", updatePosition, doc),
        $1e78293c4d0a3fa1$var$on("touchmove", updatePosition, doc),
        $1e78293c4d0a3fa1$var$on("drag", updatePosition, doc)
    ];
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $1e78293c4d0a3fa1$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $1e78293c4d0a3fa1$var$getEventTarget(event);
            if ($1e78293c4d0a3fa1$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ("pointerType" in event) {
                switch(event.pointerType){
                    case "mouse":
                        pointerType = $1e78293c4d0a3fa1$var$PointerTypes.Mouse;
                        break;
                    case "touch":
                        pointerType = $1e78293c4d0a3fa1$var$PointerTypes.Touch;
                        break;
                    case "pen":
                        pointerType = $1e78293c4d0a3fa1$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $1e78293c4d0a3fa1$var$PointerTypes.Touch) {
                    if ($1e78293c4d0a3fa1$var$MouseInteractions[eventKey] === $1e78293c4d0a3fa1$var$MouseInteractions.MouseDown) thisEventKey = "TouchStart";
                    else if ($1e78293c4d0a3fa1$var$MouseInteractions[eventKey] === $1e78293c4d0a3fa1$var$MouseInteractions.MouseUp) thisEventKey = "TouchEnd";
                } else $1e78293c4d0a3fa1$var$PointerTypes.Pen;
            } else if ($1e78293c4d0a3fa1$var$legacy_isTouchEvent(event)) pointerType = $1e78293c4d0a3fa1$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith("Touch") && pointerType === $1e78293c4d0a3fa1$var$PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === $1e78293c4d0a3fa1$var$PointerTypes.Mouse) pointerType = null;
            } else if ($1e78293c4d0a3fa1$var$MouseInteractions[eventKey] === $1e78293c4d0a3fa1$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $1e78293c4d0a3fa1$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $1e78293c4d0a3fa1$var$callbackWrapper(mouseInteractionCb)({
                type: $1e78293c4d0a3fa1$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($1e78293c4d0a3fa1$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $1e78293c4d0a3fa1$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($1e78293c4d0a3fa1$var$MouseInteractions[eventKey]){
            case $1e78293c4d0a3fa1$var$MouseInteractions.MouseDown:
            case $1e78293c4d0a3fa1$var$MouseInteractions.MouseUp:
                eventName = eventName.replace("mouse", "pointer");
                break;
            case $1e78293c4d0a3fa1$var$MouseInteractions.TouchStart:
            case $1e78293c4d0a3fa1$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($1e78293c4d0a3fa1$var$on(eventName, handler, doc));
    });
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $1e78293c4d0a3fa1$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $1e78293c4d0a3fa1$var$callbackWrapper($1e78293c4d0a3fa1$var$throttle$1($1e78293c4d0a3fa1$var$callbackWrapper((evt)=>{
        const target = $1e78293c4d0a3fa1$var$getEventTarget(evt);
        if (!target || $1e78293c4d0a3fa1$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $1e78293c4d0a3fa1$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $1e78293c4d0a3fa1$var$on("scroll", updatePosition, doc);
}
function $1e78293c4d0a3fa1$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $1e78293c4d0a3fa1$var$callbackWrapper($1e78293c4d0a3fa1$var$throttle$1($1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        const height = $1e78293c4d0a3fa1$var$getWindowHeight();
        const width = $1e78293c4d0a3fa1$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $1e78293c4d0a3fa1$var$on("resize", updateDimension, win);
}
const $1e78293c4d0a3fa1$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $1e78293c4d0a3fa1$var$lastInputValueMap = new WeakMap();
function $1e78293c4d0a3fa1$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $1e78293c4d0a3fa1$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $1e78293c4d0a3fa1$var$toUpperCase(target.tagName);
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $1e78293c4d0a3fa1$var$INPUT_TAGS.indexOf(tagName) < 0 || $1e78293c4d0a3fa1$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $1e78293c4d0a3fa1$var$getInputType(target);
        let text = $1e78293c4d0a3fa1$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $1e78293c4d0a3fa1$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $1e78293c4d0a3fa1$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        text = $1e78293c4d0a3fa1$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $1e78293c4d0a3fa1$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $1e78293c4d0a3fa1$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $1e78293c4d0a3fa1$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $1e78293c4d0a3fa1$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $1e78293c4d0a3fa1$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$1e78293c4d0a3fa1$var$on(eventName, $1e78293c4d0a3fa1$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            "checked"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$1e78293c4d0a3fa1$var$hookSetter(p[0], p[1], {
            set () {
                $1e78293c4d0a3fa1$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $1e78293c4d0a3fa1$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($1e78293c4d0a3fa1$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $1e78293c4d0a3fa1$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $1e78293c4d0a3fa1$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $1e78293c4d0a3fa1$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $1e78293c4d0a3fa1$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $1e78293c4d0a3fa1$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($1e78293c4d0a3fa1$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($1e78293c4d0a3fa1$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($1e78293c4d0a3fa1$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($1e78293c4d0a3fa1$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$1e78293c4d0a3fa1$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$1e78293c4d0a3fa1$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $1e78293c4d0a3fa1$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === "#document") hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === "#document" ? $1e78293c4d0a3fa1$var$_optionalChain$2([
        host,
        "access",
        (_4)=>_4.defaultView,
        "optionalAccess",
        (_5)=>_5.Document
    ]) : $1e78293c4d0a3fa1$var$_optionalChain$2([
        host,
        "access",
        (_6)=>_6.ownerDocument,
        "optionalAccess",
        (_7)=>_7.defaultView,
        "optionalAccess",
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $1e78293c4d0a3fa1$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($1e78293c4d0a3fa1$var$_optionalChain$2([
        patchTarget,
        "optionalAccess",
        (_10)=>_10.prototype
    ]), "adoptedStyleSheets") : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, "adoptedStyleSheets", {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $1e78293c4d0a3fa1$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_11)=>_11.get,
                "optionalAccess",
                (_12)=>_12.call,
                "call",
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $1e78293c4d0a3fa1$var$_optionalChain$2([
                originalPropertyDescriptor,
                "access",
                (_14)=>_14.set,
                "optionalAccess",
                (_15)=>_15.call,
                "call",
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        Object.defineProperty(host, "adoptedStyleSheets", {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $1e78293c4d0a3fa1$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId($1e78293c4d0a3fa1$var$_optionalChain$2([
                thisArg,
                "access",
                (_17)=>_17.parentRule,
                "optionalAccess",
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $1e78293c4d0a3fa1$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $1e78293c4d0a3fa1$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $1e78293c4d0a3fa1$var$getIdAndStyleId($1e78293c4d0a3fa1$var$_optionalChain$2([
                thisArg,
                "access",
                (_19)=>_19.parentRule,
                "optionalAccess",
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $1e78293c4d0a3fa1$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $1e78293c4d0a3fa1$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $1e78293c4d0a3fa1$var$callbackWrapper((type)=>$1e78293c4d0a3fa1$var$throttle$1($1e78293c4d0a3fa1$var$callbackWrapper((event)=>{
            const target = $1e78293c4d0a3fa1$var$getEventTarget(event);
            if (!target || $1e78293c4d0a3fa1$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $1e78293c4d0a3fa1$var$on("play", handler(0), doc),
        $1e78293c4d0a3fa1$var$on("pause", handler(1), doc),
        $1e78293c4d0a3fa1$var$on("seeked", handler(2), doc),
        $1e78293c4d0a3fa1$var$on("volumechange", handler(3), doc),
        $1e78293c4d0a3fa1$var$on("ratechange", handler(4), doc)
    ];
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $1e78293c4d0a3fa1$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $1e78293c4d0a3fa1$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout($1e78293c4d0a3fa1$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $1e78293c4d0a3fa1$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $1e78293c4d0a3fa1$var$_optionalChain$2([
            selection,
            "optionalAccess",
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $1e78293c4d0a3fa1$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $1e78293c4d0a3fa1$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $1e78293c4d0a3fa1$var$on("selectionchange", updateSelection);
}
function $1e78293c4d0a3fa1$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $1e78293c4d0a3fa1$var$patch(win.customElements, "define", function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $1e78293c4d0a3fa1$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $1e78293c4d0a3fa1$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $1e78293c4d0a3fa1$var$initMoveObserver(o);
    const mouseInteractionHandler = $1e78293c4d0a3fa1$var$initMouseInteractionObserver(o);
    const scrollHandler = $1e78293c4d0a3fa1$var$initScrollObserver(o);
    const viewportResizeHandler = $1e78293c4d0a3fa1$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $1e78293c4d0a3fa1$var$initInputObserver(o);
    const mediaInteractionHandler = $1e78293c4d0a3fa1$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $1e78293c4d0a3fa1$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $1e78293c4d0a3fa1$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $1e78293c4d0a3fa1$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $1e78293c4d0a3fa1$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $1e78293c4d0a3fa1$var$initSelectionObserver(o);
    const customElementObserver = $1e78293c4d0a3fa1$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $1e78293c4d0a3fa1$var$callbackWrapper(()=>{
        $1e78293c4d0a3fa1$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $1e78293c4d0a3fa1$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $1e78293c4d0a3fa1$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $1e78293c4d0a3fa1$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== "number") return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $1e78293c4d0a3fa1$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === "optionalAccess" || op === "optionalCall") && value == null) return undefined;
        if (op === "access" || op === "optionalAccess") {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === "call" || op === "optionalCall") {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $1e78293c4d0a3fa1$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $1e78293c4d0a3fa1$var$CrossOriginIframeMirror($1e78293c4d0a3fa1$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $1e78293c4d0a3fa1$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $1e78293c4d0a3fa1$var$CrossOriginIframeMirror($1e78293c4d0a3fa1$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $1e78293c4d0a3fa1$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener("message", this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $1e78293c4d0a3fa1$var$_optionalChain$1([
            this,
            "access",
            (_)=>_.loadListener,
            "optionalCall",
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== "rrweb" || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $1e78293c4d0a3fa1$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $1e78293c4d0a3fa1$var$EventType.Meta:
            case $1e78293c4d0a3fa1$var$EventType.Load:
            case $1e78293c4d0a3fa1$var$EventType.DomContentLoaded:
                return false;
            case $1e78293c4d0a3fa1$var$EventType.Plugin:
                return e;
            case $1e78293c4d0a3fa1$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    "id",
                    "parentId",
                    "previousId",
                    "nextId"
                ]);
                return e;
            case $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $1e78293c4d0a3fa1$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "nextId",
                                "previousId"
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "parentId",
                                "id"
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $1e78293c4d0a3fa1$var$IncrementalSource.Drag:
                    case $1e78293c4d0a3fa1$var$IncrementalSource.TouchMove:
                    case $1e78293c4d0a3fa1$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                "id"
                            ]);
                        });
                        return e;
                    case $1e78293c4d0a3fa1$var$IncrementalSource.ViewportResize:
                        return false;
                    case $1e78293c4d0a3fa1$var$IncrementalSource.MediaInteraction:
                    case $1e78293c4d0a3fa1$var$IncrementalSource.MouseInteraction:
                    case $1e78293c4d0a3fa1$var$IncrementalSource.Scroll:
                    case $1e78293c4d0a3fa1$var$IncrementalSource.CanvasMutation:
                    case $1e78293c4d0a3fa1$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        return e;
                    case $1e78293c4d0a3fa1$var$IncrementalSource.StyleSheetRule:
                    case $1e78293c4d0a3fa1$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleId"
                        ]);
                        return e;
                    case $1e78293c4d0a3fa1$var$IncrementalSource.Font:
                        return e;
                    case $1e78293c4d0a3fa1$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                "start",
                                "end"
                            ]);
                        });
                        return e;
                    case $1e78293c4d0a3fa1$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            "id"
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            "styleIds"
                        ]);
                        $1e78293c4d0a3fa1$var$_optionalChain$1([
                            e,
                            "access",
                            (_3)=>_3.data,
                            "access",
                            (_4)=>_4.styles,
                            "optionalAccess",
                            (_5)=>_5.forEach,
                            "call",
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        "styleId"
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            "id",
            "rootId"
        ]);
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $1e78293c4d0a3fa1$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ("childNodes" in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $1e78293c4d0a3fa1$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $1e78293c4d0a3fa1$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$1e78293c4d0a3fa1$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $1e78293c4d0a3fa1$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($1e78293c4d0a3fa1$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        setTimeout(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($1e78293c4d0a3fa1$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($1e78293c4d0a3fa1$var$patch(element.prototype, "attachShadow", function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $1e78293c4d0a3fa1$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $1e78293c4d0a3fa1$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $1e78293c4d0a3fa1$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $1e78293c4d0a3fa1$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ("_cssText" in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $1e78293c4d0a3fa1$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $1e78293c4d0a3fa1$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $1e78293c4d0a3fa1$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
function $1e78293c4d0a3fa1$var$wrapEvent(e) {
    const eWithTime = e;
    eWithTime.timestamp = $1e78293c4d0a3fa1$var$nowTimestamp();
    return eWithTime;
}
let $1e78293c4d0a3fa1$var$_takeFullSnapshot;
const $1e78293c4d0a3fa1$var$mirror = $1e78293c4d0a3fa1$var$createMirror();
function $1e78293c4d0a3fa1$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = "rr-mask", unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load", userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $1e78293c4d0a3fa1$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $1e78293c4d0a3fa1$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $1e78293c4d0a3fa1$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    const wrappedEmit = (e, isCheckout)=>{
        if ((0, $eca130af7684dd65$export$3cc482e6b02f32f7)([
            $1e78293c4d0a3fa1$var$mutationBuffers,
            "access",
            (_)=>_[0],
            "optionalAccess",
            (_2)=>_2.isFrozen,
            "call",
            (_3)=>_3()
        ]) && e.type !== $1e78293c4d0a3fa1$var$EventType.FullSnapshot && !(e.type === $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot && e.data.source === $1e78293c4d0a3fa1$var$IncrementalSource.Mutation)) $1e78293c4d0a3fa1$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $eca130af7684dd65$export$3cc482e6b02f32f7)([
            emit,
            "optionalCall",
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: "rrweb",
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, "*");
        }
        if (e.type === $1e78293c4d0a3fa1$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $1e78293c4d0a3fa1$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
            type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
            data: {
                source: $1e78293c4d0a3fa1$var$IncrementalSource.Mutation,
                ...m
            }
        }));
    };
    const wrappedScrollEmit = (p)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
            type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
            data: {
                source: $1e78293c4d0a3fa1$var$IncrementalSource.Scroll,
                ...p
            }
        }));
    const wrappedCanvasMutationEmit = (p)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
            type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
            data: {
                source: $1e78293c4d0a3fa1$var$IncrementalSource.CanvasMutation,
                ...p
            }
        }));
    const wrappedAdoptedStyleSheetEmit = (a)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
            type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
            data: {
                source: $1e78293c4d0a3fa1$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        }));
    const stylesheetManager = new $1e78293c4d0a3fa1$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new $1e78293c4d0a3fa1$var$IframeManagerNoop() : new $1e78293c4d0a3fa1$var$IframeManager({
        mirror: $1e78293c4d0a3fa1$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $1e78293c4d0a3fa1$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $1e78293c4d0a3fa1$var$ProcessedNodeManager();
    const canvasManager = $1e78293c4d0a3fa1$var$_getCanvasManager(getCanvasManager, {
        mirror: $1e78293c4d0a3fa1$var$mirror,
        win: window,
        mutationCb: (p)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                data: {
                    source: $1e78293c4d0a3fa1$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            })),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        sampling: sampling["canvas"],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $1e78293c4d0a3fa1$var$ShadowDomManagerNoop() : new $1e78293c4d0a3fa1$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $1e78293c4d0a3fa1$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
            type: $1e78293c4d0a3fa1$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $1e78293c4d0a3fa1$var$getWindowWidth(),
                height: $1e78293c4d0a3fa1$var$getWindowHeight()
            }
        }), isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $1e78293c4d0a3fa1$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $1e78293c4d0a3fa1$var$snapshot(document, {
            mirror: $1e78293c4d0a3fa1$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($1e78293c4d0a3fa1$var$isSerializedIframe(n, $1e78293c4d0a3fa1$var$mirror)) iframeManager.addIframe(n);
                if ($1e78293c4d0a3fa1$var$isSerializedStylesheet(n, $1e78293c4d0a3fa1$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($1e78293c4d0a3fa1$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
            type: $1e78293c4d0a3fa1$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $1e78293c4d0a3fa1$var$getWindowScroll(window)
            }
        }));
        $1e78293c4d0a3fa1$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $1e78293c4d0a3fa1$var$mirror.getId(document));
    };
    $1e78293c4d0a3fa1$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $1e78293c4d0a3fa1$var$callbackWrapper($1e78293c4d0a3fa1$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    })),
                inputCb: (v)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.Input,
                            ...v
                        }
                    })),
                mediaInteractionCb: (p)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    })),
                styleSheetRuleCb: (r)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    })),
                styleDeclarationCb: (r)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.Font,
                            ...p
                        }
                    })),
                selectionCb: (p)=>{
                    wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.Selection,
                            ...p
                        }
                    }));
                },
                customElementCb: (c)=>{
                    wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                        type: $1e78293c4d0a3fa1$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $1e78293c4d0a3fa1$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    }));
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $1e78293c4d0a3fa1$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $eca130af7684dd65$export$3cc482e6b02f32f7)([
                    plugins,
                    "optionalAccess",
                    (_5)=>_5.filter,
                    "call",
                    (_6)=>_6((p)=>p.observer),
                    "optionalAccess",
                    (_7)=>_7.map,
                    "call",
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                                        type: $1e78293c4d0a3fa1$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    }))
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else {
            handlers.push($1e78293c4d0a3fa1$var$on("DOMContentLoaded", ()=>{
                wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                    type: $1e78293c4d0a3fa1$var$EventType.DomContentLoaded,
                    data: {}
                }));
                if (recordAfter === "DOMContentLoaded") init();
            }));
            handlers.push($1e78293c4d0a3fa1$var$on("load", ()=>{
                wrappedEmit($1e78293c4d0a3fa1$var$wrapEvent({
                    type: $1e78293c4d0a3fa1$var$EventType.Load,
                    data: {}
                }));
                if (recordAfter === "load") init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $1e78293c4d0a3fa1$var$_takeFullSnapshot = undefined;
            $1e78293c4d0a3fa1$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $1e78293c4d0a3fa1$var$takeFullSnapshot(isCheckout) {
    if (!$1e78293c4d0a3fa1$var$_takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $1e78293c4d0a3fa1$var$_takeFullSnapshot(isCheckout);
}
$1e78293c4d0a3fa1$var$record.mirror = $1e78293c4d0a3fa1$var$mirror;
$1e78293c4d0a3fa1$var$record.takeFullSnapshot = $1e78293c4d0a3fa1$var$takeFullSnapshot;
function $1e78293c4d0a3fa1$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $1e78293c4d0a3fa1$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn("Unable to initialize CanvasManager");
        return new $1e78293c4d0a3fa1$var$CanvasManagerNoop();
    }
}
const $1e78293c4d0a3fa1$var$ReplayEventTypeIncrementalSnapshot = 3;
const $1e78293c4d0a3fa1$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $1e78293c4d0a3fa1$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $1e78293c4d0a3fa1$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $1e78293c4d0a3fa1$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $1e78293c4d0a3fa1$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $35a80961bb361df7$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $1e78293c4d0a3fa1$var$INTERACTIVE_SELECTOR = "button,a";
/** Get the closest interactive parent element, or else return the given element. */ function $1e78293c4d0a3fa1$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($1e78293c4d0a3fa1$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $1e78293c4d0a3fa1$var$getClickTargetNode(event) {
    const target = $1e78293c4d0a3fa1$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $1e78293c4d0a3fa1$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $1e78293c4d0a3fa1$var$getTargetNode(event) {
    if ($1e78293c4d0a3fa1$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $1e78293c4d0a3fa1$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $1e78293c4d0a3fa1$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $1e78293c4d0a3fa1$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$1e78293c4d0a3fa1$var$handlers) {
        $1e78293c4d0a3fa1$var$handlers = [];
        $1e78293c4d0a3fa1$var$monkeyPatchWindowOpen();
    }
    $1e78293c4d0a3fa1$var$handlers.push(cb);
    return ()=>{
        const pos = $1e78293c4d0a3fa1$var$handlers ? $1e78293c4d0a3fa1$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $1e78293c4d0a3fa1$var$handlers.splice(pos, 1);
    };
}
function $1e78293c4d0a3fa1$var$monkeyPatchWindowOpen() {
    (0, $4f81a26afd00acb9$export$9563e054e6f787fb)($1e78293c4d0a3fa1$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($1e78293c4d0a3fa1$var$handlers) try {
                $1e78293c4d0a3fa1$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($1e78293c4d0a3fa1$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $1e78293c4d0a3fa1$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $1e78293c4d0a3fa1$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $1e78293c4d0a3fa1$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $1e78293c4d0a3fa1$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $1e78293c4d0a3fa1$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($1e78293c4d0a3fa1$var$ignoreElement(node, this._ignoreSelector) || !$1e78293c4d0a3fa1$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $1e78293c4d0a3fa1$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $1e78293c4d0a3fa1$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $1e78293c4d0a3fa1$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $1e78293c4d0a3fa1$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $1e78293c4d0a3fa1$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $1e78293c4d0a3fa1$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $1e78293c4d0a3fa1$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $1e78293c4d0a3fa1$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $1e78293c4d0a3fa1$var$ignoreElement(node, ignoreSelector) {
    if (!$1e78293c4d0a3fa1$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $1e78293c4d0a3fa1$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $1e78293c4d0a3fa1$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $1e78293c4d0a3fa1$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$1e78293c4d0a3fa1$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $1e78293c4d0a3fa1$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $1e78293c4d0a3fa1$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($1e78293c4d0a3fa1$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $1e78293c4d0a3fa1$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $1e78293c4d0a3fa1$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $1e78293c4d0a3fa1$var$isIncrementalEvent(event) {
    return event.type === $1e78293c4d0a3fa1$var$ReplayEventTypeIncrementalSnapshot;
}
function $1e78293c4d0a3fa1$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $1e78293c4d0a3fa1$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $1e78293c4d0a3fa1$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $1e78293c4d0a3fa1$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($1e78293c4d0a3fa1$var$NodeType || ($1e78293c4d0a3fa1$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $1e78293c4d0a3fa1$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $1e78293c4d0a3fa1$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($1e78293c4d0a3fa1$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $1e78293c4d0a3fa1$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $1e78293c4d0a3fa1$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $1e78293c4d0a3fa1$var$handleClick(replay.clickDetector, result, $1e78293c4d0a3fa1$var$getClickTargetNode(handlerData.event));
        $1e78293c4d0a3fa1$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $1e78293c4d0a3fa1$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $1e78293c4d0a3fa1$var$record.mirror.getId(target);
    const node = nodeId && $1e78293c4d0a3fa1$var$record.mirror.getNode(nodeId);
    const meta = node && $1e78293c4d0a3fa1$var$record.mirror.getMeta(node);
    const element = meta && $1e78293c4d0a3fa1$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $1e78293c4d0a3fa1$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(""),
                attributes: $1e78293c4d0a3fa1$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $1e78293c4d0a3fa1$var$handleDom(handlerData) {
    const { target: target, message: message } = $1e78293c4d0a3fa1$var$getDomTarget(handlerData);
    return $1e78293c4d0a3fa1$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$1e78293c4d0a3fa1$var$getBaseDomBreadcrumb(target, message)
    });
}
function $1e78293c4d0a3fa1$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $1e78293c4d0a3fa1$var$getClickTargetNode(handlerData.event) : $1e78293c4d0a3fa1$var$getTargetNode(handlerData.event);
        message = (0, $987d30935b5a1a43$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $1e78293c4d0a3fa1$var$isElement(node) {
    return node.type === $1e78293c4d0a3fa1$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $1e78293c4d0a3fa1$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $1e78293c4d0a3fa1$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $1e78293c4d0a3fa1$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $1e78293c4d0a3fa1$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $1e78293c4d0a3fa1$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $987d30935b5a1a43$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $1e78293c4d0a3fa1$var$getBaseDomBreadcrumb(target, message);
    return $1e78293c4d0a3fa1$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $1e78293c4d0a3fa1$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $1e78293c4d0a3fa1$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $1e78293c4d0a3fa1$var$createResourceEntry,
    paint: $1e78293c4d0a3fa1$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $1e78293c4d0a3fa1$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $1e78293c4d0a3fa1$var$createPerformanceEntries(entries) {
    return entries.map($1e78293c4d0a3fa1$var$createPerformanceEntry).filter(Boolean);
}
function $1e78293c4d0a3fa1$var$createPerformanceEntry(entry) {
    if (!$1e78293c4d0a3fa1$var$ENTRY_TYPES[entry.entryType]) return null;
    return $1e78293c4d0a3fa1$var$ENTRY_TYPES[entry.entryType](entry);
}
function $1e78293c4d0a3fa1$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $b44690d12ec59e52$export$baf075a948ffc0bf) || $1e78293c4d0a3fa1$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $1e78293c4d0a3fa1$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $1e78293c4d0a3fa1$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $1e78293c4d0a3fa1$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $1e78293c4d0a3fa1$var$getAbsoluteTime(startTime),
        end: $1e78293c4d0a3fa1$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $1e78293c4d0a3fa1$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $1e78293c4d0a3fa1$var$getAbsoluteTime(startTime),
        end: $1e78293c4d0a3fa1$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $1e78293c4d0a3fa1$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $1e78293c4d0a3fa1$var$getAbsoluteTime(value);
    const data = {
        type: "largest-contentful-paint",
        name: "largest-contentful-paint",
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $1e78293c4d0a3fa1$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $1e78293c4d0a3fa1$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        clearCallbacks.push((0, $673eae9aafa78d9e$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $673eae9aafa78d9e$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($1e78293c4d0a3fa1$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1e78293c4d0a3fa1$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const $1e78293c4d0a3fa1$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $1e78293c4d0a3fa1$var$e() {
    const e = new Blob([
        $1e78293c4d0a3fa1$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $1e78293c4d0a3fa1$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$1e78293c4d0a3fa1$var$DEBUG_BUILD) return;
    (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $1e78293c4d0a3fa1$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $1e78293c4d0a3fa1$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$1e78293c4d0a3fa1$var$DEBUG_BUILD) return;
    (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $1e78293c4d0a3fa1$var$addLogBreadcrumb(message);
    }, 0);
}
function $1e78293c4d0a3fa1$var$addLogBreadcrumb(message) {
    (0, $dbaa48b6af64d774$export$efda9a273d7a036d)({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $1e78293c4d0a3fa1$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$1e78293c4d0a3fa1$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $1e78293c4d0a3fa1$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $1e78293c4d0a3fa1$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $1e78293c4d0a3fa1$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $1e78293c4d0a3fa1$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $1e78293c4d0a3fa1$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $1e78293c4d0a3fa1$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $1e78293c4d0a3fa1$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $1e78293c4d0a3fa1$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $1e78293c4d0a3fa1$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $1e78293c4d0a3fa1$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $1e78293c4d0a3fa1$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage("clear").then(null, (e)=>{
            $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $1e78293c4d0a3fa1$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $1e78293c4d0a3fa1$var$EventBufferArray();
        this._compression = new $1e78293c4d0a3fa1$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $1e78293c4d0a3fa1$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $1e78293c4d0a3fa1$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $1e78293c4d0a3fa1$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $1e78293c4d0a3fa1$var$logInfo("[Replay] Using simple buffer");
    return new $1e78293c4d0a3fa1$var$EventBufferArray();
}
function $1e78293c4d0a3fa1$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $1e78293c4d0a3fa1$var$_getWorkerUrl();
        if (!workerUrl) return;
        $1e78293c4d0a3fa1$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
        const worker = new Worker(workerUrl);
        return new $1e78293c4d0a3fa1$var$EventBufferProxy(worker);
    } catch (error) {
        $1e78293c4d0a3fa1$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
}
function $1e78293c4d0a3fa1$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $1e78293c4d0a3fa1$var$e();
    return "";
}
/** If sessionStorage is available. */ function $1e78293c4d0a3fa1$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $1e78293c4d0a3fa1$var$WINDOW && !!$1e78293c4d0a3fa1$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $1e78293c4d0a3fa1$var$clearSession(replay) {
    $1e78293c4d0a3fa1$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $1e78293c4d0a3fa1$var$deleteSession() {
    if (!$1e78293c4d0a3fa1$var$hasSessionStorage()) return;
    try {
        $1e78293c4d0a3fa1$var$WINDOW.sessionStorage.removeItem($1e78293c4d0a3fa1$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $1e78293c4d0a3fa1$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $1e78293c4d0a3fa1$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $8e0411c1e39b6e49$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $1e78293c4d0a3fa1$var$saveSession(session) {
    if (!$1e78293c4d0a3fa1$var$hasSessionStorage()) return;
    try {
        $1e78293c4d0a3fa1$var$WINDOW.sessionStorage.setItem($1e78293c4d0a3fa1$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $1e78293c4d0a3fa1$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $1e78293c4d0a3fa1$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $1e78293c4d0a3fa1$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $1e78293c4d0a3fa1$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $1e78293c4d0a3fa1$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $1e78293c4d0a3fa1$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $1e78293c4d0a3fa1$var$fetchSession(traceInternals) {
    if (!$1e78293c4d0a3fa1$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $1e78293c4d0a3fa1$var$WINDOW.sessionStorage.getItem($1e78293c4d0a3fa1$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $1e78293c4d0a3fa1$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $1e78293c4d0a3fa1$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $1e78293c4d0a3fa1$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $1e78293c4d0a3fa1$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $1e78293c4d0a3fa1$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $1e78293c4d0a3fa1$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $1e78293c4d0a3fa1$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$1e78293c4d0a3fa1$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $1e78293c4d0a3fa1$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $1e78293c4d0a3fa1$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $1e78293c4d0a3fa1$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $1e78293c4d0a3fa1$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$1e78293c4d0a3fa1$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $1e78293c4d0a3fa1$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $1e78293c4d0a3fa1$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $1e78293c4d0a3fa1$var$isCustomEvent(event) {
    return event.type === $1e78293c4d0a3fa1$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $1e78293c4d0a3fa1$var$addEventSync(replay, event, isCheckout) {
    if (!$1e78293c4d0a3fa1$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $1e78293c4d0a3fa1$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $1e78293c4d0a3fa1$var$addEvent(replay, event, isCheckout) {
    if (!$1e78293c4d0a3fa1$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $1e78293c4d0a3fa1$var$_addEvent(replay, event, isCheckout);
}
async function $1e78293c4d0a3fa1$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $1e78293c4d0a3fa1$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $1e78293c4d0a3fa1$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $1e78293c4d0a3fa1$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $1e78293c4d0a3fa1$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $1e78293c4d0a3fa1$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $1e78293c4d0a3fa1$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $1e78293c4d0a3fa1$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $1e78293c4d0a3fa1$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $1e78293c4d0a3fa1$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $1e78293c4d0a3fa1$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/** If the event is a feedback event */ function $1e78293c4d0a3fa1$var$isFeedbackEvent(event) {
    return event.type === "feedback";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $1e78293c4d0a3fa1$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $1e78293c4d0a3fa1$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$1e78293c4d0a3fa1$var$isErrorEvent(event) && !$1e78293c4d0a3fa1$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($1e78293c4d0a3fa1$var$isTransactionEvent(event)) {
            $1e78293c4d0a3fa1$var$handleTransactionEvent(replay, event);
            return;
        }
        $1e78293c4d0a3fa1$var$handleErrorEvent(replay, event);
    };
}
function $1e78293c4d0a3fa1$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $1e78293c4d0a3fa1$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== "buffer" || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) return;
    setTimeout(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function $1e78293c4d0a3fa1$var$isBaseTransportSend() {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $1e78293c4d0a3fa1$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$1e78293c4d0a3fa1$var$isErrorEvent(event)) return;
        $1e78293c4d0a3fa1$var$handleHydrationError(replay, event);
    };
}
function $1e78293c4d0a3fa1$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== "string") return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $1e78293c4d0a3fa1$var$createBreadcrumb({
            category: "replay.hydrate-error"
        });
        $1e78293c4d0a3fa1$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $1e78293c4d0a3fa1$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $1e78293c4d0a3fa1$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $1e78293c4d0a3fa1$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: "breadcrumb",
                payload: {
                    timestamp: event.timestamp,
                    type: "default",
                    category: "sentry.feedback",
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $1e78293c4d0a3fa1$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $1e78293c4d0a3fa1$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $1e78293c4d0a3fa1$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $1e78293c4d0a3fa1$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $1e78293c4d0a3fa1$var$handleAfterSendEvent(replay) : undefined;
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($1e78293c4d0a3fa1$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$1e78293c4d0a3fa1$var$isErrorEvent(event) && !$1e78293c4d0a3fa1$var$isTransactionEvent(event) && !$1e78293c4d0a3fa1$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($1e78293c4d0a3fa1$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $1e78293c4d0a3fa1$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($1e78293c4d0a3fa1$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $1e78293c4d0a3fa1$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: "Replay"
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $1e78293c4d0a3fa1$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $1e78293c4d0a3fa1$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $1e78293c4d0a3fa1$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $1e78293c4d0a3fa1$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $1e78293c4d0a3fa1$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $1e78293c4d0a3fa1$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $1e78293c4d0a3fa1$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($1e78293c4d0a3fa1$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $03b7478e7775e363$export$d92e61f5600202af)(url, (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $1e78293c4d0a3fa1$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($1e78293c4d0a3fa1$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $1e78293c4d0a3fa1$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $1e78293c4d0a3fa1$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function $1e78293c4d0a3fa1$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $1e78293c4d0a3fa1$var$handleFetch(handlerData);
        $1e78293c4d0a3fa1$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $1e78293c4d0a3fa1$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $85fd56d95444000b$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function $1e78293c4d0a3fa1$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $1e78293c4d0a3fa1$var$handleXhr(handlerData);
        $1e78293c4d0a3fa1$var$addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function $1e78293c4d0a3fa1$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $1e78293c4d0a3fa1$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $1e78293c4d0a3fa1$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $1e78293c4d0a3fa1$var$getBodyString(body) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $1e78293c4d0a3fa1$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
/** Merge a warning into an existing network request/response. */ function $1e78293c4d0a3fa1$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $1e78293c4d0a3fa1$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $4f81a26afd00acb9$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $1e78293c4d0a3fa1$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $1e78293c4d0a3fa1$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $1e78293c4d0a3fa1$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $1e78293c4d0a3fa1$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $1e78293c4d0a3fa1$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body
    };
    const exceedsSizeLimit = body.length > $1e78293c4d0a3fa1$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $1e78293c4d0a3fa1$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $1e78293c4d0a3fa1$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                "MAYBE_JSON_TRUNCATED"
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                "TEXT_TRUNCATED"
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $1e78293c4d0a3fa1$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $1e78293c4d0a3fa1$var$urlMatches(url, urls) {
    const fullUrl = $1e78293c4d0a3fa1$var$getFullUrl(url);
    return (0, $3ded168be62470b2$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $1e78293c4d0a3fa1$var$getFullUrl(url, baseURI = $1e78293c4d0a3fa1$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($1e78293c4d0a3fa1$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $1e78293c4d0a3fa1$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $1e78293c4d0a3fa1$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $1e78293c4d0a3fa1$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $1e78293c4d0a3fa1$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $1e78293c4d0a3fa1$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = input ? $1e78293c4d0a3fa1$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $1e78293c4d0a3fa1$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $1e78293c4d0a3fa1$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $1e78293c4d0a3fa1$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $1e78293c4d0a3fa1$var$urlMatches(url, options.networkDetailAllowUrls) && !$1e78293c4d0a3fa1$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $1e78293c4d0a3fa1$var$_getRequestInfo(options, hint.input, requestBodySize) : $1e78293c4d0a3fa1$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $1e78293c4d0a3fa1$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $1e78293c4d0a3fa1$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $1e78293c4d0a3fa1$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $1e78293c4d0a3fa1$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $1e78293c4d0a3fa1$var$getBodyString(requestBody);
    const data = $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $1e78293c4d0a3fa1$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $1e78293c4d0a3fa1$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $1e78293c4d0a3fa1$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $1e78293c4d0a3fa1$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $1e78293c4d0a3fa1$var$_parseFetchResponseBody(response);
    const result = $1e78293c4d0a3fa1$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        textEncoder: textEncoder,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $1e78293c4d0a3fa1$var$mergeWarning(result, warning);
    return result;
}
function $1e78293c4d0a3fa1$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $1e78293c4d0a3fa1$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $1e78293c4d0a3fa1$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Failed to serialize response body", error);
        // fallback
        return $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $1e78293c4d0a3fa1$var$_parseFetchResponseBody(response) {
    const res = $1e78293c4d0a3fa1$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        "BODY_PARSE_ERROR"
    ];
    try {
        const text = await $1e78293c4d0a3fa1$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Failed to get text body from response", error);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
}
function $1e78293c4d0a3fa1$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $1e78293c4d0a3fa1$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $1e78293c4d0a3fa1$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $1e78293c4d0a3fa1$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $1e78293c4d0a3fa1$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $1e78293c4d0a3fa1$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $1e78293c4d0a3fa1$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $1e78293c4d0a3fa1$var$getAllowedHeaders(headers, allowedHeaders);
}
function $1e78293c4d0a3fa1$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Failed to clone response body", error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $1e78293c4d0a3fa1$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = setTimeout(()=>reject(new Error("Timeout while trying to read response body")), 500);
        $1e78293c4d0a3fa1$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $1e78293c4d0a3fa1$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $1e78293c4d0a3fa1$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $1e78293c4d0a3fa1$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $1e78293c4d0a3fa1$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $1e78293c4d0a3fa1$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("[Replay] Failed to capture xhr breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $1e78293c4d0a3fa1$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $1e78293c4d0a3fa1$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $1e78293c4d0a3fa1$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $1e78293c4d0a3fa1$var$_getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $1e78293c4d0a3fa1$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$1e78293c4d0a3fa1$var$urlMatches(url, options.networkDetailAllowUrls) || $1e78293c4d0a3fa1$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $1e78293c4d0a3fa1$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $1e78293c4d0a3fa1$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $85fd56d95444000b$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $1e78293c4d0a3fa1$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $1e78293c4d0a3fa1$var$getAllowedHeaders($1e78293c4d0a3fa1$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $1e78293c4d0a3fa1$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $1e78293c4d0a3fa1$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $1e78293c4d0a3fa1$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $1e78293c4d0a3fa1$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $1e78293c4d0a3fa1$var$mergeWarning(response, responseWarning) : response
    };
}
function $1e78293c4d0a3fa1$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $1e78293c4d0a3fa1$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $1e78293c4d0a3fa1$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Failed to get xhr response body", ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $1e78293c4d0a3fa1$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === "json" && body && typeof body === "object") return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Failed to serialize body", body);
        return [
            undefined,
            "BODY_PARSE_ERROR"
        ];
    }
    $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).info("[Replay] Skipping network body because of body type", body);
    return [
        undefined,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $1e78293c4d0a3fa1$var$_getBodySize(body, responseType, textEncoder) {
    try {
        const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
        return $1e78293c4d0a3fa1$var$getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $1e78293c4d0a3fa1$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$1e78293c4d0a3fa1$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $393ca4cf55d29319$export$f75d3c772c923df0)($1e78293c4d0a3fa1$var$handleFetchSpanListener(replay));
            (0, $85fd56d95444000b$export$26ace48dd54c9aea)($1e78293c4d0a3fa1$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $1e78293c4d0a3fa1$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($1e78293c4d0a3fa1$var$_isXhrBreadcrumb(breadcrumb) && $1e78293c4d0a3fa1$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $1e78293c4d0a3fa1$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $1e78293c4d0a3fa1$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($1e78293c4d0a3fa1$var$_isFetchBreadcrumb(breadcrumb) && $1e78293c4d0a3fa1$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $1e78293c4d0a3fa1$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $1e78293c4d0a3fa1$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $1e78293c4d0a3fa1$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $1e78293c4d0a3fa1$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $1e78293c4d0a3fa1$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $1e78293c4d0a3fa1$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $1e78293c4d0a3fa1$var$_LAST_BREADCRUMB = null;
function $1e78293c4d0a3fa1$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $1e78293c4d0a3fa1$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $1e78293c4d0a3fa1$var$handleScope(scope);
        if (!result) return;
        $1e78293c4d0a3fa1$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $1e78293c4d0a3fa1$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($1e78293c4d0a3fa1$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $1e78293c4d0a3fa1$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$1e78293c4d0a3fa1$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $1e78293c4d0a3fa1$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $1e78293c4d0a3fa1$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $1e78293c4d0a3fa1$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $1e78293c4d0a3fa1$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $1e78293c4d0a3fa1$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $1e78293c4d0a3fa1$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $35a80961bb361df7$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $1e78293c4d0a3fa1$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $1e78293c4d0a3fa1$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $1e78293c4d0a3fa1$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $1e78293c4d0a3fa1$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    scope.addScopeListener($1e78293c4d0a3fa1$var$handleScopeListener(replay));
    (0, $3d9d919d2542148e$export$5aeffd3db2cf9df7)($1e78293c4d0a3fa1$var$handleDomListener(replay));
    (0, $ea2feddc8f99ab63$export$3f18c56c58114e75)($1e78293c4d0a3fa1$var$handleHistorySpanListener(replay));
    $1e78293c4d0a3fa1$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $1e78293c4d0a3fa1$var$handleGlobalEventListener(replay, !$1e78293c4d0a3fa1$var$hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, $650e462234d20c92$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($1e78293c4d0a3fa1$var$hasHooks(client)) {
        client.on("beforeSendEvent", $1e78293c4d0a3fa1$var$handleBeforeSendEvent(replay));
        client.on("afterSendEvent", $1e78293c4d0a3fa1$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on("beforeSendFeedback", (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1e78293c4d0a3fa1$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $1e78293c4d0a3fa1$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($1e78293c4d0a3fa1$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $1e78293c4d0a3fa1$var$createMemoryEntry($1e78293c4d0a3fa1$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $1e78293c4d0a3fa1$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $1e78293c4d0a3fa1$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $1e78293c4d0a3fa1$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $1e78293c4d0a3fa1$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$1e78293c4d0a3fa1$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $1e78293c4d0a3fa1$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $1e78293c4d0a3fa1$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $1e78293c4d0a3fa1$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $1e78293c4d0a3fa1$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $1e78293c4d0a3fa1$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $1e78293c4d0a3fa1$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $1e78293c4d0a3fa1$var$addEventSync(replay, $1e78293c4d0a3fa1$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $1e78293c4d0a3fa1$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $1acad3161cb11d68$export$f93f7f385160c44e)((0, $1acad3161cb11d68$export$92b6093782fe661b)(replayEvent, (0, $1acad3161cb11d68$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $1e78293c4d0a3fa1$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $1e78293c4d0a3fa1$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $e424e8186a197aac$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $9c33807712fa1c9d$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $1e78293c4d0a3fa1$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $1e78293c4d0a3fa1$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    const scope = (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $1e78293c4d0a3fa1$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $1e78293c4d0a3fa1$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $1e78293c4d0a3fa1$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $1e78293c4d0a3fa1$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($1e78293c4d0a3fa1$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $1e78293c4d0a3fa1$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $abdb270ed536ed67$export$699aff705e0d49d4)({}, response);
    if ((0, $abdb270ed536ed67$export$6c91fec22056810a)(rateLimits, "replay")) throw new $1e78293c4d0a3fa1$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $1e78293c4d0a3fa1$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $1e78293c4d0a3fa1$var$RateLimitError extends Error {
    constructor(rateLimits){
        super("Rate limit hit");
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $1e78293c4d0a3fa1$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $1e78293c4d0a3fa1$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $1e78293c4d0a3fa1$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $1e78293c4d0a3fa1$var$TransportStatusCodeError || err instanceof $1e78293c4d0a3fa1$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $dbaa48b6af64d774$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ($1e78293c4d0a3fa1$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $dbaa48b6af64d774$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $1e78293c4d0a3fa1$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$1e78293c4d0a3fa1$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $1e78293c4d0a3fa1$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $1e78293c4d0a3fa1$var$THROTTLED = "__THROTTLED";
const $1e78293c4d0a3fa1$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1e78293c4d0a3fa1$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $1e78293c4d0a3fa1$var$SKIPPED : $1e78293c4d0a3fa1$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $1e78293c4d0a3fa1$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $1e78293c4d0a3fa1$var$ReplayContainer.prototype.__init.call(this);
        $1e78293c4d0a3fa1$var$ReplayContainer.prototype.__init2.call(this);
        $1e78293c4d0a3fa1$var$ReplayContainer.prototype.__init3.call(this);
        $1e78293c4d0a3fa1$var$ReplayContainer.prototype.__init4.call(this);
        $1e78293c4d0a3fa1$var$ReplayContainer.prototype.__init5.call(this);
        $1e78293c4d0a3fa1$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $1e78293c4d0a3fa1$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $1e78293c4d0a3fa1$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $1e78293c4d0a3fa1$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $1e78293c4d0a3fa1$var$throttle((event, isCheckout)=>$1e78293c4d0a3fa1$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($1e78293c4d0a3fa1$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $1e78293c4d0a3fa1$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $1e78293c4d0a3fa1$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $1e78293c4d0a3fa1$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $1e78293c4d0a3fa1$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        const session = $1e78293c4d0a3fa1$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $1e78293c4d0a3fa1$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $1e78293c4d0a3fa1$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $1e78293c4d0a3fa1$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $1e78293c4d0a3fa1$var$BUFFER_CHECKOUT_TIME
                },
                emit: $1e78293c4d0a3fa1$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $1e78293c4d0a3fa1$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $1e78293c4d0a3fa1$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $1e78293c4d0a3fa1$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $1e78293c4d0a3fa1$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $1e78293c4d0a3fa1$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $1e78293c4d0a3fa1$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$1e78293c4d0a3fa1$var$WINDOW.location.pathname}${$1e78293c4d0a3fa1$var$WINDOW.location.hash}${$1e78293c4d0a3fa1$var$WINDOW.location.search}`;
        const url = `${$1e78293c4d0a3fa1$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $1e78293c4d0a3fa1$var$THROTTLED) {
            const breadcrumb = $1e78293c4d0a3fa1$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$1e78293c4d0a3fa1$var$addEventSync(this, {
                    type: $1e78293c4d0a3fa1$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        // eslint-disable-next-line deprecation/deprecation
        const lastTransaction = this.lastTransaction || (0, $dbaa48b6af64d774$export$c7be4b0125a10cba)().getTransaction();
        const attributes = lastTransaction && (0, $3c6c3464b56596d8$export$92d8c23565496537)(lastTransaction).data || {};
        const source = attributes[0, $96dae9fbf54762e8$export$d7a7d984b0791405];
        if (!lastTransaction || !source || ![
            "route",
            "custom"
        ].includes(source)) return undefined;
        return (0, $3c6c3464b56596d8$export$92d8c23565496537)(lastTransaction).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $1e78293c4d0a3fa1$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("[Replay]", error);
        if ($1e78293c4d0a3fa1$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $dbaa48b6af64d774$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $1e78293c4d0a3fa1$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($1e78293c4d0a3fa1$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $1e78293c4d0a3fa1$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $1e78293c4d0a3fa1$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $1e78293c4d0a3fa1$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $1e78293c4d0a3fa1$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $1e78293c4d0a3fa1$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $1e78293c4d0a3fa1$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $1e78293c4d0a3fa1$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $1e78293c4d0a3fa1$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $1e78293c4d0a3fa1$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $1e78293c4d0a3fa1$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($1e78293c4d0a3fa1$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $1e78293c4d0a3fa1$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $1e78293c4d0a3fa1$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $1e78293c4d0a3fa1$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $1e78293c4d0a3fa1$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $1e78293c4d0a3fa1$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $1e78293c4d0a3fa1$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $1e78293c4d0a3fa1$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($1e78293c4d0a3fa1$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $1e78293c4d0a3fa1$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $1e78293c4d0a3fa1$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $1e78293c4d0a3fa1$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $1e78293c4d0a3fa1$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $1e78293c4d0a3fa1$var$DEBUG_BUILD && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $1e78293c4d0a3fa1$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $1e78293c4d0a3fa1$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $1e78293c4d0a3fa1$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        (0, $fa8e8d8acc41a310$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
        });
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $1e78293c4d0a3fa1$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $1e78293c4d0a3fa1$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $1e78293c4d0a3fa1$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $1e78293c4d0a3fa1$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $1e78293c4d0a3fa1$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $1e78293c4d0a3fa1$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $1e78293c4d0a3fa1$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === "value" && el.tagName === "INPUT" && [
        "submit",
        "button"
    ].includes(el.getAttribute("type") || "")) return value.replace(/[\S]/g, "*");
    return value;
}
const $1e78293c4d0a3fa1$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $1e78293c4d0a3fa1$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $1e78293c4d0a3fa1$var$_initialized = false;
const $1e78293c4d0a3fa1$export$d7706faf7ab354bf = (options)=>{
    // eslint-disable-next-line deprecation/deprecation
    return new $1e78293c4d0a3fa1$export$a35c789ed37ee0f7(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ class $1e78293c4d0a3fa1$export$a35c789ed37ee0f7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $1e78293c4d0a3fa1$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $1e78293c4d0a3fa1$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $1e78293c4d0a3fa1$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $1e78293c4d0a3fa1$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        "title",
        "placeholder"
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        // eslint-disable-next-line deprecation/deprecation
        this.name = $1e78293c4d0a3fa1$export$a35c789ed37ee0f7.id;
        const privacyOptions = $1e78293c4d0a3fa1$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$1e78293c4d0a3fa1$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $1e78293c4d0a3fa1$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $1e78293c4d0a3fa1$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $1e78293c4d0a3fa1$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $1e78293c4d0a3fa1$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $1e78293c4d0a3fa1$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$1e78293c4d0a3fa1$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $0a5a77464a1317ad$export$4e09c449d6c407f7)()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $1e78293c4d0a3fa1$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $1e78293c4d0a3fa1$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $0a5a77464a1317ad$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $1e78293c4d0a3fa1$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $1e78293c4d0a3fa1$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
            if (!canvasIntegration) return;
            this._replay["_canvas"] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$1e78293c4d0a3fa1$export$a35c789ed37ee0f7.__initStatic();
/** Parse Replay-related options from SDK options */ function $1e78293c4d0a3fa1$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $4f81a26afd00acb9$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $fa8e8d8acc41a310$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("SDK client is not available.");
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, $fa8e8d8acc41a310$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    });
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $1e78293c4d0a3fa1$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$1e78293c4d0a3fa1$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function $1e78293c4d0a3fa1$export$b28310b2f161456b() {
    const client = (0, $dbaa48b6af64d774$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName && client.getIntegrationByName("Replay");
}








let $e880cf40978a3170$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $67837210becc2ddc$export$56d8a8a25bd48b81).Sentry && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).Sentry.Integrations) $e880cf40978a3170$var$windowIntegrations = (0, $67837210becc2ddc$export$56d8a8a25bd48b81).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $e880cf40978a3170$export$99d02219d259eb94 = {
    ...$e880cf40978a3170$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $aee0925ccd2f4df9$export$99d02219d259eb94),
    ...$276e39e69e01803e$exports
};




var $af10e3f63daf3025$exports = {};
"use strict";
var $426c7baebabc049b$exports = {};
"use strict";

$426c7baebabc049b$exports = (parcelRequire("hFtc0"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $af10e3f63daf3025$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $af10e3f63daf3025$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $af10e3f63daf3025$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $af10e3f63daf3025$var$TYPE_STATICS = {};
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.ForwardRef] = $af10e3f63daf3025$var$FORWARD_REF_STATICS;
$af10e3f63daf3025$var$TYPE_STATICS[$426c7baebabc049b$exports.Memo] = $af10e3f63daf3025$var$MEMO_STATICS;
function $af10e3f63daf3025$var$getStatics(component) {
    // React v16.11 and below
    if ($426c7baebabc049b$exports.isMemo(component)) return $af10e3f63daf3025$var$MEMO_STATICS;
     // React v16.12 and above
    return $af10e3f63daf3025$var$TYPE_STATICS[component["$$typeof"]] || $af10e3f63daf3025$var$REACT_STATICS;
}
var $af10e3f63daf3025$var$defineProperty = Object.defineProperty;
var $af10e3f63daf3025$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $af10e3f63daf3025$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $af10e3f63daf3025$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $af10e3f63daf3025$var$getPrototypeOf = Object.getPrototypeOf;
var $af10e3f63daf3025$var$objectPrototype = Object.prototype;
function $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($af10e3f63daf3025$var$objectPrototype) {
            var inheritedComponent = $af10e3f63daf3025$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $af10e3f63daf3025$var$objectPrototype) $af10e3f63daf3025$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $af10e3f63daf3025$var$getOwnPropertyNames(sourceComponent);
        if ($af10e3f63daf3025$var$getOwnPropertySymbols) keys = keys.concat($af10e3f63daf3025$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $af10e3f63daf3025$var$getStatics(targetComponent);
        var sourceStatics = $af10e3f63daf3025$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$af10e3f63daf3025$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $af10e3f63daf3025$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $af10e3f63daf3025$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$af10e3f63daf3025$exports = $af10e3f63daf3025$var$hoistNonReactStatics;



var $6cds3 = parcelRequire("6cds3");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9453c67056eae3cf$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


const $56f2f765e8af6e24$var$_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
let $56f2f765e8af6e24$var$activeTransaction;
let $56f2f765e8af6e24$var$_useEffect;
let $56f2f765e8af6e24$var$_useLocation;
let $56f2f765e8af6e24$var$_useNavigationType;
let $56f2f765e8af6e24$var$_createRoutesFromChildren;
let $56f2f765e8af6e24$var$_matchRoutes;
let $56f2f765e8af6e24$var$_customStartTransaction;
let $56f2f765e8af6e24$var$_startTransactionOnLocationChange;
let $56f2f765e8af6e24$var$_stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function $56f2f765e8af6e24$export$47113a480541ff59(options) {
    const integration = (0, $5623538de79d54f3$export$b4109253475213e9)({
        ...options,
        instrumentPageLoad: false,
        instrumentNavigation: false
    });
    const { useEffect: useEffect, useLocation: useLocation, useNavigationType: useNavigationType, createRoutesFromChildren: createRoutesFromChildren, matchRoutes: matchRoutes, stripBasename: stripBasename, instrumentPageLoad: instrumentPageLoad = true, instrumentNavigation: instrumentNavigation = true } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationCallback = (startSpanOptions)=>{
                (0, $5623538de79d54f3$export$7d159749bd9969ad)(client, startSpanOptions);
                return undefined;
            };
            const initPathName = (0, $67837210becc2ddc$export$56d8a8a25bd48b81) && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).location && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).location.pathname;
            if (instrumentPageLoad && initPathName) (0, $5623538de79d54f3$export$aa44a07f82af519f)(client, {
                name: initPathName,
                attributes: {
                    [(0, $96dae9fbf54762e8$export$d7a7d984b0791405)]: "url",
                    [(0, $96dae9fbf54762e8$export$1a413bd9a88fdb09)]: "pageload",
                    [(0, $96dae9fbf54762e8$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
                }
            });
            $56f2f765e8af6e24$var$_useEffect = useEffect;
            $56f2f765e8af6e24$var$_useLocation = useLocation;
            $56f2f765e8af6e24$var$_useNavigationType = useNavigationType;
            $56f2f765e8af6e24$var$_matchRoutes = matchRoutes;
            $56f2f765e8af6e24$var$_createRoutesFromChildren = createRoutesFromChildren;
            $56f2f765e8af6e24$var$_stripBasename = stripBasename || false;
            $56f2f765e8af6e24$var$_customStartTransaction = startNavigationCallback;
            $56f2f765e8af6e24$var$_startTransactionOnLocationChange = instrumentNavigation;
        }
    };
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function $56f2f765e8af6e24$export$e6e76890c5208db1(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return (customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        const initPathName = (0, $67837210becc2ddc$export$56d8a8a25bd48b81) && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).location && (0, $67837210becc2ddc$export$56d8a8a25bd48b81).location.pathname;
        if (startTransactionOnPageLoad && initPathName) $56f2f765e8af6e24$var$activeTransaction = customStartTransaction({
            name: initPathName,
            attributes: {
                [(0, $96dae9fbf54762e8$export$d7a7d984b0791405)]: "url",
                [(0, $96dae9fbf54762e8$export$1a413bd9a88fdb09)]: "pageload",
                [(0, $96dae9fbf54762e8$export$cca8dd30f57f805e)]: "auto.pageload.react.reactrouter_v6"
            }
        });
        $56f2f765e8af6e24$var$_useEffect = useEffect;
        $56f2f765e8af6e24$var$_useLocation = useLocation;
        $56f2f765e8af6e24$var$_useNavigationType = useNavigationType;
        $56f2f765e8af6e24$var$_matchRoutes = matchRoutes;
        $56f2f765e8af6e24$var$_createRoutesFromChildren = createRoutesFromChildren;
        $56f2f765e8af6e24$var$_stripBasename = stripBasename || false;
        $56f2f765e8af6e24$var$_customStartTransaction = customStartTransaction;
        $56f2f765e8af6e24$var$_startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function $56f2f765e8af6e24$var$stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return pathname;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    const startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    const nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return pathname;
    return pathname.slice(startIndex) || "/";
}
function $56f2f765e8af6e24$var$getNormalizedName(routes, location, branches, basename = "") {
    if (!routes || routes.length === 0) return [
        $56f2f765e8af6e24$var$_stripBasename ? $56f2f765e8af6e24$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
    let pathBuilder = "";
    if (branches) // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let x = 0; x < branches.length; x++){
        const branch = branches[x];
        const route = branch.route;
        if (route) {
            // Early return if index route
            if (route.index) return [
                $56f2f765e8af6e24$var$_stripBasename ? $56f2f765e8af6e24$var$stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                "route"
            ];
            const path = route.path;
            if (path) {
                const newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : `/${path}`;
                pathBuilder += newPath;
                if (basename + branch.pathname === location.pathname) {
                    if (// If the route defined on the element is something like
                    // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                    // We should check against the branch.pathname for the number of / seperators
                    (0, $3b64804f5aea203a$export$69dd85280a8d374c)(pathBuilder) !== (0, $3b64804f5aea203a$export$69dd85280a8d374c)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                    pathBuilder.slice(-2) !== "/*") return [
                        ($56f2f765e8af6e24$var$_stripBasename ? "" : basename) + newPath,
                        "route"
                    ];
                    return [
                        ($56f2f765e8af6e24$var$_stripBasename ? "" : basename) + pathBuilder,
                        "route"
                    ];
                }
            }
        }
    }
    return [
        $56f2f765e8af6e24$var$_stripBasename ? $56f2f765e8af6e24$var$stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function $56f2f765e8af6e24$var$updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $56f2f765e8af6e24$var$_matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        const [name, source] = $56f2f765e8af6e24$var$getNormalizedName(routes, location, branches, basename);
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute((0, $96dae9fbf54762e8$export$d7a7d984b0791405), source);
    }
}
function $56f2f765e8af6e24$var$handleNavigation(location, routes, navigationType, matches, basename) {
    const branches = Array.isArray(matches) ? matches : $56f2f765e8af6e24$var$_matchRoutes(routes, location, basename);
    if ($56f2f765e8af6e24$var$_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if ($56f2f765e8af6e24$var$activeTransaction) $56f2f765e8af6e24$var$activeTransaction.end();
        const [name, source] = $56f2f765e8af6e24$var$getNormalizedName(routes, location, branches, basename);
        $56f2f765e8af6e24$var$activeTransaction = $56f2f765e8af6e24$var$_customStartTransaction({
            name: name,
            attributes: {
                [(0, $96dae9fbf54762e8$export$d7a7d984b0791405)]: source,
                [(0, $96dae9fbf54762e8$export$1a413bd9a88fdb09)]: "navigation",
                [(0, $96dae9fbf54762e8$export$cca8dd30f57f805e)]: "auto.navigation.react.reactrouter_v6"
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $56f2f765e8af6e24$export$c6111e8561a02a8b(Routes) {
    if (!$56f2f765e8af6e24$var$_useEffect || !$56f2f765e8af6e24$var$_useLocation || !$56f2f765e8af6e24$var$_useNavigationType || !$56f2f765e8af6e24$var$_createRoutesFromChildren || !$56f2f765e8af6e24$var$_matchRoutes || !$56f2f765e8af6e24$var$_customStartTransaction) {
        (0, $9453c67056eae3cf$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn(`reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.
      useEffect: ${$56f2f765e8af6e24$var$_useEffect}. useLocation: ${$56f2f765e8af6e24$var$_useLocation}. useNavigationType: ${$56f2f765e8af6e24$var$_useNavigationType}.
      createRoutesFromChildren: ${$56f2f765e8af6e24$var$_createRoutesFromChildren}. matchRoutes: ${$56f2f765e8af6e24$var$_matchRoutes}. customStartTransaction: ${$56f2f765e8af6e24$var$_customStartTransaction}.`);
        return Routes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const location = $56f2f765e8af6e24$var$_useLocation();
        const navigationType = $56f2f765e8af6e24$var$_useNavigationType();
        $56f2f765e8af6e24$var$_useEffect(()=>{
            const routes = $56f2f765e8af6e24$var$_createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                $56f2f765e8af6e24$var$updatePageloadTransaction($56f2f765e8af6e24$var$getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else $56f2f765e8af6e24$var$handleNavigation(location, routes, navigationType);
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return $6cds3.createElement(Routes, {
            ...props,
            __self: this,
            __source: {
                fileName: $56f2f765e8af6e24$var$_jsxFileName,
                lineNumber: 329
            }
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($af10e3f63daf3025$exports)))(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function $56f2f765e8af6e24$export$1f41b3e298c8040f(origUseRoutes) {
    if (!$56f2f765e8af6e24$var$_useEffect || !$56f2f765e8af6e24$var$_useLocation || !$56f2f765e8af6e24$var$_useNavigationType || !$56f2f765e8af6e24$var$_matchRoutes || !$56f2f765e8af6e24$var$_customStartTransaction) {
        (0, $9453c67056eae3cf$export$16a28057038b10ef) && (0, $fa8e8d8acc41a310$export$af88d00dbe7f521).warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    let isMountRenderPass = true;
    const SentryRoutes = (props)=>{
        const { routes: routes, locationArg: locationArg } = props;
        const Routes = origUseRoutes(routes, locationArg);
        const location = $56f2f765e8af6e24$var$_useLocation();
        const navigationType = $56f2f765e8af6e24$var$_useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        const stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        $56f2f765e8af6e24$var$_useEffect(()=>{
            const normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                $56f2f765e8af6e24$var$updatePageloadTransaction($56f2f765e8af6e24$var$getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else $56f2f765e8af6e24$var$handleNavigation(normalizedLocation, routes, navigationType);
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return (routes, locationArg)=>{
        return $6cds3.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: this,
            __source: {
                fileName: $56f2f765e8af6e24$var$_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function $56f2f765e8af6e24$export$7f4c656bd7ebbb6b(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        const router = createRouterFunction(routes, opts);
        const basename = opts && opts.basename;
        const activeRootSpan = $56f2f765e8af6e24$var$getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) $56f2f765e8af6e24$var$updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        router.subscribe((state)=>{
            const location = state.location;
            if ($56f2f765e8af6e24$var$_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) $56f2f765e8af6e24$var$handleNavigation(location, routes, state.historyAction, undefined, basename);
        });
        return router;
    };
}
function $56f2f765e8af6e24$var$getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if ($56f2f765e8af6e24$var$activeTransaction) return $56f2f765e8af6e24$var$activeTransaction;
    const span = (0, $6e4ea71dfdcc0bfd$export$1be426a8e585c83e)();
    const rootSpan = span ? (0, $91673f51e515ea64$export$c4c6a79b1260ca1b)(span) : undefined;
    if (!rootSpan) return undefined;
    const op = (0, $3c6c3464b56596d8$export$92d8c23565496537)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}


/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $96b280a33643b696$var$_extends() {
    $96b280a33643b696$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96b280a33643b696$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $96b280a33643b696$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($96b280a33643b696$export$e19cd5f9376f8cee || ($96b280a33643b696$export$e19cd5f9376f8cee = {}));
const $96b280a33643b696$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $96b280a33643b696$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $96b280a33643b696$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $96b280a33643b696$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $96b280a33643b696$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $96b280a33643b696$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $96b280a33643b696$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $96b280a33643b696$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $96b280a33643b696$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $96b280a33643b696$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $96b280a33643b696$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $96b280a33643b696$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $96b280a33643b696$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $96b280a33643b696$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $96b280a33643b696$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $96b280a33643b696$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $96b280a33643b696$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($96b280a33643b696$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $96b280a33643b696$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $96b280a33643b696$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $96b280a33643b696$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($96b280a33643b696$var$ResultType || ($96b280a33643b696$var$ResultType = {}));
const $96b280a33643b696$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $96b280a33643b696$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $96b280a33643b696$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $96b280a33643b696$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($96b280a33643b696$var$isIndexRoute(route)) {
            let indexRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $96b280a33643b696$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $96b280a33643b696$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $96b280a33643b696$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $96b280a33643b696$var$flattenRoutes(routes);
    $96b280a33643b696$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $96b280a33643b696$var$decodePath(pathname);
        matches = $96b280a33643b696$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $96b280a33643b696$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $96b280a33643b696$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $96b280a33643b696$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $96b280a33643b696$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $96b280a33643b696$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $96b280a33643b696$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $96b280a33643b696$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $96b280a33643b696$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $96b280a33643b696$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $96b280a33643b696$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $96b280a33643b696$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $96b280a33643b696$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $96b280a33643b696$var$paramRe = /^:[\w-]+$/;
const $96b280a33643b696$var$dynamicSegmentValue = 3;
const $96b280a33643b696$var$indexRouteValue = 2;
const $96b280a33643b696$var$emptySegmentValue = 1;
const $96b280a33643b696$var$staticSegmentValue = 10;
const $96b280a33643b696$var$splatPenalty = -2;
const $96b280a33643b696$var$isSplat = (s)=>s === "*";
function $96b280a33643b696$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($96b280a33643b696$var$isSplat)) initialScore += $96b280a33643b696$var$splatPenalty;
    if (index) initialScore += $96b280a33643b696$var$indexRouteValue;
    return segments.filter((s)=>!$96b280a33643b696$var$isSplat(s)).reduce((score, segment)=>score + ($96b280a33643b696$var$paramRe.test(segment) ? $96b280a33643b696$var$dynamicSegmentValue : segment === "" ? $96b280a33643b696$var$emptySegmentValue : $96b280a33643b696$var$staticSegmentValue), initialScore);
}
function $96b280a33643b696$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $96b280a33643b696$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $96b280a33643b696$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $96b280a33643b696$export$a5c6d149b50c1d86($96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $96b280a33643b696$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $96b280a33643b696$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $96b280a33643b696$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $96b280a33643b696$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $96b280a33643b696$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $96b280a33643b696$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $96b280a33643b696$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $96b280a33643b696$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $96b280a33643b696$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $96b280a33643b696$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $96b280a33643b696$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $96b280a33643b696$var$normalizeSearch(search),
        hash: $96b280a33643b696$var$normalizeHash(hash)
    };
}
function $96b280a33643b696$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $96b280a33643b696$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $96b280a33643b696$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $96b280a33643b696$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $96b280a33643b696$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $96b280a33643b696$export$8ccf933b0513f8d0(toArg);
    else {
        to = $96b280a33643b696$var$_extends({}, toArg);
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $96b280a33643b696$var$getInvalidPathError("?", "pathname", "search", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "pathname", "hash", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $96b280a33643b696$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $96b280a33643b696$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $96b280a33643b696$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $96b280a33643b696$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $96b280a33643b696$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $96b280a33643b696$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $96b280a33643b696$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $96b280a33643b696$export$42a99a7a4bc0e76a extends Error {
}
class $96b280a33643b696$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $96b280a33643b696$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $96b280a33643b696$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $96b280a33643b696$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $96b280a33643b696$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $96b280a33643b696$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $96b280a33643b696$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $96b280a33643b696$var$unwrapTrackedPromise(value) {
    if (!$96b280a33643b696$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $96b280a33643b696$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $96b280a33643b696$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $96b280a33643b696$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $96b280a33643b696$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $96b280a33643b696$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $96b280a33643b696$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $96b280a33643b696$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $96b280a33643b696$var$validMutationMethods = new Set($96b280a33643b696$var$validMutationMethodsArr);
const $96b280a33643b696$var$validRequestMethodsArr = [
    "get",
    ...$96b280a33643b696$var$validMutationMethodsArr
];
const $96b280a33643b696$var$validRequestMethods = new Set($96b280a33643b696$var$validRequestMethodsArr);
const $96b280a33643b696$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $96b280a33643b696$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $96b280a33643b696$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $96b280a33643b696$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $96b280a33643b696$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $96b280a33643b696$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $96b280a33643b696$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $96b280a33643b696$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $96b280a33643b696$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $96b280a33643b696$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $96b280a33643b696$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$96b280a33643b696$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($96b280a33643b696$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $96b280a33643b696$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $96b280a33643b696$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $96b280a33643b696$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($96b280a33643b696$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $96b280a33643b696$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $96b280a33643b696$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $96b280a33643b696$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $96b280a33643b696$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $96b280a33643b696$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$96b280a33643b696$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $96b280a33643b696$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $96b280a33643b696$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $96b280a33643b696$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $96b280a33643b696$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $96b280a33643b696$var$ResultType.error,
            error: $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($96b280a33643b696$var$isDeferredResult(result)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $96b280a33643b696$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $96b280a33643b696$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $96b280a33643b696$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($96b280a33643b696$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $96b280a33643b696$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $96b280a33643b696$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $96b280a33643b696$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $96b280a33643b696$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($96b280a33643b696$var$isRedirectResult(actionResult) || $96b280a33643b696$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($96b280a33643b696$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($96b280a33643b696$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($96b280a33643b696$var$isDeferredResult(actionResult)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $96b280a33643b696$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $96b280a33643b696$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $96b280a33643b696$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $96b280a33643b696$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $96b280a33643b696$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $96b280a33643b696$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $96b280a33643b696$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $96b280a33643b696$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($96b280a33643b696$var$isDeferredResult(result)) result = await $96b280a33643b696$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($96b280a33643b696$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($96b280a33643b696$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $96b280a33643b696$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $96b280a33643b696$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $96b280a33643b696$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $96b280a33643b696$export$e19cd5f9376f8cee.Replace : $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $96b280a33643b696$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($96b280a33643b696$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $96b280a33643b696$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $96b280a33643b696$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $96b280a33643b696$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $96b280a33643b696$var$callLoaderOrAction("loader", $96b280a33643b696$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $96b280a33643b696$var$ResultType.error,
                        error: $96b280a33643b696$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $96b280a33643b696$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $96b280a33643b696$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $96b280a33643b696$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $96b280a33643b696$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $96b280a33643b696$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $96b280a33643b696$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$96b280a33643b696$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $96b280a33643b696$export$4d0306f8f6a4585b = Symbol("deferred");
function $96b280a33643b696$export$3336b097a6fbc59a(routes, opts) {
    $96b280a33643b696$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $96b280a33643b696$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD") {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $96b280a33643b696$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
        let matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $96b280a33643b696$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $96b280a33643b696$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $96b280a33643b696$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($96b280a33643b696$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$96b280a33643b696$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $96b280a33643b696$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($96b280a33643b696$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $96b280a33643b696$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $96b280a33643b696$var$isResponse(result) ? result : $96b280a33643b696$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($96b280a33643b696$var$isQueryRouteResponse(e)) {
                if (e.type === $96b280a33643b696$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($96b280a33643b696$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $96b280a33643b696$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        } else {
            result = await $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($96b280a33643b696$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($96b280a33643b696$var$isDeferredResult(result)) {
            let error = $96b280a33643b696$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $96b280a33643b696$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($96b280a33643b696$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $96b280a33643b696$var$_extends({}, context, {
                statusCode: $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $96b280a33643b696$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $96b280a33643b696$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $96b280a33643b696$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $96b280a33643b696$export$fec11da027c70692(routes, context, error) {
    let newContext = $96b280a33643b696$var$_extends({}, context, {
        statusCode: $96b280a33643b696$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $96b280a33643b696$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $96b280a33643b696$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $96b280a33643b696$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $96b280a33643b696$export$cae722b0cc860f13(to ? to : ".", $96b280a33643b696$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $96b280a33643b696$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$96b280a33643b696$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $96b280a33643b696$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $96b280a33643b696$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $96b280a33643b696$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$96b280a33643b696$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$96b280a33643b696$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $96b280a33643b696$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $96b280a33643b696$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $96b280a33643b696$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $96b280a33643b696$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($96b280a33643b696$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $96b280a33643b696$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $96b280a33643b696$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $96b280a33643b696$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $96b280a33643b696$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($96b280a33643b696$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $96b280a33643b696$var$shouldRevalidateLoader(match, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $96b280a33643b696$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $96b280a33643b696$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $96b280a33643b696$var$shouldRevalidateLoader(fetcherMatch, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $96b280a33643b696$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $96b280a33643b696$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $96b280a33643b696$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $96b280a33643b696$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $96b280a33643b696$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $96b280a33643b696$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$96b280a33643b696$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $96b280a33643b696$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $96b280a33643b696$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $96b280a33643b696$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $96b280a33643b696$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $96b280a33643b696$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $96b280a33643b696$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($96b280a33643b696$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($96b280a33643b696$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $96b280a33643b696$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) location = $96b280a33643b696$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $96b280a33643b696$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $96b280a33643b696$var$ResultType.error ? $96b280a33643b696$var$ResultType.error : $96b280a33643b696$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $96b280a33643b696$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $96b280a33643b696$var$ResultType.error) return {
            type: resultType,
            error: new $96b280a33643b696$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $96b280a33643b696$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($96b280a33643b696$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $96b280a33643b696$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $96b280a33643b696$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($96b280a33643b696$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $96b280a33643b696$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $96b280a33643b696$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $96b280a33643b696$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($96b280a33643b696$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $96b280a33643b696$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($96b280a33643b696$var$isErrorResult(result)) {
            let boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $96b280a33643b696$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($96b280a33643b696$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($96b280a33643b696$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $96b280a33643b696$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $96b280a33643b696$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $96b280a33643b696$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $96b280a33643b696$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $96b280a33643b696$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $96b280a33643b696$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $96b280a33643b696$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $96b280a33643b696$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($96b280a33643b696$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $96b280a33643b696$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(path) : path;
    return $96b280a33643b696$export$fe53371bee54353d($96b280a33643b696$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $96b280a33643b696$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $96b280a33643b696$var$isDeferredResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.deferred;
}
function $96b280a33643b696$var$isErrorResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.error;
}
function $96b280a33643b696$var$isRedirectResult(result) {
    return (result && result.type) === $96b280a33643b696$var$ResultType.redirect;
}
function $96b280a33643b696$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $96b280a33643b696$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $96b280a33643b696$var$isRedirectResponse(result) {
    if (!$96b280a33643b696$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $96b280a33643b696$var$isQueryRouteResponse(obj) {
    return obj && $96b280a33643b696$var$isResponse(obj.response) && (obj.type === $96b280a33643b696$var$ResultType.data || obj.type === $96b280a33643b696$var$ResultType.error);
}
function $96b280a33643b696$var$isValidMethod(method) {
    return $96b280a33643b696$var$validRequestMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$isMutationMethod(method) {
    return $96b280a33643b696$var$validMutationMethods.has(method.toLowerCase());
}
async function $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$96b280a33643b696$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($96b280a33643b696$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $96b280a33643b696$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $96b280a33643b696$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $96b280a33643b696$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $96b280a33643b696$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $96b280a33643b696$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $96b280a33643b696$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $96b280a33643b696$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $96b280a33643b696$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $96b280a33643b696$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $96b280a33643b696$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $96b280a33643b696$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $96b280a33643b696$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $96b280a33643b696$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $96b280a33643b696$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $96b280a33643b696$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $96b280a33643b696$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $96b280a33643b696$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($96b280a33643b696$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $96b280a33643b696$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $4a3e215446c0ed92$var$_extends() {
    $4a3e215446c0ed92$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a3e215446c0ed92$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $4a3e215446c0ed92$export$3add0d5dce533e2e = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$145dfa71566a64dc = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$var$AwaitContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $4a3e215446c0ed92$export$26749e8557646306 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$c7914228fb69b0f5 = /*#__PURE__*/ $6cds3.createContext(null);
const $4a3e215446c0ed92$export$9072aa6dd1f93057 = /*#__PURE__*/ $6cds3.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $4a3e215446c0ed92$var$RouteErrorContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $4a3e215446c0ed92$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $4a3e215446c0ed92$export$9c954a9d03d32f4a() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $4a3e215446c0ed92$export$45d76561a5302f2b() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $4a3e215446c0ed92$export$1b3f31771c5d07c() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $4a3e215446c0ed92$export$6c330e8992e8a295(pattern) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $4a3e215446c0ed92$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6cds3.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $4a3e215446c0ed92$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4a3e215446c0ed92$var$useNavigateStable() : $4a3e215446c0ed92$var$useNavigateUnstable();
}
function $4a3e215446c0ed92$var$useNavigateUnstable() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$OutletContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $4a3e215446c0ed92$export$4138103a3ae699cc() {
    return $6cds3.useContext($4a3e215446c0ed92$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $4a3e215446c0ed92$export$a3be3530d8e40d0b(context) {
    let outlet = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $4a3e215446c0ed92$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $6cds3.useMemo(()=>(0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $4a3e215446c0ed92$export$5d3fca4a98652595(routes, locationArg) {
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: parentMatches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $96b280a33643b696$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $4a3e215446c0ed92$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4a3e215446c0ed92$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4a3e215446c0ed92$var$DefaultErrorComponent() {
    let error = $4a3e215446c0ed92$export$ed527bf60f6e05f2();
    let message = (0, $96b280a33643b696$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6cds3.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6cds3.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $4a3e215446c0ed92$var$defaultErrorElement = /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DefaultErrorComponent, null);
class $4a3e215446c0ed92$var$RenderErrorBoundary extends $6cds3.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $4a3e215446c0ed92$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4a3e215446c0ed92$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $4a3e215446c0ed92$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4a3e215446c0ed92$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6cds3.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4a3e215446c0ed92$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($4a3e215446c0ed92$var$DataRouterHook || {});
var $4a3e215446c0ed92$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($4a3e215446c0ed92$var$DataRouterStateHook || {});
function $4a3e215446c0ed92$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4a3e215446c0ed92$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4a3e215446c0ed92$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext($4a3e215446c0ed92$export$145dfa71566a64dc);
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
function $4a3e215446c0ed92$var$useRouteContext(hookName) {
    let route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4a3e215446c0ed92$var$useCurrentRouteId(hookName) {
    let route = $4a3e215446c0ed92$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4a3e215446c0ed92$export$5fc8298006ad9e58() {
    return $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4a3e215446c0ed92$export$d0fd4b7106de2769() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4a3e215446c0ed92$export$600dc272ed516c15() {
    let dataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseRevalidator);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRevalidator);
    return $6cds3.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4a3e215446c0ed92$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseMatches);
    return $6cds3.useMemo(()=>matches.map((m)=>(0, $96b280a33643b696$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4a3e215446c0ed92$export$1448a5050d252c4d() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4a3e215446c0ed92$export$fd5d37484eab868d(routeId) {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4a3e215446c0ed92$export$fdc00f3f26066d5e() {
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseActionData);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4a3e215446c0ed92$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6cds3.useContext($4a3e215446c0ed92$var$RouteErrorContext);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    let routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$78a72ddb39bdd145() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $4a3e215446c0ed92$export$17f53340677d5831() {
    let value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $4a3e215446c0ed92$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4a3e215446c0ed92$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseBlocker);
    let state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6cds3.useState("");
    let blockerFunction = $6cds3.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $4a3e215446c0ed92$var$_extends({}, currentLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4a3e215446c0ed92$var$_extends({}, nextLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6cds3.useEffect(()=>{
        let key = String(++$4a3e215446c0ed92$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6cds3.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $96b280a33643b696$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4a3e215446c0ed92$var$useNavigateStable() {
    let { router: router } = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseNavigateStable);
    let id = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4a3e215446c0ed92$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $4a3e215446c0ed92$var$alreadyWarned = {};
function $4a3e215446c0ed92$var$warningOnce(key, cond, message) {
    if (!cond && !$4a3e215446c0ed92$var$alreadyWarned[key]) $4a3e215446c0ed92$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $4a3e215446c0ed92$var$START_TRANSITION = "startTransition";
const $4a3e215446c0ed92$var$startTransitionImpl = $6cds3[$4a3e215446c0ed92$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4a3e215446c0ed92$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        if (v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl) $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $4a3e215446c0ed92$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $4a3e215446c0ed92$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $4a3e215446c0ed92$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306);
    let { matches: matches } = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4a3e215446c0ed92$export$45d76561a5302f2b();
    let navigate = $4a3e215446c0ed92$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, (0, $96b280a33643b696$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6cds3.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $4a3e215446c0ed92$export$910ae8079b2c2852(props) {
    return $4a3e215446c0ed92$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $4a3e215446c0ed92$export$e7b0ac011bb776c6(_props) {
    (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $4a3e215446c0ed92$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6cds3.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $4a3e215446c0ed92$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6cds3.useMemo(()=>{
        let trailingPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $4a3e215446c0ed92$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $4a3e215446c0ed92$export$5d3fca4a98652595($4a3e215446c0ed92$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4a3e215446c0ed92$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$ResolveAwait, null, children));
}
var $4a3e215446c0ed92$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($4a3e215446c0ed92$var$AwaitRenderStatus || {});
const $4a3e215446c0ed92$var$neverSettledPromise = new Promise(()=>{});
class $4a3e215446c0ed92$var$AwaitErrorBoundary extends $6cds3.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.error : promise._data !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.success : $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && promise._error instanceof (0, $96b280a33643b696$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $4a3e215446c0ed92$var$neverSettledPromise;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $4a3e215446c0ed92$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $4a3e215446c0ed92$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $4a3e215446c0ed92$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6cds3.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6cds3.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6cds3.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4a3e215446c0ed92$export$e7b0ac011bb776c6) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4a3e215446c0ed92$export$daf73786167a7f72(matches) {
    return $4a3e215446c0ed92$var$_renderMatches(matches);
}
function $4a3e215446c0ed92$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6cds3.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $6cds3.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6cds3.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4a3e215446c0ed92$export$f30f7e456d254e83(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a3e215446c0ed92$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4a3e215446c0ed92$export$52b333d321859367
    }).initialize();
}

/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6cds3 = parcelRequire("6cds3");



function $0e36e707c39d0f3a$var$_extends() {
    $0e36e707c39d0f3a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e36e707c39d0f3a$var$_extends.apply(this, arguments);
}
function $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0e36e707c39d0f3a$var$defaultMethod = "get";
const $0e36e707c39d0f3a$var$defaultEncType = "application/x-www-form-urlencoded";
function $0e36e707c39d0f3a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0e36e707c39d0f3a$var$isButtonElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0e36e707c39d0f3a$var$isFormElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0e36e707c39d0f3a$var$isInputElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0e36e707c39d0f3a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0e36e707c39d0f3a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0e36e707c39d0f3a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = null;
function $0e36e707c39d0f3a$var$isFormDataSubmitterSupported() {
    if ($0e36e707c39d0f3a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = true;
    }
    return $0e36e707c39d0f3a$var$_formDataSupportsSubmitter;
}
const $0e36e707c39d0f3a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0e36e707c39d0f3a$var$getFormEncType(encType) {
    if (encType != null && !$0e36e707c39d0f3a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0e36e707c39d0f3a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0e36e707c39d0f3a$var$isButtonElement(target) || $0e36e707c39d0f3a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("formenctype")) || $0e36e707c39d0f3a$var$getFormEncType(form.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0e36e707c39d0f3a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0e36e707c39d0f3a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0e36e707c39d0f3a$var$defaultMethod;
        action = null;
        encType = $0e36e707c39d0f3a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0e36e707c39d0f3a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $0e36e707c39d0f3a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $0e36e707c39d0f3a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0e36e707c39d0f3a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0e36e707c39d0f3a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0e36e707c39d0f3a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0e36e707c39d0f3a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0e36e707c39d0f3a$var$_extends({}, state, {
        errors: $0e36e707c39d0f3a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0e36e707c39d0f3a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $96b280a33643b696$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0e36e707c39d0f3a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6cds3.createContext({
    isTransitioning: false
});
const $0e36e707c39d0f3a$export$148fd98d095596d4 = /*#__PURE__*/ $6cds3.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0e36e707c39d0f3a$var$START_TRANSITION = "startTransition";
const $0e36e707c39d0f3a$var$startTransitionImpl = $6cds3[$0e36e707c39d0f3a$var$START_TRANSITION];
const $0e36e707c39d0f3a$var$FLUSH_SYNC = "flushSync";
const $0e36e707c39d0f3a$var$flushSyncImpl = $6d4849ee44552f5f$exports[$0e36e707c39d0f3a$var$FLUSH_SYNC];
const $0e36e707c39d0f3a$var$USE_ID = "useId";
const $0e36e707c39d0f3a$var$useIdImpl = $6cds3[$0e36e707c39d0f3a$var$USE_ID];
function $0e36e707c39d0f3a$var$startTransitionSafe(cb) {
    if ($0e36e707c39d0f3a$var$startTransitionImpl) $0e36e707c39d0f3a$var$startTransitionImpl(cb);
    else cb();
}
function $0e36e707c39d0f3a$var$flushSyncSafe(cb) {
    if ($0e36e707c39d0f3a$var$flushSyncImpl) $0e36e707c39d0f3a$var$flushSyncImpl(cb);
    else cb();
}
class $0e36e707c39d0f3a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0e36e707c39d0f3a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6cds3.useState(router.state);
    let [pendingState, setPendingState] = $6cds3.useState();
    let [vtContext, setVtContext] = $6cds3.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6cds3.useState();
    let [transition, setTransition] = $6cds3.useState();
    let [interruption, setInterruption] = $6cds3.useState();
    let fetcherData = $6cds3.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6cds3.useCallback((cb)=>{
        if (v7_startTransition) $0e36e707c39d0f3a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6cds3.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0e36e707c39d0f3a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0e36e707c39d0f3a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6cds3.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6cds3.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0e36e707c39d0f3a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6cds3.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6cds3.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $6cds3.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6cds3.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6cds3.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $0e36e707c39d0f3a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4a3e215446c0ed92$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0e36e707c39d0f3a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0e36e707c39d0f3a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6cds3.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6cds3.useCallback((newState)=>{
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0e36e707c39d0f3a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0e36e707c39d0f3a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6cds3.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref7, $0e36e707c39d0f3a$var$_excluded);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0e36e707c39d0f3a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $96b280a33643b696$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4a3e215446c0ed92$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0e36e707c39d0f3a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6cds3.createElement("a", $0e36e707c39d0f3a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0e36e707c39d0f3a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6cds3.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref8, $0e36e707c39d0f3a$var$_excluded2);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let routerState = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0e36e707c39d0f3a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a6c7ac8248d6e38a, $0e36e707c39d0f3a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0e36e707c39d0f3a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6cds3.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0e36e707c39d0f3a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref9, $0e36e707c39d0f3a$var$_excluded3);
    let submit = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let formAction = $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $6cds3.createElement("form", $0e36e707c39d0f3a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0e36e707c39d0f3a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0e36e707c39d0f3a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0e36e707c39d0f3a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0e36e707c39d0f3a$var$DataRouterHook || ($0e36e707c39d0f3a$var$DataRouterHook = {}));
var $0e36e707c39d0f3a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0e36e707c39d0f3a$var$DataRouterStateHook || ($0e36e707c39d0f3a$var$DataRouterStateHook = {}));
// Internal hooks
function $0e36e707c39d0f3a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0e36e707c39d0f3a$var$useDataRouterContext(hookName) {
    let ctx = $6cds3.useContext((0, $4a3e215446c0ed92$export$3add0d5dce533e2e));
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0e36e707c39d0f3a$var$useDataRouterState(hookName) {
    let state = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0e36e707c39d0f3a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6cds3.useCallback((event)=>{
        if ($0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $96b280a33643b696$export$fe53371bee54353d)(location) === (0, $96b280a33643b696$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0e36e707c39d0f3a$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6cds3.useRef($0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6cds3.useRef(false);
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let searchParams = $6cds3.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0e36e707c39d0f3a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    let setSearchParams = $6cds3.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0e36e707c39d0f3a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0e36e707c39d0f3a$var$fetcherId = 0;
let $0e36e707c39d0f3a$var$getUniqueFetcherId = ()=>"__" + String(++$0e36e707c39d0f3a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0e36e707c39d0f3a$export$47c85c6e3a081d3() {
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let currentRouteId = (0, $4a3e215446c0ed92$export$5fc8298006ad9e58)();
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0e36e707c39d0f3a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let routeContext = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !routeContext && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0e36e707c39d0f3a$var$_extends({}, (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $96b280a33643b696$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0e36e707c39d0f3a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseFetcher);
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $6cds3.useContext($0e36e707c39d0f3a$export$148fd98d095596d4);
    let route = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0e36e707c39d0f3a$var$useIdImpl ? $0e36e707c39d0f3a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $6cds3.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0e36e707c39d0f3a$var$getUniqueFetcherId());
    // Registration/cleanup
    $6cds3.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $6cds3.useCallback((href, opts)=>{
        !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    let submit = $6cds3.useCallback((target, opts)=>{
        submitImpl(target, $0e36e707c39d0f3a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $6cds3.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $6cds3.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a7fed597f4b8afd8, $0e36e707c39d0f3a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $96b280a33643b696$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $6cds3.useMemo(()=>$0e36e707c39d0f3a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0e36e707c39d0f3a$export$fa996778a3a31087() {
    let state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0e36e707c39d0f3a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0e36e707c39d0f3a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0e36e707c39d0f3a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306));
    let location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    let matches = (0, $4a3e215446c0ed92$export$2378eb7f5ff86053)();
    let navigation = (0, $4a3e215446c0ed92$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6cds3.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0e36e707c39d0f3a$var$usePageHide($6cds3.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0e36e707c39d0f3a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0e36e707c39d0f3a$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0e36e707c39d0f3a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0e36e707c39d0f3a$var$_extends({}, location, {
                    pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0e36e707c39d0f3a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6cds3.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0e36e707c39d0f3a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4a3e215446c0ed92$export$b273b3273281a049)(when);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6cds3.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0e36e707c39d0f3a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6cds3.useContext($0e36e707c39d0f3a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $96b280a33643b696$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $96b280a33643b696$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


$47b105bf0f2247b7$export$2cd8252107eb640b({
    dsn: "https://24335c3205ab3ebc86dc4074bd1e6993@o355390.ingest.us.sentry.io/4506710676733952",
    integrations: [
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        $56f2f765e8af6e24$export$47113a480541ff59({
            useEffect: (0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).useEffect,
            useLocation: $4a3e215446c0ed92$export$45d76561a5302f2b,
            useNavigationType: $4a3e215446c0ed92$export$1b3f31771c5d07c,
            createRoutesFromChildren: $4a3e215446c0ed92$export$16da398f5434bdec,
            matchRoutes: $96b280a33643b696$export$2708184779ceb39d
        }),
        $1e78293c4d0a3fa1$export$d7706faf7ab354bf()
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,
    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/onfarma\.it/,
        /^https:\/\/www\.onfarma\.it/,
        /^https:\/\/onfarma\.it\//,
        /^https:\/\/www\.onfarma\.it\//
    ],
    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
});
function $a198c5b7f78064c1$var$App({ dataset: dataset }) {
    const [formId, setFormId] = (0, $6cds3.useState)();
    const [formName, setFormName] = (0, $6cds3.useState)();
    const [form, setForm] = (0, $6cds3.useState)(null);
    const [formError, setFormError] = (0, $6cds3.useState)(null);
    const [fields, setFields] = (0, $6cds3.useState)(null);
    const [customerId, setCustomerId] = (0, $6cds3.useState)();
    const [defaultValues, setDefaultValues] = (0, $6cds3.useState)(null);
    const [existingOnStrapi, setExistingOnStrapi] = (0, $6cds3.useState)(null);
    const [formData, setFormData] = (0, $6cds3.useState)(null);
    const [dispatcherName, setDispatcherName] = (0, $6cds3.useState)(null);
    const [shopifyAuthData, setShopifyAuthData] = (0, $6cds3.useState)(null);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const { register: register, formState: { errors: errors }, handleSubmit: handleSubmit, reset: reset, watch: watch } = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)({
        defaultValues: defaultValues
    });
    (0, $6cds3.useEffect)(()=>{
        const subscription = watch((value, { name: name, type: type })=>setFormData(value));
        return ()=>subscription.unsubscribe();
    }, [
        watch
    ]);
    (0, $6cds3.useEffect)(()=>{
    // setCustomerId(window.__st?.cid);
    }, []);
    (0, $6cds3.useEffect)(()=>{
        console.log("WIDGET CARICATO");
    }, []);
    const generate8CharPassword = ()=>{
        const length = 8;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let retVal = "";
        for(let i = 0, n = charset.length; i < length; ++i)retVal += charset.charAt(Math.floor(Math.random() * n));
        return retVal;
    };
    const shopifyAuthenticate = async ()=>{
        const data = {
            ...shopifyAuthData
        };
        const res = await fetch("/account/login", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                customer: {
                    email: data.email,
                    password: generate8CharPassword()
                },
                form_type: "customer_login",
                utf8: "\u2713"
            })
        }).catch((error)=>{
            $dbaa48b6af64d774$export$f5282963edea4a68(error);
        });
        if (res.status === 200) window.location.href = "https://www.onfarma.it/account/addresses?l=true";
        if (res.status === 422) setFormError(true);
        if (res.status === 404) setFormError(true);
        if (res.status === 500) setFormError(true);
        if (res.status === 401) setFormError(true);
    };
    const onSubmit = async (_data)=>{
        setIsLoading(true);
        const data = {
            ..._data,
            "customer#metafields#customer_fields#tipo_di_cliente": formName
        };
        Object.keys(data).forEach((key)=>{
            const value = data[key];
            if (key.includes("#")) {
                const newKey = key.replace(/#/g, ".");
                data[newKey] = value;
                delete data[key];
            }
        });
        const payload = {
            form: formId,
            payload: {
                ...data,
                password: generate8CharPassword()
            }
        };
        if (existingOnStrapi) (0, $84a973f6a13a2051$export$327f7b26ebf455db)({
            path: `applications/${existingOnStrapi}`,
            data: {
                data: {
                    ...payload
                }
            }
        }).then((response)=>{
            window.location.href = window.__st?.cid ? document.referrer : "https://www.onfarma.it/account";
        }).catch((error)=>{
            console.error("error", error);
            setFormError(true);
            $dbaa48b6af64d774$export$f5282963edea4a68(error);
        });
        else // se non esiste su strapi però dovrei capire se esiste su shopify
        if (customerId) {
            const _application = await (0, $84a973f6a13a2051$export$299ba2dee77727e9)({
                path: `applications`,
                data: {
                    data: {
                        ...payload
                    }
                }
            }).catch((error)=>{
                console.error("error", error);
                $dbaa48b6af64d774$export$f5282963edea4a68(error);
            });
            const _id = _application?.data?.data?.id;
            if (_id) (0, $84a973f6a13a2051$export$327f7b26ebf455db)({
                path: `applications/${_id}`,
                data: {
                    data: {
                        ...payload
                    }
                }
            }).then((response)=>{
                window.location.href = "https://www.onfarma.it/account";
            }).catch((error)=>{
                console.error("error", error);
                setFormError(true);
                $dbaa48b6af64d774$export$f5282963edea4a68(error);
            });
        } else // è una nuova registrazione
        (0, $84a973f6a13a2051$export$299ba2dee77727e9)({
            path: `applications`,
            data: {
                data: {
                    ...payload,
                    createOnShopify: true
                }
            }
        }).then((response)=>{
            window.scrollTo(0, 0);
            setShopifyAuthData(data);
        }).catch((error)=>{
            console.error("error", error);
            setFormError(true);
            $dbaa48b6af64d774$export$f5282963edea4a68(error);
        });
    };
    const retrieveForm = async ()=>{
        const { data: data } = await (0, $84a973f6a13a2051$export$3988ae62b71be9a3)({
            path: `forms/${formId}?populate=deep`
        }).catch((error)=>{
            $dbaa48b6af64d774$export$f5282963edea4a68(error);
        });
        setForm(data.data);
    };
    const populateFields = ()=>{
        const { attributes: attributes } = form;
        const { areas: areas } = attributes;
        const fieldItems = [];
        areas.data.forEach((element)=>{
            const blocks = element.attributes.blocks;
            blocks.map((block)=>{
                block.fields.map((field)=>{
                    if (customerId) {
                        if (!field.slug.includes("password")) {
                            if (field.type !== "checkbox") fieldItems.push({
                                [field.slug]: field
                            });
                        }
                    } else fieldItems.push({
                        [field.slug]: field
                    });
                });
            });
        });
        setFields(fieldItems);
    };
    (0, $6cds3.useEffect)(()=>{
        if (form) populateFields();
    }, [
        form,
        defaultValues
    ]);
    (0, $6cds3.useEffect)(()=>{
        formId && retrieveForm();
    }, [
        formId
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (shopifyAuthData) window.location.href = "/account/login";
    }, [
        shopifyAuthData
    ]);
    const cleanPhone = (phone)=>{
        try {
            return phone.replace(/\D/g, "").slice(-10);
        } catch (err) {
            return phone;
        }
    };
    const retrieveFieldsFromShopify = async ()=>{
        const { data: data } = await (0, $84a973f6a13a2051$export$3988ae62b71be9a3)({
            path: `applications/shopify/${customerId}`
        }).catch((error)=>{
            $dbaa48b6af64d774$export$f5282963edea4a68(error);
        });
        const { metafields: metafields, customer: customer } = data;
        let _fields = {
            first_name: customer.first_name,
            last_name: customer.last_name,
            email: customer.email,
            phone: cleanPhone(customer.phone)
        };
        metafields.forEach((metafield)=>{
            const { key: key, value: value, owner_resource: owner_resource, namespace: namespace } = metafield;
            let slug = owner_resource + ".metafields." + namespace + "." + key;
            _fields[slug.replace(/\./g, "#")] = value;
        });
        setDispatcherName(_fields["customer#metafields#customer_fields#tipo_di_cliente"]);
        setDefaultValues(_fields);
    };
    const retrieveFields = async ()=>{
        console.log("retrieveFields");
        const { data: data } = await (0, $84a973f6a13a2051$export$3988ae62b71be9a3)({
            path: `applications?filters[customerId][$eq]=${customerId}&populate=deep`
        }).catch((error)=>{
            $dbaa48b6af64d774$export$f5282963edea4a68(error);
        });
        const info = data.data;
        if (info.length > 0) {
            setExistingOnStrapi(info[0]["id"]);
            const { payload: payload } = info[0]["attributes"];
            const _o = {};
            Object.keys(payload).forEach((key)=>{
                const value = payload[key];
                if (key.includes(".")) {
                    const newKey = key.replace(/\./g, "#");
                    _o[newKey] = value;
                    delete _o[key];
                } else _o[key] = value;
            });
            setDispatcherName(_o["customer#metafields#customer_fields#tipo_di_cliente"]);
            if (!_o["customer#metafields#customer_fields#tipo_di_cliente"]) retrieveFieldsFromShopify();
            setDefaultValues(_o);
        } else {
            setExistingOnStrapi(null);
            if (customerId) retrieveFieldsFromShopify();
        }
    };
    (0, $6cds3.useEffect)(()=>{
        if (customerId) {
            console.log("caso 1");
            retrieveFields();
        } else setDefaultValues({});
    }, [
        customerId
    ]);
    const cleanFormKey = (key)=>{
        // remove ALL instances of . with a #
        return key.replace(/\./g, "#");
    };
    (0, $6cds3.useEffect)(()=>{
        if (defaultValues) reset(defaultValues);
    }, [
        defaultValues
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (formError) setIsLoading(false);
    }, [
        formError
    ]);
    // if (shopifyAuthData) {
    //   return (
    //     <>
    //       <div className="cf-react-target">
    //         <div className="cf-form-inner">
    //           <div
    //             style={{
    //               marginTop: "-20px !important",
    //               marginBottom: "20px !important",
    //             }}
    //             className="avviso-reg"
    //             data-cf-field-id="235163"
    //             data-cf-field-type="paragraph"
    //             data-cf-column-width="12"
    //             data-cf-grow="true"
    //             data-cf-field-actions="show_field"
    //             key={"message-ok"}
    //           >
    //             <div
    //               className="cf-field avviso-reg"
    //               data-cf-field-id="235163"
    //               data-cf-field-type="paragraph"
    //               data-cf-grow="true"
    //               style={{
    //                 padding: "20px !important",
    //                 margin: "0px !important",
    //               }}
    //             >
    //               <div
    //                 style={{
    //                   fontSize: "14px",
    //                 }}
    //               >
    //                 <p
    //                   style={{
    //                     textAlign: "center",
    //                     padding: "20px"
    //                   }}
    //                 >
    //                   Grazie per esserti registrato su <b>ONFARMA.it</b>, clicca sul link che segue per accedere alla tua area riservata
    //                   <button
    //                     onClick={() => shopifyAuthenticate()}
    //                     style={{
    //                       textDecoration: "underline",
    //                     }}
    //                   >
    //                     Accedi su <b>ONFARMA.it</b>
    //                   </button>
    //                 </p>
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </>
    //   );
    // }
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "cf-react-target",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "cf-form-inner",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d8918e33b5816ce2$export$2e2bcd8739ae039), {
                    formId: formId,
                    dataset: dataset,
                    setFormId: setFormId,
                    setFormName: setFormName,
                    dispatcherName: dispatcherName,
                    customerId: customerId
                }),
                form?.attributes?.customText && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        style: {
                            marginTop: "-20px !important",
                            marginBottom: "20px !important"
                        },
                        className: "avviso-reg",
                        "data-cf-field-id": "235163",
                        "data-cf-field-type": "paragraph",
                        "data-cf-column-width": "12",
                        "data-cf-grow": "true",
                        "data-cf-field-actions": "show_field",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: "cf-field avviso-reg",
                            "data-cf-field-id": "235163",
                            "data-cf-field-type": "paragraph",
                            "data-cf-grow": "true",
                            style: {
                                padding: "20px !important",
                                margin: "0px !important"
                            },
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                style: {
                                    fontSize: "14px"
                                },
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: form?.attributes?.customText
                                    }
                                })
                            })
                        })
                    }, "message-" + form?.id)
                }),
                formId && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "cf-form-step",
                    children: fields && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
                                style: {
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start"
                                },
                                onSubmit: handleSubmit(onSubmit),
                                children: [
                                    fields.map((field, index)=>{
                                        const key = cleanFormKey(Object.keys(field)[0]);
                                        const value = field[Object.keys(field)[0]];
                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                            className: "cf-field-container",
                                            "data-field-type": value.type,
                                            "data-field-name": key,
                                            "data-cf-column-width": "12",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                className: "cf-field",
                                                "data-cf-invalid": errors[key] ? "true" : "false",
                                                style: {
                                                    display: "flex",
                                                    marginBottom: "20px",
                                                    flexDirection: value.type === "checkbox" ? "row-reverse" : "column",
                                                    alignItems: value.type === "checkbox" ? "baseline" : "flex-start",
                                                    justifyContent: "flex-end"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("label", {
                                                        htmlFor: key,
                                                        style: {
                                                            textAlign: "left"
                                                        },
                                                        children: [
                                                            value.label.toUpperCase(),
                                                            " ",
                                                            value.required && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                children: "*"
                                                            }),
                                                            value.defaultValue && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                                children: value.type === "checkbox" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                                                    children: value.defaultValue
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                        style: {
                                                            width: value.type !== "checkbox" ? "100%" : "auto",
                                                            marginRight: value.type === "checkbox" ? "10px" : 0,
                                                            marginBottom: "10px"
                                                        },
                                                        ...register(key, {
                                                            validate: (v)=>{
                                                                if (value.required) {
                                                                    let isValid = v;
                                                                    try {
                                                                        const _dependentFields = value.dependentFields ? value.dependentFields.split(",") : null;
                                                                        if (_dependentFields) {
                                                                            if (_dependentFields.length > 0) {
                                                                                let otherFieldsAreValid = true;
                                                                                _dependentFields.forEach((df)=>{
                                                                                    const _key = cleanFormKey(df);
                                                                                    const _value = formData[_key];
                                                                                    otherFieldsAreValid = _value;
                                                                                    return !!_value;
                                                                                });
                                                                                if (otherFieldsAreValid) isValid = true;
                                                                                else isValid = value.required ? !!v : true;
                                                                            }
                                                                        } else {
                                                                            const checkIfThisFieldIsEmpty = ()=>{
                                                                                return !!v;
                                                                            };
                                                                            isValid = value.required ? checkIfThisFieldIsEmpty() : false;
                                                                        }
                                                                    } catch (err) {
                                                                        console.log(err);
                                                                    }
                                                                    return isValid;
                                                                } else return true;
                                                            },
                                                            minLength: value.minLength,
                                                            maxLength: value.maxLength,
                                                            min: value.min,
                                                            max: value.max
                                                        }),
                                                        id: key,
                                                        autoComplete: "new-password",
                                                        "data-cf-input": true,
                                                        "data-cf-invalid": errors[key] ? "true" : "false",
                                                        name: key,
                                                        type: value.type
                                                    }),
                                                    value.defaultValue && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                                        children: value.type !== "checkbox" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("small", {
                                                            children: value.defaultValue
                                                        })
                                                    }),
                                                    errors[key] && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        style: {
                                                            color: "red"
                                                        },
                                                        children: "Questo campo non pu\xf2 essere lasciato vuoto"
                                                    })
                                                ]
                                            })
                                        }, key);
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                        type: "submit",
                                        disabled: isLoading,
                                        style: {
                                            width: "100%"
                                        }
                                    })
                                ]
                            }),
                            formError && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "cf-form-error",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "cf-form-error-message",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        children: "Si \xe8 verificato un errore, riprova pi\xf9 tardi. Potrebbe gi\xe0 esistere un account con questa email o con questo numero di telefono."
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $a198c5b7f78064c1$export$2e2bcd8739ae039 = $a198c5b7f78064c1$var$App;



const $ea833559f5a67bb4$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("eDGma")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $ea833559f5a67bb4$export$2e2bcd8739ae039 = $ea833559f5a67bb4$var$reportWebVitals;




var $6cds3 = parcelRequire("6cds3");




function $b95e078fbc506e36$var$Addresses({ dataset: dataset }) {
    const [customerId, setCustomerId] = (0, $6cds3.useState)();
    const [defaultValues, setDefaultValues] = (0, $6cds3.useState)(null);
    const [customer, setCustomer] = (0, $6cds3.useState)(null);
    const [addresses, setAddresses] = (0, $6cds3.useState)(null);
    const [metafields, setMetafields] = (0, $6cds3.useState)(null);
    const [addressId, setAddressId] = (0, $6cds3.useState)(null);
    const { register: register, formState: { errors: errors }, handleSubmit: handleSubmit, reset: reset } = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)({
        defaultValues: defaultValues
    });
    const onSubmit = (_data)=>{
        const data = {
            ..._data
        };
        console.log(data);
    };
    (0, $6cds3.useEffect)(()=>{
        setCustomerId(window.__st?.cid);
    }, []);
    const retrieveCustomer = async ()=>{
        const response = await (0, $84a973f6a13a2051$export$3988ae62b71be9a3)({
            path: `applications/shopify/${customerId}`
        });
        setMetafields(response.data.metafields);
        console.log(response.data);
        setAddresses(response.data.customer.addresses);
    };
    (0, $6cds3.useEffect)(()=>{
        customerId && retrieveCustomer();
    }, [
        customerId
    ]);
    (0, $6cds3.useEffect)(()=>{
        if (metafields) {
            const billingAddress = metafields.find((metafield)=>metafield.key === "indirizzo_fatturazione_di_default");
            if (billingAddress) setAddressId(billingAddress.value);
        }
    }, [
        metafields
    ]);
    const submitBillingAddress = async (addressId)=>{
        const response = await (0, $84a973f6a13a2051$export$299ba2dee77727e9)({
            path: `applications/shopify/${customerId}/billing-address`,
            data: {
                data: {
                    addressId: addressId
                }
            }
        });
        console.log(response.data);
    };
    (0, $6cds3.useEffect)(()=>{
        if (addressId) submitBillingAddress(addressId);
    }, [
        addressId
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "cf-react-target",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "cf-form-inner",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "cf-form-step",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            className: "cf-field-container",
                            "data-field-name": "phone",
                            style: {
                                width: "100% !important"
                            },
                            "data-cf-column-width": "12",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "cf-field",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                        className: "cf-field-label",
                                        htmlFor: "billing-address",
                                        "data-cf-error": "Seleziona un indirizzo",
                                        children: "Seleziona il tuo indirizzo di fatturazione di default"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("select", {
                                        className: "cf-field-input",
                                        name: "billing-address",
                                        id: "billing-address",
                                        ...register("billing-address"),
                                        value: addressId,
                                        style: {
                                            width: "100%",
                                            marginBottom: "10px"
                                        },
                                        onChange: (e)=>{
                                            setAddressId(e.target.value);
                                        // submitBillingAddress(e.target.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("option", {
                                                value: "",
                                                children: "Seleziona un indirizzo"
                                            }),
                                            addresses && addresses.map((address)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("option", {
                                                    value: address.id,
                                                    children: [
                                                        address.address1,
                                                        ", ",
                                                        address.city,
                                                        ", ",
                                                        address.province,
                                                        " (",
                                                        " ",
                                                        address.first_name,
                                                        " ",
                                                        address.last_name,
                                                        " ",
                                                        address.company,
                                                        ")"
                                                    ]
                                                }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        style: {
                                            marginBottom: "30px"
                                        },
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                            href: "/account/addresses",
                                            class: "text-link",
                                            children: "Aggiungi un nuovo indirizzo o modificane uno, qui"
                                        })
                                    })
                                ]
                            })
                        }, "billing-address-key")
                    })
                })
            }),
            customerId && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a198c5b7f78064c1$export$2e2bcd8739ae039), {})
        ]
    });
}
var $b95e078fbc506e36$export$2e2bcd8739ae039 = $b95e078fbc506e36$var$Addresses;




var $6cds3 = parcelRequire("6cds3");



function $8c09af95f4ce7beb$var$CartCheck({ dataset: dataset }) {
    const [customerId, setCustomerId] = (0, $6cds3.useState)();
    const [defaultValues, setDefaultValues] = (0, $6cds3.useState)(null);
    const [customer, setCustomer] = (0, $6cds3.useState)(null);
    const [addresses, setAddresses] = (0, $6cds3.useState)(null);
    const [metafields, setMetafields] = (0, $6cds3.useState)(null);
    const [addressId, setAddressId] = (0, $6cds3.useState)(null);
    const { register: register, formState: { errors: errors }, handleSubmit: handleSubmit, reset: reset } = (0, $ba34d1ebd6528b77$export$87c0cf8eb5a167e0)({
        defaultValues: defaultValues
    });
    const onSubmit = (_data)=>{
        const data = {
            ..._data
        };
        console.log(data);
    };
    const retrieveCustomer = async ()=>{
        const response = await (0, $84a973f6a13a2051$export$3988ae62b71be9a3)({
            path: `applications/shopify/${customerId}`
        });
        setMetafields(response.data.metafields);
        setAddresses(response.data.customer.addresses);
    };
    (0, $6cds3.useEffect)(()=>{
        customerId && retrieveCustomer();
    }, [
        customerId
    ]);
    (0, $6cds3.useEffect)(()=>{
        setCustomerId(window.__st?.cid);
    }, []);
    (0, $6cds3.useEffect)(()=>{
        if (metafields) {
            const billingAddress = metafields.find((metafield)=>metafield.key === "indirizzo_fatturazione_di_default");
            if (billingAddress) setAddressId(billingAddress.value);
        }
    }, [
        metafields
    ]);
    const submitBillingAddress = async (addressId)=>{
        const response = await (0, $84a973f6a13a2051$export$299ba2dee77727e9)({
            path: `applications/shopify/${customerId}/billing-address`,
            data: {
                data: {
                    addressId: addressId
                }
            }
        });
        console.log(response.data);
    };
    (0, $6cds3.useEffect)(()=>{
        if (addressId) submitBillingAddress(addressId);
    }, [
        addressId
    ]);
    if (customerId && metafields && !metafields?.find((metafield)=>metafield.key === "indirizzo_fatturazione_di_default")) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            class: "widget-modal",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                class: "widget-modal__inner",
                style: {
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        src: "https://www.onfarma.it/cdn/shop/files/logo_x40@2x.png?v=1617964333",
                        alt: "Onfarma",
                        class: "widget-modal__logo",
                        style: {
                            maxWidth: "50%",
                            marginBottom: "20px"
                        }
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                        children: "Prima di continuare con il checkout abbiamo necessit\xe0 che vengano aggiornati i vostri dati di fatturazione ed impostato almeno un indirizzo di fatturazione."
                    }),
                    !addressId && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "/account/addresses",
                        className: "btn cart__checkout",
                        children: "Imposta il tuo indirizzo di fatturazione"
                    }),
                    addressId && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "/pages/modifica-account",
                        className: "btn cart__checkout",
                        children: "Modifica i tuoi dati"
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {});
}
var $8c09af95f4ce7beb$export$2e2bcd8739ae039 = $8c09af95f4ce7beb$var$CartCheck;


const $f25e85c08ff84b11$var$widgetDivs = document.querySelectorAll(".onfarma-widget");
$f25e85c08ff84b11$var$widgetDivs.forEach((widgetDiv)=>{
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(widgetDiv);
    const { template: template } = widgetDiv.dataset;
    root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
        children: template === "address" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b95e078fbc506e36$export$2e2bcd8739ae039), {
            dataset: widgetDiv.dataset
        }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
            children: template === "cart-check" ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $8c09af95f4ce7beb$export$2e2bcd8739ae039), {
                dataset: widgetDiv.dataset
            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $a198c5b7f78064c1$export$2e2bcd8739ae039), {
                dataset: widgetDiv.dataset
            })
        })
    }));
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $ea833559f5a67bb4$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=index.js.map
